
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired274"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired274"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $fb333321d638d134$exports = {};
$parcel$extendImportMap({
    "j5Mty": "eye-dropper.13bb459d.svg",
    "gvGqy": "discord.0237f33a.html",
    "YCPzX": "loading.2743d059.svg",
    "1SrrK": "demo-thumbnail.ee15827b.jpg",
    "dM0jD": "icon.3e6c1efe.svg",
    "fSHUt": "sw.js"
});

function $21104bc65c54f4d6$var$inherit(cls, className) {
    var proto = Object.create(cls.prototype);
    proto.className = className;
    return proto;
}
function $21104bc65c54f4d6$var$addElementProperty(cls, name) {
    Object.defineProperty(cls.prototype, name, {
        get: function() {
            return this.element[name];
        },
        set: function(value) {
            this.element[name] = value;
        }
    });
}
function $21104bc65c54f4d6$var$addStyleProperty(cls, name) {
    Object.defineProperty(cls.prototype, name, {
        get: function() {
            return this.element.style[name];
        },
        set: function(text) {
            this.element.style[name] = text;
        }
    });
}
function $21104bc65c54f4d6$var$Widget() {
    if (!this.element) this.element = document.createElement("div");
    if (!this.body) this.body = this.element;
    this.element.classList.add("pbfe" + (this.className ? this.className : "Widget"));
}
$21104bc65c54f4d6$var$Widget.prototype.appendChild = function(widget) {
    this.body.appendChild(widget.element);
};
$21104bc65c54f4d6$var$Widget.prototype.appendChildren = function(array) {
    for(var i = 0; i < array.length; ++i)this.appendChild(array[i]);
};
$21104bc65c54f4d6$var$Widget.prototype.removeChild = function(widget) {
    this.body.removeChild(widget.element);
};
$21104bc65c54f4d6$var$Widget.prototype.removeChildAfterTransition = function(widget, callback) {
    var body = this.body;
    this.element.addEventListener("transitionend", function listener() {
        body.removeChild(widget.element);
        if (callback) callback();
        this.removeEventListener("transitionend", listener);
    });
};
$21104bc65c54f4d6$var$Widget.prototype.addEventListener = function(type, listener) {
    this.element.addEventListener.apply(this.element, arguments);
};
$21104bc65c54f4d6$var$Widget.prototype.contains = function(widget) {
    return widget.element.parentNode == this.element;
};
$21104bc65c54f4d6$var$addStyleProperty($21104bc65c54f4d6$var$Widget, "width");
$21104bc65c54f4d6$var$addStyleProperty($21104bc65c54f4d6$var$Widget, "height");
$21104bc65c54f4d6$var$addStyleProperty($21104bc65c54f4d6$var$Widget, "order");
$21104bc65c54f4d6$var$addStyleProperty($21104bc65c54f4d6$var$Widget, "flexGrow");
$21104bc65c54f4d6$var$addStyleProperty($21104bc65c54f4d6$var$Widget, "flexShrink");
$21104bc65c54f4d6$var$addStyleProperty($21104bc65c54f4d6$var$Widget, "flexBasis");
$21104bc65c54f4d6$var$addStyleProperty($21104bc65c54f4d6$var$Widget, "alignSelf");
function $21104bc65c54f4d6$var$Container(element) {
    if (!element) {
        element = document.createElement("div");
        document.body.appendChild(element);
    }
    this.element = element;
    $21104bc65c54f4d6$var$Widget.call(this);
}
$21104bc65c54f4d6$var$Container.prototype = $21104bc65c54f4d6$var$inherit($21104bc65c54f4d6$var$Widget, "Container");
$21104bc65c54f4d6$var$Container.prototype.createShadow = function() {
    if (document.getElementById("pbfeShadow")) return;
    var div = document.createElement("div");
    div.style.cssText = "position:fixed;top:0;left:0;width:100%;height:100%;z-index:100;";
    div.id = "pbfeShadow";
    this.element.appendChild(div);
};
$21104bc65c54f4d6$var$Container.prototype.showToast = function(text, timeout, waitHideTransition) {
    var toast = new $21104bc65c54f4d6$var$Toast(text);
    this.appendChild(toast);
    // Force transition to play, if any.
    setTimeout(toast.show.bind(toast), 0);
    var self = this;
    setTimeout(function() {
        if (waitHideTransition) {
            toast.element.addEventListener("transitionend", function listener() {
                self.removeChild(toast);
                toast.element.removeEventListener("transitionend", listener);
            });
            toast.hide();
        } else this.removeChild(toast);
    }, timeout);
};
function $21104bc65c54f4d6$var$Flexbox(direction) {
    var element = document.createElement("div");
    element.style.display = "flex";
    element.style.flexDirection = direction;
    this.element = element;
    $21104bc65c54f4d6$var$Widget.call(this);
}
$21104bc65c54f4d6$var$Flexbox.prototype = $21104bc65c54f4d6$var$inherit($21104bc65c54f4d6$var$Widget, "Flexbox");
$21104bc65c54f4d6$var$addStyleProperty($21104bc65c54f4d6$var$Flexbox, "flexDirection");
$21104bc65c54f4d6$var$addStyleProperty($21104bc65c54f4d6$var$Flexbox, "justifyContent");
$21104bc65c54f4d6$var$addStyleProperty($21104bc65c54f4d6$var$Flexbox, "alignItems");
$21104bc65c54f4d6$var$addStyleProperty($21104bc65c54f4d6$var$Flexbox, "alignContent");
$21104bc65c54f4d6$var$addStyleProperty($21104bc65c54f4d6$var$Flexbox, "gap");
$21104bc65c54f4d6$var$addStyleProperty($21104bc65c54f4d6$var$Flexbox, "rowGap");
$21104bc65c54f4d6$var$addStyleProperty($21104bc65c54f4d6$var$Flexbox, "columnGap");
function $21104bc65c54f4d6$var$Floatbox() {
    var element = document.createElement("div");
    element.style.position = "fixed";
    this.element = element;
    $21104bc65c54f4d6$var$Widget.call(this);
}
$21104bc65c54f4d6$var$Floatbox.prototype = $21104bc65c54f4d6$var$inherit($21104bc65c54f4d6$var$Widget, "Floatbox");
$21104bc65c54f4d6$var$addStyleProperty($21104bc65c54f4d6$var$Floatbox, "zIndex");
$21104bc65c54f4d6$var$addStyleProperty($21104bc65c54f4d6$var$Floatbox, "top");
$21104bc65c54f4d6$var$addStyleProperty($21104bc65c54f4d6$var$Floatbox, "left");
$21104bc65c54f4d6$var$addStyleProperty($21104bc65c54f4d6$var$Floatbox, "bottom");
$21104bc65c54f4d6$var$addStyleProperty($21104bc65c54f4d6$var$Floatbox, "right");
function $21104bc65c54f4d6$var$Label(text) {
    var element = document.createElement("span");
    element.innerText = text;
    this.element = element;
    $21104bc65c54f4d6$var$Widget.call(this);
}
$21104bc65c54f4d6$var$Label.prototype = $21104bc65c54f4d6$var$inherit($21104bc65c54f4d6$var$Widget, "Label");
Object.defineProperty($21104bc65c54f4d6$var$Label.prototype, "text", {
    get: function() {
        return this.element.innerText;
    },
    set: function(text) {
        this.element.innerText = text;
    }
});
function $21104bc65c54f4d6$var$Button(text, type) {
    var element = document.createElement("button");
    if (text) element.innerText = text;
    if (type) element.classList.add(type);
    this.element = element;
    $21104bc65c54f4d6$var$Widget.call(this);
}
$21104bc65c54f4d6$var$Button.prototype = $21104bc65c54f4d6$var$inherit($21104bc65c54f4d6$var$Label, "Button");
function $21104bc65c54f4d6$var$Dialog(titleText) {
    var element = document.createElement("div");
    element.style.zIndex = 101;
    var title = document.createElement("div");
    title.classList.add("pbfeDialogTitle");
    title.innerText = titleText;
    element.appendChild(title);
    var body = document.createElement("div");
    body.classList.add("pbfeDialogBody");
    element.appendChild(body);
    var buttons = document.createElement("div");
    buttons.classList.add("pbfeDialogButtons");
    buttons.style.display = "flex";
    element.appendChild(buttons);
    this.element = element;
    this.title = title;
    this.body = body;
    this.buttons = buttons;
    $21104bc65c54f4d6$var$Widget.call(this);
}
$21104bc65c54f4d6$var$Dialog.prototype = $21104bc65c54f4d6$var$inherit($21104bc65c54f4d6$var$Widget, "Dialog");
$21104bc65c54f4d6$var$Dialog.prototype.show = function() {
    this.element.classList.add("show");
    var shadow = document.getElementById("pbfeShadow");
    if (shadow) shadow.classList.add("show");
};
$21104bc65c54f4d6$var$Dialog.prototype.hide = function() {
    if (this.element.classList.contains("show")) {
        this.element.classList.remove("show");
        var shadow = document.getElementById("pbfeShadow");
        if (shadow) shadow.classList.remove("show");
    }
};
$21104bc65c54f4d6$var$Dialog.prototype.appendButton = function(widget) {
    this.buttons.appendChild(widget.element);
};
$21104bc65c54f4d6$var$Dialog.prototype.removeButton = function(widget) {
    this.buttons.removeChild(widget.element);
};
$21104bc65c54f4d6$var$Dialog.prototype.appendHideButton = function(btnText, type) {
    var tr = typeof window !== "undefined" && window.i18nTranslate ? window.i18nTranslate(btnText) : btnText;
    var btn = new $21104bc65c54f4d6$var$Button(tr, type);
    if (typeof window !== "undefined" && window.i18nTranslate) btn.element.setAttribute("data-i18n", btnText);
    btn.addEventListener("click", this.hide.bind(this));
    this.appendButton(btn);
};
Object.defineProperty($21104bc65c54f4d6$var$Dialog.prototype, "titleText", {
    get: function() {
        return this._title.innerText;
    },
    set: function(text) {
        this._title.innerText = text;
    }
});
function $21104bc65c54f4d6$var$Input(type) {
    function createCheckbox() {
        var element = document.createElement("button");
        element.classList.add("pbfeCheckbox");
        var inner = document.createElement("div");
        inner.classList.add("pbfeCheckboxInner");
        element.appendChild(inner);
        Object.defineProperty(element, "checked", {
            get: function() {
                return this._checked;
            },
            set: function(value) {
                if (this._checked == value) return;
                this._checked = value;
                if (value) element.classList.add("checked");
                else element.classList.remove("checked");
                element.dispatchEvent(new Event("change"));
            }
        });
        element._checked = false;
        element.addEventListener("click", function() {
            this.checked = !this.checked;
        });
        return element;
    }
    var element;
    switch(type){
        case "checkbox":
            element = createCheckbox();
            break;
        default:
            // no replacement, fallback to input element
            element = document.createElement("input");
            element.type = type;
            break;
    }
    this.element = element;
    this.type = type;
    $21104bc65c54f4d6$var$Widget.call(this);
}
$21104bc65c54f4d6$var$Input.prototype = $21104bc65c54f4d6$var$inherit($21104bc65c54f4d6$var$Widget, "Input");
$21104bc65c54f4d6$var$addElementProperty($21104bc65c54f4d6$var$Input, "value");
$21104bc65c54f4d6$var$addElementProperty($21104bc65c54f4d6$var$Input, "placeholder");
$21104bc65c54f4d6$var$addElementProperty($21104bc65c54f4d6$var$Input, "min");
$21104bc65c54f4d6$var$addElementProperty($21104bc65c54f4d6$var$Input, "max");
$21104bc65c54f4d6$var$addElementProperty($21104bc65c54f4d6$var$Input, "step");
function $21104bc65c54f4d6$var$ProgressBar() {
    var element = document.createElement("div");
    var inner = document.createElement("div");
    inner.classList.add("pbfeProgressBarInner");
    inner.style.width = "0%";
    inner.style.height = "100%";
    element.appendChild(inner);
    this.element = element;
    this.inner = inner;
    $21104bc65c54f4d6$var$Widget.call(this);
}
$21104bc65c54f4d6$var$ProgressBar.prototype = $21104bc65c54f4d6$var$inherit($21104bc65c54f4d6$var$Widget, "ProgressBar");
$21104bc65c54f4d6$var$ProgressBar.prototype.setProgress = function(value) {
    var inner = this.inner;
    if (typeof value == "number") {
        if (value < 0) {
            inner.style.removeProperty("width");
            inner.classList.add("indeterminate");
            return;
        } else value = value * 100 + "%";
    }
    if (inner.classList.contains("indeterminate")) inner.classList.remove("indeterminate");
    inner.style.width = value;
};
function $21104bc65c54f4d6$var$Canvas() {
    this.element = document.createElement("canvas");
    $21104bc65c54f4d6$var$Widget.call(this);
}
$21104bc65c54f4d6$var$Canvas.prototype = $21104bc65c54f4d6$var$inherit($21104bc65c54f4d6$var$Widget, "Canvas");
$21104bc65c54f4d6$var$Canvas.prototype.getContext = function() {
    return this.element.getContext.apply(this.element, arguments);
};
function $21104bc65c54f4d6$var$Toast(text) {
    var element = document.createElement("div");
    element.style.zIndex = 102;
    element.innerText = text;
    this.element = element;
    $21104bc65c54f4d6$var$Widget.call(this);
}
$21104bc65c54f4d6$var$Toast.prototype = $21104bc65c54f4d6$var$inherit($21104bc65c54f4d6$var$Label, "Toast");
$21104bc65c54f4d6$var$Toast.prototype.show = function() {
    this.element.classList.add("show");
};
$21104bc65c54f4d6$var$Toast.prototype.hide = function() {
    this.element.classList.remove("show");
};
function $21104bc65c54f4d6$var$Selector() {
    var element = document.createElement("select");
    this.element = element;
    $21104bc65c54f4d6$var$Widget.call(this);
}
$21104bc65c54f4d6$var$Selector.prototype = $21104bc65c54f4d6$var$inherit($21104bc65c54f4d6$var$Widget, "Selector");
$21104bc65c54f4d6$var$Selector.prototype.addOption = function(text, value, isPlaceholder) {
    var option = document.createElement("option");
    option.text = text;
    if (value) option.value = value;
    if (isPlaceholder) option.hidden = option.disabled = option.selected = true;
    this.element.appendChild(option);
};
$21104bc65c54f4d6$var$addElementProperty($21104bc65c54f4d6$var$Selector, "value");
const $21104bc65c54f4d6$var$pbfe = {
    Container: $21104bc65c54f4d6$var$Container,
    Widget: $21104bc65c54f4d6$var$Widget,
    Flexbox: $21104bc65c54f4d6$var$Flexbox,
    Floatbox: $21104bc65c54f4d6$var$Floatbox,
    Label: $21104bc65c54f4d6$var$Label,
    Button: $21104bc65c54f4d6$var$Button,
    Dialog: $21104bc65c54f4d6$var$Dialog,
    Input: $21104bc65c54f4d6$var$Input,
    ProgressBar: $21104bc65c54f4d6$var$ProgressBar,
    Canvas: $21104bc65c54f4d6$var$Canvas,
    Toast: $21104bc65c54f4d6$var$Toast,
    Selector: $21104bc65c54f4d6$var$Selector
};
var $21104bc65c54f4d6$export$2e2bcd8739ae039 = $21104bc65c54f4d6$var$pbfe;




var $313f6ce5359206e9$var$strings = {};
var $313f6ce5359206e9$var$langs = {};
// Elements registered for live re-translation on language switch.
// Each entry: { el, key, attr } where attr is "text" or an attribute name.
var $313f6ce5359206e9$var$subs = [];
async function $313f6ce5359206e9$var$init() {
    var res = await fetch("/i18n/langs.json");
    var json = await res.json();
    $313f6ce5359206e9$var$langs = json;
}
async function $313f6ce5359206e9$var$loadLanguage(lang) {
    if (!(lang in $313f6ce5359206e9$var$langs)) throw new Error;
    var res = await fetch("/i18n/" + lang + ".json");
    var json = await res.json();
    $313f6ce5359206e9$var$strings = json;
}
function $313f6ce5359206e9$var$getString(str) {
    if (str in $313f6ce5359206e9$var$strings) return $313f6ce5359206e9$var$strings[str];
    else return str;
}
function $313f6ce5359206e9$var$getLanguages() {
    return $313f6ce5359206e9$var$langs;
}
// Register an element to be re-translated whenever the language changes.
// Usage:
//   t(el, "Some English key")              -> sets el.textContent
//   t(el, "Some English key", "aria-label")-> sets el's aria-label attribute
// The element keeps displaying the CURRENT language immediately, and
// retranslate() (called after i18n.loadLanguage) updates every connected
// element without tearing down the DOM. This is what lets the language
// switcher update the UI in place instead of rebuilding the whole app.
function $313f6ce5359206e9$export$625550452a3fa3ec(el, key, attr) {
    attr = attr || "text";
    var sub = {
        el: el,
        key: key,
        attr: attr
    };
    $313f6ce5359206e9$var$applySub(sub);
    $313f6ce5359206e9$var$subs.push(sub);
    return el;
}
function $313f6ce5359206e9$var$applySub(sub) {
    var v = $313f6ce5359206e9$var$getString(sub.key);
    if (sub.attr === "text") sub.el.textContent = v;
    else sub.el.setAttribute(sub.attr, v);
}
function $313f6ce5359206e9$export$282dadb5b59543dc() {
    for(var i = 0; i < $313f6ce5359206e9$var$subs.length; i++){
        var s = $313f6ce5359206e9$var$subs[i];
        if (s.el && s.el.isConnected) $313f6ce5359206e9$var$applySub(s);
    }
    // Also re-translate any element tagged with a data-i18n attribute
    // (used for UI built without a direct reference, e.g. dialog hide
    // buttons created inside pbfe). Keeps those in sync on language switch.
    if (typeof document !== "undefined") {
        var nodes = document.querySelectorAll("[data-i18n]");
        for(var j = 0; j < nodes.length; j++){
            var n = nodes[j];
            if (n.isConnected) n.textContent = $313f6ce5359206e9$var$getString(n.getAttribute("data-i18n"));
        }
    }
    // Notify dynamic UI (state-dependent labels like the panel hide/show
    // toggle) so they can re-localize themselves after a language switch.
    if (typeof window !== "undefined") window.dispatchEvent(new Event("i18n:change"));
}
// Convenience for elements created without a tracked reference: set the
// data-i18n attribute and the initial (current-language) text in one call.
function $313f6ce5359206e9$export$a039134f2fc7e0(el, key) {
    el.setAttribute("data-i18n", key);
    el.textContent = $313f6ce5359206e9$var$getString(key);
    return el;
}
// Expose a translator so generic UI builders (pbfe) can localize text they
// create without importing i18n directly.
if (typeof window !== "undefined") window.i18nTranslate = function(k) {
    return $313f6ce5359206e9$var$getString(k);
};
var $313f6ce5359206e9$var$i18n = {
    init: $313f6ce5359206e9$var$init,
    loadLanguage: $313f6ce5359206e9$var$loadLanguage,
    getString: $313f6ce5359206e9$var$getString,
    getLanguages: $313f6ce5359206e9$var$getLanguages
};
var $313f6ce5359206e9$export$2e2bcd8739ae039 = $313f6ce5359206e9$var$i18n;
var $313f6ce5359206e9$export$71511d61b312f219 = $313f6ce5359206e9$var$getString;


var $4244c5b4a8c0a9c7$var$dialog, $4244c5b4a8c0a9c7$var$progressBar;
function $4244c5b4a8c0a9c7$var$init(container) {
    $4244c5b4a8c0a9c7$var$dialog = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Dialog("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)($4244c5b4a8c0a9c7$var$dialog.title, "Loading...");
    container.appendChild($4244c5b4a8c0a9c7$var$dialog);
    $4244c5b4a8c0a9c7$var$progressBar = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).ProgressBar;
    $4244c5b4a8c0a9c7$var$progressBar.element.id = "loadingBar";
    $4244c5b4a8c0a9c7$var$dialog.appendChild($4244c5b4a8c0a9c7$var$progressBar);
}
function $4244c5b4a8c0a9c7$var$show() {
    $4244c5b4a8c0a9c7$var$dialog.show();
}
function $4244c5b4a8c0a9c7$var$hide() {
    $4244c5b4a8c0a9c7$var$dialog.hide();
}
function $4244c5b4a8c0a9c7$var$setProgress(value) {
    $4244c5b4a8c0a9c7$var$progressBar.setProgress(value);
}
var $4244c5b4a8c0a9c7$var$loadingDialog = {
    init: $4244c5b4a8c0a9c7$var$init,
    show: $4244c5b4a8c0a9c7$var$show,
    hide: $4244c5b4a8c0a9c7$var$hide,
    setProgress: $4244c5b4a8c0a9c7$var$setProgress
};
var $4244c5b4a8c0a9c7$export$2e2bcd8739ae039 = $4244c5b4a8c0a9c7$var$loadingDialog;



var $cff5b25a521f554e$var$container;
function $cff5b25a521f554e$var$init(_container) {
    $cff5b25a521f554e$var$container = _container;
}
function $cff5b25a521f554e$var$show(text) {
    $cff5b25a521f554e$var$container.showToast(text, 3000, true);
}
var $cff5b25a521f554e$var$toast = {
    init: $cff5b25a521f554e$var$init,
    show: $cff5b25a521f554e$var$show
};
var $cff5b25a521f554e$export$2e2bcd8739ae039 = $cff5b25a521f554e$var$toast;




// (c) Dean McNamee <dean@gmail.com>, 2013.
//
// https://github.com/deanm/omggif
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
// FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
// IN THE SOFTWARE.
//
// omggif is a JavaScript implementation of a GIF 89a encoder and decoder,
// including animation and compression.  It does not rely on any specific
// underlying system, so should run in the browser, Node, or Plask.
var $71041c0c6f4131a3$export$47e375f7f82a91ef;
var $71041c0c6f4131a3$export$c4cdd6730c8d089c;
"use strict";
function $71041c0c6f4131a3$var$GifWriter(buf, width, height, gopts) {
    var p = 0;
    var gopts = gopts === undefined ? {} : gopts;
    var loop_count = gopts.loop === undefined ? null : gopts.loop;
    var global_palette = gopts.palette === undefined ? null : gopts.palette;
    if (width <= 0 || height <= 0 || width > 65535 || height > 65535) throw new Error("Width/Height invalid.");
    function check_palette_and_num_colors(palette) {
        var num_colors = palette.length;
        if (num_colors < 2 || num_colors > 256 || num_colors & num_colors - 1) throw new Error("Invalid code/color length, must be power of 2 and 2 .. 256.");
        return num_colors;
    }
    // - Header.
    buf[p++] = 0x47;
    buf[p++] = 0x49;
    buf[p++] = 0x46; // GIF
    buf[p++] = 0x38;
    buf[p++] = 0x39;
    buf[p++] = 0x61; // 89a
    // Handling of Global Color Table (palette) and background index.
    var gp_num_colors_pow2 = 0;
    var background = 0;
    if (global_palette !== null) {
        var gp_num_colors = check_palette_and_num_colors(global_palette);
        while(gp_num_colors >>= 1)++gp_num_colors_pow2;
        gp_num_colors = 1 << gp_num_colors_pow2;
        --gp_num_colors_pow2;
        if (gopts.background !== undefined) {
            background = gopts.background;
            if (background >= gp_num_colors) throw new Error("Background index out of range.");
            // The GIF spec states that a background index of 0 should be ignored, so
            // this is probably a mistake and you really want to set it to another
            // slot in the palette.  But actually in the end most browsers, etc end
            // up ignoring this almost completely (including for dispose background).
            if (background === 0) throw new Error("Background index explicitly passed as 0.");
        }
    }
    // - Logical Screen Descriptor.
    // NOTE(deanm): w/h apparently ignored by implementations, but set anyway.
    buf[p++] = width & 0xff;
    buf[p++] = width >> 8 & 0xff;
    buf[p++] = height & 0xff;
    buf[p++] = height >> 8 & 0xff;
    // NOTE: Indicates 0-bpp original color resolution (unused?).
    buf[p++] = (global_palette !== null ? 0x80 : 0) | // Global Color Table Flag.
    gp_num_colors_pow2; // NOTE: No sort flag (unused?).
    buf[p++] = background; // Background Color Index.
    buf[p++] = 0; // Pixel aspect ratio (unused?).
    // - Global Color Table
    if (global_palette !== null) for(var i = 0, il = global_palette.length; i < il; ++i){
        var rgb = global_palette[i];
        buf[p++] = rgb >> 16 & 0xff;
        buf[p++] = rgb >> 8 & 0xff;
        buf[p++] = rgb & 0xff;
    }
    if (loop_count !== null) {
        if (loop_count < 0 || loop_count > 65535) throw new Error("Loop count invalid.");
        // Extension code, label, and length.
        buf[p++] = 0x21;
        buf[p++] = 0xff;
        buf[p++] = 0x0b;
        // NETSCAPE2.0
        buf[p++] = 0x4e;
        buf[p++] = 0x45;
        buf[p++] = 0x54;
        buf[p++] = 0x53;
        buf[p++] = 0x43;
        buf[p++] = 0x41;
        buf[p++] = 0x50;
        buf[p++] = 0x45;
        buf[p++] = 0x32;
        buf[p++] = 0x2e;
        buf[p++] = 0x30;
        // Sub-block
        buf[p++] = 0x03;
        buf[p++] = 0x01;
        buf[p++] = loop_count & 0xff;
        buf[p++] = loop_count >> 8 & 0xff;
        buf[p++] = 0x00; // Terminator.
    }
    var ended = false;
    this.addFrame = function(x, y, w, h, indexed_pixels, opts) {
        if (ended === true) {
            --p;
            ended = false;
        } // Un-end.
        opts = opts === undefined ? {} : opts;
        // TODO(deanm): Bounds check x, y.  Do they need to be within the virtual
        // canvas width/height, I imagine?
        if (x < 0 || y < 0 || x > 65535 || y > 65535) throw new Error("x/y invalid.");
        if (w <= 0 || h <= 0 || w > 65535 || h > 65535) throw new Error("Width/Height invalid.");
        if (indexed_pixels.length < w * h) throw new Error("Not enough pixels for the frame size.");
        var using_local_palette = true;
        var palette = opts.palette;
        if (palette === undefined || palette === null) {
            using_local_palette = false;
            palette = global_palette;
        }
        if (palette === undefined || palette === null) throw new Error("Must supply either a local or global palette.");
        var num_colors = check_palette_and_num_colors(palette);
        // Compute the min_code_size (power of 2), destroying num_colors.
        var min_code_size = 0;
        while(num_colors >>= 1)++min_code_size;
        num_colors = 1 << min_code_size; // Now we can easily get it back.
        var delay = opts.delay === undefined ? 0 : opts.delay;
        // From the spec:
        //     0 -   No disposal specified. The decoder is
        //           not required to take any action.
        //     1 -   Do not dispose. The graphic is to be left
        //           in place.
        //     2 -   Restore to background color. The area used by the
        //           graphic must be restored to the background color.
        //     3 -   Restore to previous. The decoder is required to
        //           restore the area overwritten by the graphic with
        //           what was there prior to rendering the graphic.
        //  4-7 -    To be defined.
        // NOTE(deanm): Dispose background doesn't really work, apparently most
        // browsers ignore the background palette index and clear to transparency.
        var disposal = opts.disposal === undefined ? 0 : opts.disposal;
        if (disposal < 0 || disposal > 3) throw new Error("Disposal out of range.");
        var use_transparency = false;
        var transparent_index = 0;
        if (opts.transparent !== undefined && opts.transparent !== null) {
            use_transparency = true;
            transparent_index = opts.transparent;
            if (transparent_index < 0 || transparent_index >= num_colors) throw new Error("Transparent color index.");
        }
        if (disposal !== 0 || use_transparency || delay !== 0) {
            // - Graphics Control Extension
            buf[p++] = 0x21;
            buf[p++] = 0xf9; // Extension / Label.
            buf[p++] = 4; // Byte size.
            buf[p++] = disposal << 2 | (use_transparency === true ? 1 : 0);
            buf[p++] = delay & 0xff;
            buf[p++] = delay >> 8 & 0xff;
            buf[p++] = transparent_index; // Transparent color index.
            buf[p++] = 0; // Block Terminator.
        }
        // - Image Descriptor
        buf[p++] = 0x2c; // Image Seperator.
        buf[p++] = x & 0xff;
        buf[p++] = x >> 8 & 0xff; // Left.
        buf[p++] = y & 0xff;
        buf[p++] = y >> 8 & 0xff; // Top.
        buf[p++] = w & 0xff;
        buf[p++] = w >> 8 & 0xff;
        buf[p++] = h & 0xff;
        buf[p++] = h >> 8 & 0xff;
        // NOTE: No sort flag (unused?).
        // TODO(deanm): Support interlace.
        buf[p++] = using_local_palette === true ? 0x80 | min_code_size - 1 : 0;
        // - Local Color Table
        if (using_local_palette === true) for(var i = 0, il = palette.length; i < il; ++i){
            var rgb = palette[i];
            buf[p++] = rgb >> 16 & 0xff;
            buf[p++] = rgb >> 8 & 0xff;
            buf[p++] = rgb & 0xff;
        }
        p = $71041c0c6f4131a3$var$GifWriterOutputLZWCodeStream(buf, p, min_code_size < 2 ? 2 : min_code_size, indexed_pixels);
        return p;
    };
    this.end = function() {
        if (ended === false) {
            buf[p++] = 0x3b; // Trailer.
            ended = true;
        }
        return p;
    };
    this.getOutputBuffer = function() {
        return buf;
    };
    this.setOutputBuffer = function(v) {
        buf = v;
    };
    this.getOutputBufferPosition = function() {
        return p;
    };
    this.setOutputBufferPosition = function(v) {
        p = v;
    };
}
// Main compression routine, palette indexes -> LZW code stream.
// |index_stream| must have at least one entry.
function $71041c0c6f4131a3$var$GifWriterOutputLZWCodeStream(buf, p, min_code_size, index_stream) {
    buf[p++] = min_code_size;
    var cur_subblock = p++; // Pointing at the length field.
    var clear_code = 1 << min_code_size;
    var code_mask = clear_code - 1;
    var eoi_code = clear_code + 1;
    var next_code = eoi_code + 1;
    var cur_code_size = min_code_size + 1; // Number of bits per code.
    var cur_shift = 0;
    // We have at most 12-bit codes, so we should have to hold a max of 19
    // bits here (and then we would write out).
    var cur = 0;
    function emit_bytes_to_buffer(bit_block_size) {
        while(cur_shift >= bit_block_size){
            buf[p++] = cur & 0xff;
            cur >>= 8;
            cur_shift -= 8;
            if (p === cur_subblock + 256) {
                buf[cur_subblock] = 255;
                cur_subblock = p++;
            }
        }
    }
    function emit_code(c) {
        cur |= c << cur_shift;
        cur_shift += cur_code_size;
        emit_bytes_to_buffer(8);
    }
    // I am not an expert on the topic, and I don't want to write a thesis.
    // However, it is good to outline here the basic algorithm and the few data
    // structures and optimizations here that make this implementation fast.
    // The basic idea behind LZW is to build a table of previously seen runs
    // addressed by a short id (herein called output code).  All data is
    // referenced by a code, which represents one or more values from the
    // original input stream.  All input bytes can be referenced as the same
    // value as an output code.  So if you didn't want any compression, you
    // could more or less just output the original bytes as codes (there are
    // some details to this, but it is the idea).  In order to achieve
    // compression, values greater then the input range (codes can be up to
    // 12-bit while input only 8-bit) represent a sequence of previously seen
    // inputs.  The decompressor is able to build the same mapping while
    // decoding, so there is always a shared common knowledge between the
    // encoding and decoder, which is also important for "timing" aspects like
    // how to handle variable bit width code encoding.
    //
    // One obvious but very important consequence of the table system is there
    // is always a unique id (at most 12-bits) to map the runs.  'A' might be
    // 4, then 'AA' might be 10, 'AAA' 11, 'AAAA' 12, etc.  This relationship
    // can be used for an effecient lookup strategy for the code mapping.  We
    // need to know if a run has been seen before, and be able to map that run
    // to the output code.  Since we start with known unique ids (input bytes),
    // and then from those build more unique ids (table entries), we can
    // continue this chain (almost like a linked list) to always have small
    // integer values that represent the current byte chains in the encoder.
    // This means instead of tracking the input bytes (AAAABCD) to know our
    // current state, we can track the table entry for AAAABC (it is guaranteed
    // to exist by the nature of the algorithm) and the next character D.
    // Therefor the tuple of (table_entry, byte) is guaranteed to also be
    // unique.  This allows us to create a simple lookup key for mapping input
    // sequences to codes (table indices) without having to store or search
    // any of the code sequences.  So if 'AAAA' has a table entry of 12, the
    // tuple of ('AAAA', K) for any input byte K will be unique, and can be our
    // key.  This leads to a integer value at most 20-bits, which can always
    // fit in an SMI value and be used as a fast sparse array / object key.
    // Output code for the current contents of the index buffer.
    var ib_code = index_stream[0] & code_mask; // Load first input index.
    var code_table = {}; // Key'd on our 20-bit "tuple".
    emit_code(clear_code); // Spec says first code should be a clear code.
    // First index already loaded, process the rest of the stream.
    for(var i = 1, il = index_stream.length; i < il; ++i){
        var k = index_stream[i] & code_mask;
        var cur_key = ib_code << 8 | k; // (prev, k) unique tuple.
        var cur_code = code_table[cur_key]; // buffer + k.
        // Check if we have to create a new code table entry.
        if (cur_code === undefined) {
            // Emit index buffer (without k).
            // This is an inline version of emit_code, because this is the core
            // writing routine of the compressor (and V8 cannot inline emit_code
            // because it is a closure here in a different context).  Additionally
            // we can call emit_byte_to_buffer less often, because we can have
            // 30-bits (from our 31-bit signed SMI), and we know our codes will only
            // be 12-bits, so can safely have 18-bits there without overflow.
            // emit_code(ib_code);
            cur |= ib_code << cur_shift;
            cur_shift += cur_code_size;
            while(cur_shift >= 8){
                buf[p++] = cur & 0xff;
                cur >>= 8;
                cur_shift -= 8;
                if (p === cur_subblock + 256) {
                    buf[cur_subblock] = 255;
                    cur_subblock = p++;
                }
            }
            if (next_code === 4096) {
                emit_code(clear_code);
                next_code = eoi_code + 1;
                cur_code_size = min_code_size + 1;
                code_table = {};
            } else {
                // Increase our variable bit code sizes if necessary.  This is a bit
                // tricky as it is based on "timing" between the encoding and
                // decoder.  From the encoders perspective this should happen after
                // we've already emitted the index buffer and are about to create the
                // first table entry that would overflow our current code bit size.
                if (next_code >= 1 << cur_code_size) ++cur_code_size;
                code_table[cur_key] = next_code++; // Insert into code table.
            }
            ib_code = k; // Index buffer to single input k.
        } else ib_code = cur_code; // Index buffer to sequence in code table.
    }
    emit_code(ib_code); // There will still be something in the index buffer.
    emit_code(eoi_code); // End Of Information.
    // Flush / finalize the sub-blocks stream to the buffer.
    emit_bytes_to_buffer(1);
    // Finish the sub-blocks, writing out any unfinished lengths and
    // terminating with a sub-block of length 0.  If we have already started
    // but not yet used a sub-block it can just become the terminator.
    if (cur_subblock + 1 === p) buf[cur_subblock] = 0;
    else {
        buf[cur_subblock] = p - cur_subblock - 1;
        buf[p++] = 0;
    }
    return p;
}
function $71041c0c6f4131a3$var$GifReader(buf) {
    var p = 0;
    // - Header (GIF87a or GIF89a).
    if (buf[p++] !== 0x47 || buf[p++] !== 0x49 || buf[p++] !== 0x46 || buf[p++] !== 0x38 || (buf[p++] + 1 & 0xfd) !== 0x38 || buf[p++] !== 0x61) throw new Error("Invalid GIF 87a/89a header.");
    // - Logical Screen Descriptor.
    var width = buf[p++] | buf[p++] << 8;
    var height = buf[p++] | buf[p++] << 8;
    var pf0 = buf[p++]; // <Packed Fields>.
    var global_palette_flag = pf0 >> 7;
    var num_global_colors_pow2 = pf0 & 0x7;
    var num_global_colors = 1 << num_global_colors_pow2 + 1;
    var background = buf[p++];
    buf[p++]; // Pixel aspect ratio (unused?).
    var global_palette_offset = null;
    var global_palette_size = null;
    if (global_palette_flag) {
        global_palette_offset = p;
        global_palette_size = num_global_colors;
        p += num_global_colors * 3; // Seek past palette.
    }
    var no_eof = true;
    var frames = [];
    var delay = 0;
    var transparent_index = null;
    var disposal = 0; // 0 - No disposal specified.
    var loop_count = null;
    this.width = width;
    this.height = height;
    while(no_eof && p < buf.length)switch(buf[p++]){
        case 0x21:
            switch(buf[p++]){
                case 0xff:
                    // Try if it's a Netscape block (with animation loop counter).
                    if (buf[p] !== 0x0b || // 21 FF already read, check block size.
                    // NETSCAPE2.0
                    buf[p + 1] == 0x4e && buf[p + 2] == 0x45 && buf[p + 3] == 0x54 && buf[p + 4] == 0x53 && buf[p + 5] == 0x43 && buf[p + 6] == 0x41 && buf[p + 7] == 0x50 && buf[p + 8] == 0x45 && buf[p + 9] == 0x32 && buf[p + 10] == 0x2e && buf[p + 11] == 0x30 && // Sub-block
                    buf[p + 12] == 0x03 && buf[p + 13] == 0x01 && buf[p + 16] == 0) {
                        p += 14;
                        loop_count = buf[p++] | buf[p++] << 8;
                        p++; // Skip terminator.
                    } else {
                        p += 12;
                        while(true){
                            var block_size = buf[p++];
                            // Bad block size (ex: undefined from an out of bounds read).
                            if (!(block_size >= 0)) throw Error("Invalid block size");
                            if (block_size === 0) break; // 0 size is terminator
                            p += block_size;
                        }
                    }
                    break;
                case 0xf9:
                    if (buf[p++] !== 0x4 || buf[p + 4] !== 0) throw new Error("Invalid graphics extension block.");
                    var pf1 = buf[p++];
                    delay = buf[p++] | buf[p++] << 8;
                    transparent_index = buf[p++];
                    if ((pf1 & 1) === 0) transparent_index = null;
                    disposal = pf1 >> 2 & 0x7;
                    p++; // Skip terminator.
                    break;
                // Plain Text Extension could be present and we just want to be able
                // to parse past it.  It follows the block structure of the comment
                // extension enough to reuse the path to skip through the blocks.
                case 0x01:
                case 0xfe:
                    while(true){
                        var block_size = buf[p++];
                        // Bad block size (ex: undefined from an out of bounds read).
                        if (!(block_size >= 0)) throw Error("Invalid block size");
                        if (block_size === 0) break; // 0 size is terminator
                        // console.log(buf.slice(p, p+block_size).toString('ascii'));
                        p += block_size;
                    }
                    break;
                default:
                    throw new Error("Unknown graphic control label: 0x" + buf[p - 1].toString(16));
            }
            break;
        case 0x2c:
            var x = buf[p++] | buf[p++] << 8;
            var y = buf[p++] | buf[p++] << 8;
            var w = buf[p++] | buf[p++] << 8;
            var h = buf[p++] | buf[p++] << 8;
            var pf2 = buf[p++];
            var local_palette_flag = pf2 >> 7;
            var interlace_flag = pf2 >> 6 & 1;
            var num_local_colors_pow2 = pf2 & 0x7;
            var num_local_colors = 1 << num_local_colors_pow2 + 1;
            var palette_offset = global_palette_offset;
            var palette_size = global_palette_size;
            var has_local_palette = false;
            if (local_palette_flag) {
                var has_local_palette = true;
                palette_offset = p; // Override with local palette.
                palette_size = num_local_colors;
                p += num_local_colors * 3; // Seek past palette.
            }
            var data_offset = p;
            p++; // codesize
            while(true){
                var block_size = buf[p++];
                // Bad block size (ex: undefined from an out of bounds read).
                if (!(block_size >= 0)) throw Error("Invalid block size");
                if (block_size === 0) break; // 0 size is terminator
                p += block_size;
            }
            frames.push({
                x: x,
                y: y,
                width: w,
                height: h,
                has_local_palette: has_local_palette,
                palette_offset: palette_offset,
                palette_size: palette_size,
                data_offset: data_offset,
                data_length: p - data_offset,
                transparent_index: transparent_index,
                interlaced: !!interlace_flag,
                delay: delay,
                disposal: disposal
            });
            break;
        case 0x3b:
            no_eof = false;
            break;
        default:
            throw new Error("Unknown gif block: 0x" + buf[p - 1].toString(16));
    }
    this.numFrames = function() {
        return frames.length;
    };
    this.loopCount = function() {
        return loop_count;
    };
    this.frameInfo = function(frame_num) {
        if (frame_num < 0 || frame_num >= frames.length) throw new Error("Frame index out of range.");
        return frames[frame_num];
    };
    this.decodeAndBlitFrameBGRA = function(frame_num, pixels) {
        var frame = this.frameInfo(frame_num);
        var num_pixels = frame.width * frame.height;
        var index_stream = new Uint8Array(num_pixels); // At most 8-bit indices.
        $71041c0c6f4131a3$var$GifReaderLZWOutputIndexStream(buf, frame.data_offset, index_stream, num_pixels);
        var palette_offset = frame.palette_offset;
        // NOTE(deanm): It seems to be much faster to compare index to 256 than
        // to === null.  Not sure why, but CompareStub_EQ_STRICT shows up high in
        // the profile, not sure if it's related to using a Uint8Array.
        var trans = frame.transparent_index;
        if (trans === null) trans = 256;
        // We are possibly just blitting to a portion of the entire frame.
        // That is a subrect within the framerect, so the additional pixels
        // must be skipped over after we finished a scanline.
        var framewidth = frame.width;
        var framestride = width - framewidth;
        var xleft = framewidth; // Number of subrect pixels left in scanline.
        // Output index of the top left corner of the subrect.
        var opbeg = (frame.y * width + frame.x) * 4;
        // Output index of what would be the left edge of the subrect, one row
        // below it, i.e. the index at which an interlace pass should wrap.
        var opend = ((frame.y + frame.height) * width + frame.x) * 4;
        var op = opbeg;
        var scanstride = framestride * 4;
        // Use scanstride to skip past the rows when interlacing.  This is skipping
        // 7 rows for the first two passes, then 3 then 1.
        if (frame.interlaced === true) scanstride += width * 28; // Pass 1.
        var interlaceskip = 8; // Tracking the row interval in the current pass.
        for(var i = 0, il = index_stream.length; i < il; ++i){
            var index = index_stream[i];
            if (xleft === 0) {
                op += scanstride;
                xleft = framewidth;
                if (op >= opend) {
                    scanstride = framestride * 4 + width * 4 * (interlaceskip - 1);
                    // interlaceskip / 2 * 4 is interlaceskip << 1.
                    op = opbeg + (framewidth + framestride) * (interlaceskip << 1);
                    interlaceskip >>= 1;
                }
            }
            if (index === trans) op += 4;
            else {
                var r = buf[palette_offset + index * 3];
                var g = buf[palette_offset + index * 3 + 1];
                var b = buf[palette_offset + index * 3 + 2];
                pixels[op++] = b;
                pixels[op++] = g;
                pixels[op++] = r;
                pixels[op++] = 255;
            }
            --xleft;
        }
    };
    // I will go to copy and paste hell one day...
    this.decodeAndBlitFrameRGBA = function(frame_num, pixels) {
        var frame = this.frameInfo(frame_num);
        var num_pixels = frame.width * frame.height;
        var index_stream = new Uint8Array(num_pixels); // At most 8-bit indices.
        $71041c0c6f4131a3$var$GifReaderLZWOutputIndexStream(buf, frame.data_offset, index_stream, num_pixels);
        var palette_offset = frame.palette_offset;
        // NOTE(deanm): It seems to be much faster to compare index to 256 than
        // to === null.  Not sure why, but CompareStub_EQ_STRICT shows up high in
        // the profile, not sure if it's related to using a Uint8Array.
        var trans = frame.transparent_index;
        if (trans === null) trans = 256;
        // We are possibly just blitting to a portion of the entire frame.
        // That is a subrect within the framerect, so the additional pixels
        // must be skipped over after we finished a scanline.
        var framewidth = frame.width;
        var framestride = width - framewidth;
        var xleft = framewidth; // Number of subrect pixels left in scanline.
        // Output index of the top left corner of the subrect.
        var opbeg = (frame.y * width + frame.x) * 4;
        // Output index of what would be the left edge of the subrect, one row
        // below it, i.e. the index at which an interlace pass should wrap.
        var opend = ((frame.y + frame.height) * width + frame.x) * 4;
        var op = opbeg;
        var scanstride = framestride * 4;
        // Use scanstride to skip past the rows when interlacing.  This is skipping
        // 7 rows for the first two passes, then 3 then 1.
        if (frame.interlaced === true) scanstride += width * 28; // Pass 1.
        var interlaceskip = 8; // Tracking the row interval in the current pass.
        for(var i = 0, il = index_stream.length; i < il; ++i){
            var index = index_stream[i];
            if (xleft === 0) {
                op += scanstride;
                xleft = framewidth;
                if (op >= opend) {
                    scanstride = framestride * 4 + width * 4 * (interlaceskip - 1);
                    // interlaceskip / 2 * 4 is interlaceskip << 1.
                    op = opbeg + (framewidth + framestride) * (interlaceskip << 1);
                    interlaceskip >>= 1;
                }
            }
            if (index === trans) op += 4;
            else {
                var r = buf[palette_offset + index * 3];
                var g = buf[palette_offset + index * 3 + 1];
                var b = buf[palette_offset + index * 3 + 2];
                pixels[op++] = r;
                pixels[op++] = g;
                pixels[op++] = b;
                pixels[op++] = 255;
            }
            --xleft;
        }
    };
}
function $71041c0c6f4131a3$var$GifReaderLZWOutputIndexStream(code_stream, p, output, output_length) {
    var min_code_size = code_stream[p++];
    var clear_code = 1 << min_code_size;
    var eoi_code = clear_code + 1;
    var next_code = eoi_code + 1;
    var cur_code_size = min_code_size + 1; // Number of bits per code.
    // NOTE: This shares the same name as the encoder, but has a different
    // meaning here.  Here this masks each code coming from the code stream.
    var code_mask = (1 << cur_code_size) - 1;
    var cur_shift = 0;
    var cur = 0;
    var op = 0; // Output pointer.
    var subblock_size = code_stream[p++];
    // TODO(deanm): Would using a TypedArray be any faster?  At least it would
    // solve the fast mode / backing store uncertainty.
    // var code_table = Array(4096);
    var code_table = new Int32Array(4096); // Can be signed, we only use 20 bits.
    var prev_code = null; // Track code-1.
    while(true){
        // Read up to two bytes, making sure we always 12-bits for max sized code.
        while(cur_shift < 16){
            if (subblock_size === 0) break; // No more data to be read.
            cur |= code_stream[p++] << cur_shift;
            cur_shift += 8;
            if (subblock_size === 1) subblock_size = code_stream[p++]; // Next subblock.
            else --subblock_size;
        }
        // TODO(deanm): We should never really get here, we should have received
        // and EOI.
        if (cur_shift < cur_code_size) break;
        var code = cur & code_mask;
        cur >>= cur_code_size;
        cur_shift -= cur_code_size;
        // TODO(deanm): Maybe should check that the first code was a clear code,
        // at least this is what you're supposed to do.  But actually our encoder
        // now doesn't emit a clear code first anyway.
        if (code === clear_code) {
            // We don't actually have to clear the table.  This could be a good idea
            // for greater error checking, but we don't really do any anyway.  We
            // will just track it with next_code and overwrite old entries.
            next_code = eoi_code + 1;
            cur_code_size = min_code_size + 1;
            code_mask = (1 << cur_code_size) - 1;
            // Don't update prev_code ?
            prev_code = null;
            continue;
        } else if (code === eoi_code) break;
        // We have a similar situation as the decoder, where we want to store
        // variable length entries (code table entries), but we want to do in a
        // faster manner than an array of arrays.  The code below stores sort of a
        // linked list within the code table, and then "chases" through it to
        // construct the dictionary entries.  When a new entry is created, just the
        // last byte is stored, and the rest (prefix) of the entry is only
        // referenced by its table entry.  Then the code chases through the
        // prefixes until it reaches a single byte code.  We have to chase twice,
        // first to compute the length, and then to actually copy the data to the
        // output (backwards, since we know the length).  The alternative would be
        // storing something in an intermediate stack, but that doesn't make any
        // more sense.  I implemented an approach where it also stored the length
        // in the code table, although it's a bit tricky because you run out of
        // bits (12 + 12 + 8), but I didn't measure much improvements (the table
        // entries are generally not the long).  Even when I created benchmarks for
        // very long table entries the complexity did not seem worth it.
        // The code table stores the prefix entry in 12 bits and then the suffix
        // byte in 8 bits, so each entry is 20 bits.
        var chase_code = code < next_code ? code : prev_code;
        // Chase what we will output, either {CODE} or {CODE-1}.
        var chase_length = 0;
        var chase = chase_code;
        while(chase > clear_code){
            chase = code_table[chase] >> 8;
            ++chase_length;
        }
        var k = chase;
        var op_end = op + chase_length + (chase_code !== code ? 1 : 0);
        if (op_end > output_length) {
            console.log("Warning, gif stream longer than expected.");
            return;
        }
        // Already have the first byte from the chase, might as well write it fast.
        output[op++] = k;
        op += chase_length;
        var b = op; // Track pointer, writing backwards.
        if (chase_code !== code) output[op++] = k;
        chase = chase_code;
        while(chase_length--){
            chase = code_table[chase];
            output[--b] = chase & 0xff; // Write backwards.
            chase >>= 8; // Pull down to the prefix code.
        }
        if (prev_code !== null && next_code < 4096) {
            code_table[next_code++] = prev_code << 8 | k;
            // TODO(deanm): Figure out this clearing vs code growth logic better.  I
            // have an feeling that it should just happen somewhere else, for now it
            // is awkward between when we grow past the max and then hit a clear code.
            // For now just check if we hit the max 12-bits (then a clear code should
            // follow, also of course encoded in 12-bits).
            if (next_code >= code_mask + 1 && cur_code_size < 12) {
                ++cur_code_size;
                code_mask = code_mask << 1 | 1;
            }
        }
        prev_code = code;
    }
    if (op !== output_length) console.log("Warning, gif stream shorter than expected.");
    return output;
}
// CommonJS.
try {
    $71041c0c6f4131a3$export$47e375f7f82a91ef = $71041c0c6f4131a3$var$GifWriter;
    $71041c0c6f4131a3$export$c4cdd6730c8d089c = $71041c0c6f4131a3$var$GifReader;
} catch (e) {}


var $3816ae512892ed40$var$frames = [];
function $3816ae512892ed40$var$load(file, inputs) {
    var reader = new FileReader;
    reader.onloadend = async function() {
        if (reader.error) {
            toast.show(_("Failed to load GIF frames."));
            return;
        }
        var view = new Uint8Array(reader.result);
        var gifReader;
        try {
            gifReader = new (0, $71041c0c6f4131a3$export$c4cdd6730c8d089c)(view);
        } catch (e) {
            toast.show(_("Failed to load GIF frames: ") + e.message);
            return;
        }
        var { width: width, height: height } = gifReader;
        inputs.loopCount.value = gifReader.loopCount();
        var ndFrameData, lastFrameData;
        var clearBg;
        for(let i = 0; i < gifReader.numFrames(); ++i){
            const info = gifReader.frameInfo(i);
            let inheritFrame;
            if (!clearBg) {
                if (info.disposal == 3) inheritFrame = ndFrameData;
                else if (info.disposal != 0 && i > 0) inheritFrame = lastFrameData;
            } else clearBg = false;
            let imageData;
            if (inheritFrame) imageData = new ImageData(new Uint8ClampedArray(inheritFrame), width, height);
            else imageData = new ImageData(width, height);
            gifReader.decodeAndBlitFrameRGBA(i, imageData.data);
            lastFrameData = imageData.data;
            if (info.disposal == 0) ndFrameData = imageData.data;
            else if (info.disposal == 2) clearBg = true;
            let bitmap = await createImageBitmap(imageData);
            $3816ae512892ed40$var$frames[i] = {
                info: info,
                bitmap: bitmap
            };
        }
        var lastFrame = gifReader.numFrames() - 1;
        inputs.frame.min = 0;
        inputs.frame.max = lastFrame;
        inputs.frame.value = 0;
        inputs.frame.disabled = false;
        inputs.endFrame.value = lastFrame;
        inputs.keepGifColors.checked = true;
    };
    reader.readAsArrayBuffer(file);
}
function $3816ae512892ed40$var$Renderer(width, height, gopts) {
    this.buffer = [];
    this.writer = new (0, $71041c0c6f4131a3$export$47e375f7f82a91ef)(this.buffer, width, height, gopts);
}
$3816ae512892ed40$var$Renderer.prototype.addFrame = function(imageData, opts) {
    let delay = opts.delay != undefined ? opts.delay : 0;
    let disposal = opts.disposal != undefined ? opts.disposal : 2;
    let keepColors = opts.keepColors;
    let x = opts.x != undefined ? opts.x : 0;
    let y = opts.y != undefined ? opts.y : 0;
    let width = imageData.width;
    let height = imageData.height;
    let palette = [];
    let indexedPixels = [];
    let transparent = $3816ae512892ed40$var$createFrame(imageData.data, palette, indexedPixels, keepColors);
    this.writer.addFrame(x, y, width, height, indexedPixels, {
        palette: palette,
        delay: delay,
        transparent: transparent,
        disposal: disposal
    });
};
$3816ae512892ed40$var$Renderer.prototype.end = function() {
    this.writer.end();
};
$3816ae512892ed40$var$Renderer.prototype.getUint8Array = function() {
    return Uint8Array.from(this.buffer);
};
function $3816ae512892ed40$var$createFrame(px, palette, indexedPixels, keepColors) {
    var transparentIndex = null;
    for(let i = 0; i < px.length; i += 4){
        let r = px[i];
        let g = px[i + 1];
        let b = px[i + 2];
        let a = px[i + 3];
        if (a == 0) {
            if (transparentIndex == null) {
                if (palette.length < 256) transparentIndex = palette.push(0) - 1;
                else {
                    indexedPixels.push(0);
                    continue;
                }
            }
            indexedPixels.push(transparentIndex);
            continue;
        }
        let rgb = ((r & 0xff) << 16) + ((g & 0xff) << 8) + (b & 0xff);
        let index, lastDiff = null;
        for(let x = 1; x < palette.length; ++x){
            // Find color in palette
            let prgb = palette[x];
            if (prgb == rgb) {
                index = x;
                lastDiff = null;
                break;
            }
            // Check if color is close
            if (!keepColors || palette.length == 256) {
                let pr = prgb >> 16 & 0xff;
                let pg = prgb >> 8 & 0xff;
                let pb = prgb & 0xff;
                let diff = Math.abs(r - pr) + Math.abs(g - pg) + Math.abs(b - pb);
                if (lastDiff == null || diff < lastDiff) {
                    index = x;
                    lastDiff = diff;
                }
            }
        }
        // Exponentially increase tolerance
        var tolerance = 15 + 40 * Math.pow(2, 10 * (palette.length / 256) - 10);
        if (palette.length != 256 && lastDiff > tolerance) index = null;
        if (!index) index = palette.push(rgb) - 1;
        indexedPixels.push(index);
    }
    if (palette.length == 256) return transparentIndex;
    // Palette length needs to be a power of 2
    // We do a *bit* of twiddling
    let v = palette.length; // max is 256 = 8 bits
    if (v < 2) v = 2;
    else {
        --v;
        v |= v >> 1;
        v |= v >> 2;
        v |= v >> 4;
        ++v;
    }
    // Pad extra values
    let needed = v - palette.length;
    for(let i = 0; i < needed; ++i)palette.push(0);
    return transparentIndex;
}
function $3816ae512892ed40$var$reset() {
    if ($3816ae512892ed40$var$frames.length) {
        $3816ae512892ed40$var$gif.frames = $3816ae512892ed40$var$frames = [];
        return true;
    }
    return false;
}
function $3816ae512892ed40$var$isAnimated() {
    return $3816ae512892ed40$var$frames.length > 1;
}
var $3816ae512892ed40$var$gif = {
    Renderer: $3816ae512892ed40$var$Renderer,
    load: $3816ae512892ed40$var$load,
    reset: $3816ae512892ed40$var$reset,
    isAnimated: $3816ae512892ed40$var$isAnimated,
    frames: $3816ae512892ed40$var$frames
};
var $3816ae512892ed40$export$2e2bcd8739ae039 = $3816ae512892ed40$var$gif;





function $81b042702cd50b64$export$f98ed0023cec5998(draw) {
    let frameRequested = false;
    return function() {
        if (frameRequested) return;
        frameRequested = true;
        window.requestAnimationFrame(function() {
            draw();
            frameRequested = false;
        });
    };
}
var $81b042702cd50b64$var$currentTouchId = null;
function $81b042702cd50b64$export$b9d4e1086abc9c4d(e) {
    var touches = e.changedTouches;
    var touch;
    if ($81b042702cd50b64$var$currentTouchId != null) {
        for(let i = 0; i < touches.length; ++i)if (touches[i].identifier == $81b042702cd50b64$var$currentTouchId) {
            touch = touches[i];
            break;
        }
    }
    var type = "";
    switch(e.type){
        case "touchstart":
            if ($81b042702cd50b64$var$currentTouchId != null || touches.length == 0) return;
            type = "mousedown";
            touch = touches[0];
            $81b042702cd50b64$var$currentTouchId = touch.identifier;
            break;
        case "touchmove":
            type = "mousemove";
            break;
        case "touchend":
            if (touch) $81b042702cd50b64$var$currentTouchId = null;
            type = "mouseup";
            break;
        default:
            return;
    }
    if (!touch) return;
    var simulatedEvent = new MouseEvent(type, {
        bubbles: true,
        cancelable: true,
        view: window,
        screenX: touch.screenX,
        screenY: touch.screenY,
        clientX: touch.clientX,
        clientY: touch.clientY,
        ctrlKey: false,
        altKey: false,
        metaKey: false,
        button: 0,
        relatedTarget: null
    });
    this.dispatchEvent(simulatedEvent);
}
function $81b042702cd50b64$export$36d6422802a3582() {}
$81b042702cd50b64$export$36d6422802a3582.prototype.create = function(name, labelKey, inputType, split) {
    if (!labelKey) labelKey = name;
    var label = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Label("");
    label.element.classList.add("menuInputBox");
    if (split) label.element.classList.add("split");
    // Wrap the label text in its own span so it can be re-translated in
    // place (via t()) without destroying the input child appended below.
    var textSpan = document.createElement("span");
    textSpan.className = "menuInputLabel";
    label.element.appendChild(textSpan);
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(textSpan, labelKey);
    var input;
    if (inputType == "color") {
        input = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Widget;
        input.element.classList.add("cpButton");
    } else {
        input = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Input(inputType);
        input.element.id = "menuInput_" + name;
        (0, $313f6ce5359206e9$export$625550452a3fa3ec)(input.element, labelKey, "aria-label");
    }
    label.appendChild(input);
    this[name] = input.element;
    return label;
};
function $81b042702cd50b64$export$95ffc9bdbe14045b(id, values) {
    var detents = document.createElement("datalist");
    detents.id = id;
    for(let i = 0; i < values.length; ++i){
        let option = document.createElement("option");
        option.value = values[i];
        detents.appendChild(option);
    }
    document.body.appendChild(detents);
    return id;
}
function $81b042702cd50b64$export$3ed9b644ed65412a(x, y, rect) {
    return x >= rect.x && y >= rect.y && x <= rect.x + rect.width && y <= rect.y + rect.height;
}
function $81b042702cd50b64$export$489c99c59eb9ceb1(x, y, cx, cy, radius) {
    return Math.pow(x - cx, 2) + Math.pow(y - cy, 2) < Math.pow(radius, 2);
}
function $81b042702cd50b64$export$98e4a82bd6040cf1(touch1, touch2) {
    return Math.hypot(touch1.pageX - touch2.pageX, touch1.pageY - touch2.pageY);
}
function $81b042702cd50b64$export$d015f26f64ff14db(ctx, x1, y1, x2, y2) {
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
}



var $63fd6a7b35566806$var$container, $63fd6a7b35566806$var$box;
var $63fd6a7b35566806$var$hslModeBtn, $63fd6a7b35566806$var$rgbModeBtn, $63fd6a7b35566806$var$hexInput, $63fd6a7b35566806$var$edButton;
var $63fd6a7b35566806$var$pickers, $63fd6a7b35566806$var$mode;
var $63fd6a7b35566806$var$currentElement, $63fd6a7b35566806$var$currentEdElement;
var $63fd6a7b35566806$var$edActive = false;
var $63fd6a7b35566806$var$modeInfo = {
    hsl: {
        maxValues: [
            360,
            100,
            100,
            255
        ],
        toCss: $63fd6a7b35566806$var$cssHsla,
        toHex: $63fd6a7b35566806$var$hslToHex,
        convFunc: $63fd6a7b35566806$var$rgbToHsl
    },
    rgb: {
        maxValues: [
            255,
            255,
            255,
            255
        ],
        toCss: $63fd6a7b35566806$var$cssRgba,
        toHex: $63fd6a7b35566806$var$rgbToHex,
        convFunc: $63fd6a7b35566806$var$hslToRgb
    }
};
var $92a41c431cb494b1$exports = {};
$92a41c431cb494b1$exports = $parcel$resolve("j5Mty");


function $63fd6a7b35566806$var$init(_container) {
    $63fd6a7b35566806$var$container = _container;
    $63fd6a7b35566806$var$box = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Floatbox;
    $63fd6a7b35566806$var$box.element.classList.add("hide");
    $63fd6a7b35566806$var$box.element.id = "colorPicker";
    var rootFlex = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox;
    rootFlex.flexDirection = "column";
    rootFlex.gap = "0.25rem";
    $63fd6a7b35566806$var$box.appendChild(rootFlex);
    var modeFlex = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox;
    modeFlex.element.style.marginBottom = "0.5rem";
    rootFlex.appendChild(modeFlex);
    $63fd6a7b35566806$var$hslModeBtn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("HSL");
    $63fd6a7b35566806$var$hslModeBtn.element.classList.add("modeBtn");
    modeFlex.appendChild($63fd6a7b35566806$var$hslModeBtn);
    $63fd6a7b35566806$var$rgbModeBtn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("RGB");
    $63fd6a7b35566806$var$rgbModeBtn.element.classList.add("modeBtn");
    modeFlex.appendChild($63fd6a7b35566806$var$rgbModeBtn);
    $63fd6a7b35566806$var$pickers = [];
    rootFlex.appendChildren([
        $63fd6a7b35566806$var$createValuePicker("H"),
        $63fd6a7b35566806$var$createValuePicker("S"),
        $63fd6a7b35566806$var$createValuePicker("L"),
        $63fd6a7b35566806$var$createValuePicker("A")
    ]);
    var hexFlex = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox;
    hexFlex.justifyContent = "center";
    hexFlex.alignItems = "center";
    hexFlex.gap = "0.5rem";
    rootFlex.appendChild(hexFlex);
    var hexLabel = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Label("Hex");
    hexFlex.appendChild(hexLabel);
    $63fd6a7b35566806$var$hexInput = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Input("text");
    $63fd6a7b35566806$var$hexInput.element.id = "colorPickerHexInput";
    $63fd6a7b35566806$var$hexInput.placeholder = "ffffff";
    $63fd6a7b35566806$var$hexInput.element.style.fontFamily = "monospace";
    hexFlex.appendChild($63fd6a7b35566806$var$hexInput);
    $63fd6a7b35566806$var$edButton = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button;
    $63fd6a7b35566806$var$edButton.element.classList.add("edButton");
    var edIcon = document.createElement("img");
    edIcon.src = new URL($92a41c431cb494b1$exports);
    edIcon.width = edIcon.height = 16;
    $63fd6a7b35566806$var$edButton.element.appendChild(edIcon);
    hexFlex.appendChild($63fd6a7b35566806$var$edButton);
    var closeBtn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(closeBtn.element, "Close");
    closeBtn.element.style.marginTop = "0.5rem";
    rootFlex.appendChild(closeBtn);
    /* Events */ $63fd6a7b35566806$var$hslModeBtn.addEventListener("click", $63fd6a7b35566806$var$setMode.bind(null, "hsl"));
    $63fd6a7b35566806$var$rgbModeBtn.addEventListener("click", $63fd6a7b35566806$var$setMode.bind(null, "rgb"));
    for(var i = 0; i < $63fd6a7b35566806$var$pickers.length; ++i){
        var p = $63fd6a7b35566806$var$pickers[i];
        p.input.addEventListener("input", function() {
            $63fd6a7b35566806$var$setInputValue(p.input, p.input.value);
            $63fd6a7b35566806$var$updateColor();
        });
        var slider = p.slider;
        slider.addEventListener("mousedown", $63fd6a7b35566806$var$sliderMouseDown.bind(p));
        document.addEventListener("mousemove", $63fd6a7b35566806$var$mouseMoveListener);
        document.addEventListener("mouseup", $63fd6a7b35566806$var$mouseUpListener);
        slider.addEventListener("touchstart", (0, $81b042702cd50b64$export$b9d4e1086abc9c4d), {
            passive: true
        });
    }
    var hexColorRegexp = /^#?[0-9A-F]{6}$/i;
    var a = $63fd6a7b35566806$var$pickers[3];
    $63fd6a7b35566806$var$hexInput.addEventListener("input", function() {
        var value = this.value;
        if (!hexColorRegexp.test(value)) return;
        if (value[0] == "#") value = value.slice(1);
        var [r, g, b] = $63fd6a7b35566806$var$hexToRgb(value);
        $63fd6a7b35566806$var$setMode("rgb");
        $63fd6a7b35566806$var$setColor(r, g, b, $63fd6a7b35566806$var$getInputValue($63fd6a7b35566806$var$pickers[3].input)); // keep alpha value
    });
    $63fd6a7b35566806$var$edButton.addEventListener("click", function() {
        $63fd6a7b35566806$var$setEyeDropperActive(!$63fd6a7b35566806$var$edActive);
    });
    closeBtn.addEventListener("click", $63fd6a7b35566806$var$hide);
    /* Init */ $63fd6a7b35566806$var$setSliderGradient(a.slider, [
        $63fd6a7b35566806$var$cssRgba(255, 255, 255, 0),
        $63fd6a7b35566806$var$cssRgba(255, 255, 255, 1)
    ]);
    $63fd6a7b35566806$var$mode = null;
}
function $63fd6a7b35566806$var$createValuePicker(text) {
    var flex = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox;
    flex.element.classList.add("valueFlex");
    var label = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Label(text);
    flex.appendChild(label);
    var slider = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Widget;
    slider.element.classList.add("slider");
    flex.appendChild(slider);
    var point = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Widget;
    point.element.classList.add("sliderPoint");
    slider.appendChild(point);
    var input = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Input("number");
    input.element.id = "colorPickerInput" + text;
    input.element.min = input.value = 0;
    flex.appendChild(input);
    $63fd6a7b35566806$var$pickers.push({
        label: label,
        slider: slider,
        point: point,
        input: input,
        num: $63fd6a7b35566806$var$pickers.length
    });
    return flex;
}
function $63fd6a7b35566806$var$setInputValue(input, value) {
    input.value = Math.round(value);
    input.element.dataset.value = value;
}
function $63fd6a7b35566806$var$getInputValue(input) {
    return +input.element.dataset.value;
}
function $63fd6a7b35566806$var$setMode(name) {
    if ($63fd6a7b35566806$var$mode == name) return;
    var prevMode = $63fd6a7b35566806$var$mode;
    $63fd6a7b35566806$var$mode = name;
    var [p0, p1, p2, p3] = $63fd6a7b35566806$var$pickers;
    var { maxValues: maxValues, convFunc: convFunc } = $63fd6a7b35566806$var$modeInfo[name];
    for(var i = 0; i < $63fd6a7b35566806$var$pickers.length; ++i){
        var p = $63fd6a7b35566806$var$pickers[i];
        p.input.element.max = maxValues[i];
        if (i < $63fd6a7b35566806$var$mode.length) p.label.text = $63fd6a7b35566806$var$mode[i].toUpperCase();
    }
    // Mode specific stuff
    if ($63fd6a7b35566806$var$mode == "hsl") {
        $63fd6a7b35566806$var$setSliderGradient(p0.slider, [
            $63fd6a7b35566806$var$cssHsla(0, 100, 50, 1),
            $63fd6a7b35566806$var$cssHsla(60, 100, 50, 1),
            $63fd6a7b35566806$var$cssHsla(120, 100, 50, 1),
            $63fd6a7b35566806$var$cssHsla(180, 100, 50, 1),
            $63fd6a7b35566806$var$cssHsla(240, 100, 50, 1),
            $63fd6a7b35566806$var$cssHsla(300, 100, 50, 1),
            $63fd6a7b35566806$var$cssHsla(360, 100, 50, 1)
        ]);
        $63fd6a7b35566806$var$hslModeBtn.element.classList.add("chosen");
        $63fd6a7b35566806$var$rgbModeBtn.element.classList.remove("chosen");
    } else if ($63fd6a7b35566806$var$mode == "rgb") {
        $63fd6a7b35566806$var$setSliderGradient(p0.slider, [
            "#000000",
            "#ff0000"
        ]);
        $63fd6a7b35566806$var$setSliderGradient(p1.slider, [
            "#000000",
            "#00ff00"
        ]);
        $63fd6a7b35566806$var$setSliderGradient(p2.slider, [
            "#000000",
            "#0000ff"
        ]);
        $63fd6a7b35566806$var$rgbModeBtn.element.classList.add("chosen");
        $63fd6a7b35566806$var$hslModeBtn.element.classList.remove("chosen");
    }
    if (prevMode) $63fd6a7b35566806$var$setColor(...convFunc($63fd6a7b35566806$var$getInputValue(p0.input), $63fd6a7b35566806$var$getInputValue(p1.input), $63fd6a7b35566806$var$getInputValue(p2.input)), $63fd6a7b35566806$var$getInputValue(p3.input));
}
function $63fd6a7b35566806$var$setSliderGradient(slider, list) {
    slider.element.style.backgroundImage = "linear-gradient(90deg," + list.join(",") + ")";
}
function $63fd6a7b35566806$var$setColor(v1, v2, v3, a) {
    if ($63fd6a7b35566806$var$mode == "hsl") {
        var [h, s, l] = $63fd6a7b35566806$var$pickers;
        $63fd6a7b35566806$var$setSliderGradient(s.slider, [
            $63fd6a7b35566806$var$cssHsla(v1, 0, v3, 1),
            $63fd6a7b35566806$var$cssHsla(v1, 100, v3, 1)
        ]);
        $63fd6a7b35566806$var$setSliderGradient(l.slider, [
            "#000000",
            $63fd6a7b35566806$var$cssHsla(v1, v2, 50, 1),
            "#ffffff"
        ]);
    }
    var { maxValues: maxValues, toCss: toCss, toHex: toHex } = $63fd6a7b35566806$var$modeInfo[$63fd6a7b35566806$var$mode];
    for(var i = 0; i < $63fd6a7b35566806$var$pickers.length; ++i){
        var p = $63fd6a7b35566806$var$pickers[i];
        $63fd6a7b35566806$var$setInputValue(p.input, arguments[i]);
        p.point.element.style.left = arguments[i] / maxValues[i] * 100 + "%";
    }
    $63fd6a7b35566806$var$hexInput.value = toHex(v1, v2, v3);
    if ($63fd6a7b35566806$var$currentElement) {
        $63fd6a7b35566806$var$currentElement.style.backgroundColor = toCss(v1, v2, v3, a / 255);
        $63fd6a7b35566806$var$currentElement.dispatchEvent(new Event("colorchange"));
    }
}
function $63fd6a7b35566806$var$updateColor() {
    var values = [];
    for(var i = 0; i < $63fd6a7b35566806$var$pickers.length; ++i)values.push($63fd6a7b35566806$var$pickers[i].input.value);
    $63fd6a7b35566806$var$setColor(...values);
}
var $63fd6a7b35566806$var$currentPicker;
function $63fd6a7b35566806$var$sliderMouseDown(e) {
    $63fd6a7b35566806$var$currentPicker = this;
    $63fd6a7b35566806$var$mouseMoveListener(e);
}
function $63fd6a7b35566806$var$mouseMoveListener(e) {
    if ($63fd6a7b35566806$var$currentPicker) {
        e.preventDefault();
        var p = $63fd6a7b35566806$var$currentPicker;
        var sliderEl = p.slider.element;
        var rect = sliderEl.getBoundingClientRect();
        var rx = Math.max(rect.left, Math.min(e.clientX, rect.right)) - rect.left;
        var max = $63fd6a7b35566806$var$modeInfo[$63fd6a7b35566806$var$mode].maxValues[p.num];
        $63fd6a7b35566806$var$setInputValue(p.input, Math.round(rx / rect.width * max));
        $63fd6a7b35566806$var$updateColor();
    }
}
function $63fd6a7b35566806$var$mouseUpListener(e) {
    $63fd6a7b35566806$var$currentPicker = null;
}
function $63fd6a7b35566806$var$show(colorEl, eyeDropEl) {
    if (!$63fd6a7b35566806$var$container.contains($63fd6a7b35566806$var$box)) {
        $63fd6a7b35566806$var$container.appendChild($63fd6a7b35566806$var$box);
        setTimeout(function() {
            $63fd6a7b35566806$var$box.element.classList.remove("hide");
        }, 0);
    }
    if (colorEl) {
        if ($63fd6a7b35566806$var$currentElement == colorEl) return;
        $63fd6a7b35566806$var$currentElement = colorEl;
        var colorCss = colorEl.style.backgroundColor;
        if (colorCss.startsWith("rgb") || colorCss[0] == "#") {
            $63fd6a7b35566806$var$setMode("rgb");
            var [r, g, b, a] = colorCss[0] == "#" ? $63fd6a7b35566806$var$hexToRgb(colorCss.slice(1)) : colorCss.replace(/(rgba?\(|\))| /g, "").split(",");
            $63fd6a7b35566806$var$setColor(r, g, b, a === undefined ? 255 : a);
        } else if (colorCss.startsWith("hsl")) {
            $63fd6a7b35566806$var$setMode("hsl");
            var [h, s, l, a] = colorCss.replace(/(hsla?\(|\))| /g, "").split(",");
            $63fd6a7b35566806$var$setColor(h, s, l, a === undefined ? 255 : a);
        }
        var rect = colorEl.getBoundingClientRect();
        var boxEl = $63fd6a7b35566806$var$box.element;
        var pickerRect = boxEl.getBoundingClientRect();
        var top = Math.max(0, Math.min(rect.top - pickerRect.height - 6, window.innerHeight - pickerRect.height));
        var left = Math.max(0, Math.min(rect.right - pickerRect.width, window.innerWidth - pickerRect.width));
        boxEl.style.top = top + "px";
        boxEl.style.left = left + "px";
        if (eyeDropEl) $63fd6a7b35566806$var$currentEdElement = eyeDropEl;
    } else {
        $63fd6a7b35566806$var$currentElement = null;
        $63fd6a7b35566806$var$setMode("hsl");
        $63fd6a7b35566806$var$setColor(0, 100, 100, 255);
    }
}
var $63fd6a7b35566806$var$hiding = false;
function $63fd6a7b35566806$var$hide() {
    if (!$63fd6a7b35566806$var$container.contains($63fd6a7b35566806$var$box) || $63fd6a7b35566806$var$hiding) return;
    $63fd6a7b35566806$var$box.element.classList.add("hide");
    $63fd6a7b35566806$var$hiding = true;
    $63fd6a7b35566806$var$container.removeChildAfterTransition($63fd6a7b35566806$var$box, function() {
        $63fd6a7b35566806$var$hiding = false;
    });
    $63fd6a7b35566806$var$currentElement = null;
    if ($63fd6a7b35566806$var$currentEdElement) {
        $63fd6a7b35566806$var$setEyeDropperActive(false);
        $63fd6a7b35566806$var$currentEdElement = null;
    }
}
function $63fd6a7b35566806$var$setEyeDropperActive(active) {
    if (!$63fd6a7b35566806$var$currentEdElement) return;
    $63fd6a7b35566806$var$edActive = active;
    if ($63fd6a7b35566806$var$edActive) {
        $63fd6a7b35566806$var$edButton.element.classList.add("active");
        $63fd6a7b35566806$var$currentEdElement.addEventListener("eyedrop", $63fd6a7b35566806$var$eyeDropListener);
    } else {
        $63fd6a7b35566806$var$edButton.element.classList.remove("active");
        $63fd6a7b35566806$var$currentEdElement.removeEventListener("eyedrop", $63fd6a7b35566806$var$eyeDropListener);
    }
    $63fd6a7b35566806$var$currentEdElement.dispatchEvent(new CustomEvent("edstatechange", {
        detail: $63fd6a7b35566806$var$edActive
    }));
}
function $63fd6a7b35566806$var$isEyeDropperActive() {
    return $63fd6a7b35566806$var$edActive;
}
function $63fd6a7b35566806$var$eyeDropListener(e) {
    if (!$63fd6a7b35566806$var$edActive) return;
    $63fd6a7b35566806$var$setMode(e.detail.mode);
    $63fd6a7b35566806$var$setColor(...e.detail.color);
    $63fd6a7b35566806$var$setEyeDropperActive(false);
}
function $63fd6a7b35566806$var$rgbToHsl(r, g, b) {
    r /= 255;
    g /= 255;
    b /= 255;
    const l = Math.max(r, g, b);
    const s = l - Math.min(r, g, b);
    const h = s ? l === r ? (g - b) / s : l === g ? 2 + (b - r) / s : 4 + (r - g) / s : 0;
    return [
        60 * h < 0 ? 60 * h + 360 : 60 * h,
        100 * (s ? l <= 0.5 ? s / (2 * l - s) : s / (2 - (2 * l - s)) : 0),
        100 * (2 * l - s) / 2
    ];
}
function $63fd6a7b35566806$var$hslToRgb(h, s, l) {
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $63fd6a7b35566806$var$numToHex(num) {
    var hex = num.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
}
function $63fd6a7b35566806$var$rgbToHex(r, g, b) {
    r = Math.floor(r);
    g = Math.floor(g);
    b = Math.floor(b);
    return $63fd6a7b35566806$var$numToHex(r) + $63fd6a7b35566806$var$numToHex(g) + $63fd6a7b35566806$var$numToHex(b);
}
function $63fd6a7b35566806$var$hslToHex(h, s, l) {
    return $63fd6a7b35566806$var$rgbToHex(...$63fd6a7b35566806$var$hslToRgb(h, s, l));
}
function $63fd6a7b35566806$var$hexToRgb(hex) {
    return [
        parseInt(hex.slice(0, 2), 16),
        parseInt(hex.slice(2, 4), 16),
        parseInt(hex.slice(4, 6), 16)
    ];
}
function $63fd6a7b35566806$var$cssRgba(r, g, b, a) {
    return "rgba(" + r + "," + g + "," + b + "," + a + ")";
}
function $63fd6a7b35566806$var$cssHsla(h, s, l, a) {
    return "hsla(" + h + "," + s + "%," + l + "%," + a + ")";
}
var $63fd6a7b35566806$var$colorPicker = {
    init: $63fd6a7b35566806$var$init,
    show: $63fd6a7b35566806$var$show,
    hide: $63fd6a7b35566806$var$hide,
    isEyeDropperActive: $63fd6a7b35566806$var$isEyeDropperActive
};
var $63fd6a7b35566806$export$2e2bcd8739ae039 = $63fd6a7b35566806$var$colorPicker;





var $8432c3b0480904ec$var$dialog, $8432c3b0480904ec$var$inputs = new (0, $81b042702cd50b64$export$36d6422802a3582);
var $8432c3b0480904ec$var$canvas = document.createElement("canvas");
var $8432c3b0480904ec$var$ctx = $8432c3b0480904ec$var$canvas.getContext("2d");
var $8432c3b0480904ec$var$imgSrc, $8432c3b0480904ec$var$callback;
var $8432c3b0480904ec$var$inputsInfo = {
    "brightness": {
        name: "Brightness",
        min: 0,
        max: 200,
        unit: "%"
    },
    "contrast": {
        name: "Contrast",
        min: 0,
        max: 200,
        unit: "%"
    },
    "hue-rotate": {
        name: "Hue",
        min: 0,
        max: 360,
        unit: "deg"
    },
    "saturate": {
        name: "Saturation",
        min: 0,
        max: 200,
        unit: "%"
    },
    "grayscale": {
        name: "Grayscale",
        min: 0,
        max: 100,
        unit: "%"
    },
    "sepia": {
        name: "Sepia",
        min: 0,
        max: 100,
        unit: "%"
    },
    "invert": {
        name: "Invert",
        min: 0,
        max: 100,
        unit: "%"
    },
    "opacity": {
        name: "Opacity",
        min: 0,
        max: 100,
        unit: "%"
    },
    "blur": {
        name: "Blur",
        min: 0,
        max: 100,
        unit: "px"
    }
};
var $8432c3b0480904ec$var$defaultInit = {
    "brightness": 100,
    "contrast": 100,
    "hue-rotate": 0,
    "saturate": 100,
    "grayscale": 0,
    "sepia": 0,
    "invert": 0,
    "opacity": 100,
    "blur": 0
};
var $8432c3b0480904ec$var$currentOptions;
function $8432c3b0480904ec$var$init(container) {
    $8432c3b0480904ec$var$dialog = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Dialog("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)($8432c3b0480904ec$var$dialog.title, "Filters");
    $8432c3b0480904ec$var$dialog.element.style.textAlign = "center";
    $8432c3b0480904ec$var$dialog.element.style.minWidth = "min(22rem, 86%)";
    container.appendChild($8432c3b0480904ec$var$dialog);
    $8432c3b0480904ec$var$canvas.style.marginTop = "0";
    $8432c3b0480904ec$var$canvas.style.marginBottom = "0.5rem";
    $8432c3b0480904ec$var$dialog.body.appendChild($8432c3b0480904ec$var$canvas);
    var detent0 = (0, $81b042702cd50b64$export$95ffc9bdbe14045b)("filterDetent0", [
        0
    ]);
    var detent100 = (0, $81b042702cd50b64$export$95ffc9bdbe14045b)("filterDetent100", [
        100
    ]);
    var inputWidgets = [];
    for(let func in $8432c3b0480904ec$var$inputsInfo){
        var info = $8432c3b0480904ec$var$inputsInfo[func];
        var widget = $8432c3b0480904ec$var$inputs.create(func, info.name, "range");
        var input = $8432c3b0480904ec$var$inputs[func];
        input.min = info.min;
        input.max = info.max;
        var defaultValue = $8432c3b0480904ec$var$defaultInit[func];
        if (defaultValue == 0) input.setAttribute("list", detent0);
        else if (defaultValue == 100) input.setAttribute("list", detent100);
        input.addEventListener("input", function() {
            $8432c3b0480904ec$var$currentOptions[func] = this.value;
            $8432c3b0480904ec$var$redrawCanvas();
        });
        inputWidgets.push(widget);
    }
    var inputsBox = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Widget;
    inputsBox.element.id = "filtersInputsBox";
    inputsBox.appendChildren(inputWidgets);
    $8432c3b0480904ec$var$dialog.appendChild(inputsBox);
    var resetBtn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(resetBtn.element, "Reset");
    resetBtn.element.style.marginRight = "auto";
    $8432c3b0480904ec$var$dialog.appendButton(resetBtn);
    var okBtn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(okBtn.element, "OK");
    $8432c3b0480904ec$var$dialog.appendButton(okBtn);
    okBtn.addEventListener("click", function() {
        $8432c3b0480904ec$var$dialog.hide();
        if ($8432c3b0480904ec$var$callback) $8432c3b0480904ec$var$callback();
    });
    resetBtn.addEventListener("click", function() {
        for(let func in $8432c3b0480904ec$var$currentOptions){
            $8432c3b0480904ec$var$inputs[func].value = $8432c3b0480904ec$var$defaultInit[func];
            delete $8432c3b0480904ec$var$currentOptions[func];
        }
        $8432c3b0480904ec$var$redrawCanvas();
    });
}
function $8432c3b0480904ec$var$drawCanvas() {
    $8432c3b0480904ec$var$ctx.clearRect(0, 0, $8432c3b0480904ec$var$canvas.width, $8432c3b0480904ec$var$canvas.height);
    $8432c3b0480904ec$var$ctx.filter = $8432c3b0480904ec$var$optionsToFilter($8432c3b0480904ec$var$currentOptions);
    $8432c3b0480904ec$var$ctx.drawImage($8432c3b0480904ec$var$imgSrc, 0, 0);
}
var $8432c3b0480904ec$var$redrawCanvas = (0, $81b042702cd50b64$export$f98ed0023cec5998)($8432c3b0480904ec$var$drawCanvas);
function $8432c3b0480904ec$var$showOptions(init, imgSrc_, callback_) {
    if (!init) {
        init = $8432c3b0480904ec$var$defaultInit;
        $8432c3b0480904ec$var$currentOptions = {};
    } else $8432c3b0480904ec$var$currentOptions = init;
    for(let func in $8432c3b0480904ec$var$inputsInfo)$8432c3b0480904ec$var$inputs[func].value = func in init ? init[func] : $8432c3b0480904ec$var$defaultInit[func];
    $8432c3b0480904ec$var$imgSrc = imgSrc_;
    $8432c3b0480904ec$var$callback = callback_;
    $8432c3b0480904ec$var$canvas.width = $8432c3b0480904ec$var$imgSrc.width;
    $8432c3b0480904ec$var$canvas.height = $8432c3b0480904ec$var$imgSrc.height;
    $8432c3b0480904ec$var$redrawCanvas();
    $8432c3b0480904ec$var$dialog.show();
}
function $8432c3b0480904ec$var$optionsToFilter(options) {
    var filter = "";
    for(let func in options){
        var value = options[func];
        if (value == $8432c3b0480904ec$var$defaultInit[func]) continue;
        var unit = $8432c3b0480904ec$var$inputsInfo[func].unit;
        filter += func + "(" + options[func] + unit + ")";
    }
    if (filter == "") filter = "none";
    return filter;
}
var $8432c3b0480904ec$var$imageFilters = {
    init: $8432c3b0480904ec$var$init,
    showOptions: $8432c3b0480904ec$var$showOptions,
    optionsToFilter: $8432c3b0480904ec$var$optionsToFilter,
    canvas: $8432c3b0480904ec$var$canvas
};
var $8432c3b0480904ec$export$2e2bcd8739ae039 = $8432c3b0480904ec$var$imageFilters;





var $87450d491c8f5778$var$dialog, $87450d491c8f5778$var$selector, $87450d491c8f5778$var$iframe, $87450d491c8f5778$var$loadNotif;
var $87450d491c8f5778$var$imgSrc, $87450d491c8f5778$var$callback;
var $87450d491c8f5778$var$defaultPage = "data:text/html;base64,PCFET0NUWVBFIGh0bWw+PGh0bWw+PGJvZHkgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6IzI1MjcyOTsiPjwvYm9keT48L2h0bWw+";
var $49cba5b2fdaf8671$exports = {};
$49cba5b2fdaf8671$exports = $parcel$resolve("gvGqy");


var $87450d491c8f5778$var$templates = {
    discord: new URL($49cba5b2fdaf8671$exports)
};
var $2f6a6737c3e350f9$exports = {};
$2f6a6737c3e350f9$exports = $parcel$resolve("YCPzX");


function $87450d491c8f5778$var$init(container) {
    $87450d491c8f5778$var$dialog = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Dialog("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)($87450d491c8f5778$var$dialog.title, "Web Preview");
    $87450d491c8f5778$var$dialog.element.id = "webPreviewDialog";
    var prompt = document.createElement("span");
    prompt.className = "webPreviewPrompt";
    $87450d491c8f5778$var$dialog.body.appendChild(prompt);
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(prompt, "Select a website:");
    container.appendChild($87450d491c8f5778$var$dialog);
    var closeBtn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(closeBtn.element, "Close");
    $87450d491c8f5778$var$dialog.appendButton(closeBtn);
    $87450d491c8f5778$var$selector = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Selector;
    $87450d491c8f5778$var$selector.element.id = "webPreviewSelector";
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)($87450d491c8f5778$var$selector.element, "Select a website", "aria-label");
    $87450d491c8f5778$var$selector.addOption("----", "placeholder", true);
    $87450d491c8f5778$var$selector.addOption("Discord", "discord");
    $87450d491c8f5778$var$selector.element.style.marginLeft = "0.5rem";
    $87450d491c8f5778$var$dialog.appendChild($87450d491c8f5778$var$selector);
    var wrapper = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Widget;
    wrapper.element.id = "previewIFrameWrapper";
    $87450d491c8f5778$var$dialog.appendChild(wrapper);
    $87450d491c8f5778$var$iframe = document.createElement("iframe");
    $87450d491c8f5778$var$iframe.id = "previewIFrame";
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)($87450d491c8f5778$var$iframe, "Web Preview", "title");
    wrapper.body.appendChild($87450d491c8f5778$var$iframe);
    $87450d491c8f5778$var$loadNotif = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Widget;
    $87450d491c8f5778$var$loadNotif.element.id = "loadNotif";
    wrapper.appendChild($87450d491c8f5778$var$loadNotif);
    var loadSpinner = document.createElement("img");
    loadSpinner.id = "loadSpinner";
    loadSpinner.src = new URL($2f6a6737c3e350f9$exports);
    loadSpinner.width = loadSpinner.height = 128;
    loadSpinner.alt = "Loading";
    $87450d491c8f5778$var$loadNotif.body.appendChild(loadSpinner);
    var loadLabel = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Label("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(loadLabel.element, "Loading...");
    $87450d491c8f5778$var$loadNotif.appendChild(loadLabel);
    closeBtn.addEventListener("click", function() {
        $87450d491c8f5778$var$dialog.hide();
        $87450d491c8f5778$var$callback();
    });
    $87450d491c8f5778$var$selector.addEventListener("change", function() {
        $87450d491c8f5778$var$loadPreview(this.value);
    });
}
function $87450d491c8f5778$var$loadPreview(site) {
    var loadNotifEl = $87450d491c8f5778$var$loadNotif.element;
    loadNotifEl.classList.add("show");
    $87450d491c8f5778$var$iframe.src = $87450d491c8f5778$var$templates[site];
    $87450d491c8f5778$var$iframe.addEventListener("load", async function() {
        if ($87450d491c8f5778$var$iframe.contentDocument) await $87450d491c8f5778$var$injectImages();
        else (0, $cff5b25a521f554e$export$2e2bcd8739ae039).show((0, $313f6ce5359206e9$export$71511d61b312f219)("Failed to load preview page."));
        loadNotifEl.classList.remove("show");
    }, {
        once: true
    });
}
function $87450d491c8f5778$var$onImageLoadOnce(img) {
    return new Promise((resolve)=>{
        img.addEventListener("load", resolve, {
            once: true
        });
    });
}
async function $87450d491c8f5778$var$injectImages() {
    var iDocument = $87450d491c8f5778$var$iframe.contentDocument;
    var list = iDocument.getElementsByClassName("avatar");
    var imgUrls = {};
    for(var i = 0; i < list.length; ++i){
        var img = list[i];
        var size = img.dataset.size;
        var src = imgUrls[size];
        if (!src) imgUrls[size] = src = await $87450d491c8f5778$var$renderScaledImage(size);
        img.src = src;
        await $87450d491c8f5778$var$onImageLoadOnce(img);
        img.draggable = false;
    }
    for(var i in imgUrls)URL.revokeObjectURL(imgUrls[i]);
}
var $87450d491c8f5778$var$renderCanvas = document.createElement("canvas");
var $87450d491c8f5778$var$renderCtx = $87450d491c8f5778$var$renderCanvas.getContext("2d");
async function $87450d491c8f5778$var$renderScaledImage(size) {
    $87450d491c8f5778$var$renderCanvas.width = $87450d491c8f5778$var$renderCanvas.height = size;
    $87450d491c8f5778$var$renderCtx.imageSmoothingQuality = "high";
    $87450d491c8f5778$var$renderCtx.drawImage($87450d491c8f5778$var$imgSrc, 0, 0, $87450d491c8f5778$var$imgSrc.width, $87450d491c8f5778$var$imgSrc.height, 0, 0, size, size);
    var blob = await new Promise((resolve)=>$87450d491c8f5778$var$renderCanvas.toBlob(resolve));
    return URL.createObjectURL(blob);
}
function $87450d491c8f5778$var$show(imgSrc_, callback_) {
    $87450d491c8f5778$var$imgSrc = imgSrc_;
    $87450d491c8f5778$var$callback = callback_;
    $87450d491c8f5778$var$selector.value = "placeholder";
    $87450d491c8f5778$var$iframe.src = $87450d491c8f5778$var$defaultPage;
    $87450d491c8f5778$var$dialog.show();
}
var $87450d491c8f5778$var$webPreview = {
    init: $87450d491c8f5778$var$init,
    show: $87450d491c8f5778$var$show
};
var $87450d491c8f5778$export$2e2bcd8739ae039 = $87450d491c8f5778$var$webPreview;



var $0544d5bc706c7688$var$container, $0544d5bc706c7688$var$box;
var $0544d5bc706c7688$var$innerBox, $0544d5bc706c7688$var$canvasBox, $0544d5bc706c7688$var$editorCanvas, $0544d5bc706c7688$var$editorCtx, $0544d5bc706c7688$var$imgCanvas, $0544d5bc706c7688$var$imgCtx;
var $0544d5bc706c7688$var$menuBox, $0544d5bc706c7688$var$inputs = new (0, $81b042702cd50b64$export$36d6422802a3582);
var $0544d5bc706c7688$var$notifBox;
var $0544d5bc706c7688$var$renderCanvas, $0544d5bc706c7688$var$renderCtx;
var $0544d5bc706c7688$var$previewBox, $0544d5bc706c7688$var$previewImages;
var $0544d5bc706c7688$var$saveAnchor = document.createElement("a");
var $0544d5bc706c7688$var$saveDialog, $0544d5bc706c7688$var$gifOptionsDialog, $0544d5bc706c7688$var$rotateDialog;
var $0544d5bc706c7688$var$cropShapes = {
    CIRCLE: 1,
    SQUARE: 2,
    FREEFORM: 3
};
var $0544d5bc706c7688$var$cropShape = $0544d5bc706c7688$var$cropShapes.CIRCLE;
var $0544d5bc706c7688$var$previewSizes = [
    128,
    64,
    32
];
function $0544d5bc706c7688$var$init(_container) {
    $0544d5bc706c7688$var$container = _container;
    $0544d5bc706c7688$var$box = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox;
    $0544d5bc706c7688$var$box.element.id = "editorBox";
    $0544d5bc706c7688$var$box.element.classList.add("hide");
    $0544d5bc706c7688$var$initInnerBox();
    $0544d5bc706c7688$var$initMenuBox();
    $0544d5bc706c7688$var$initNotifBox();
    $0544d5bc706c7688$var$initSaveDialog();
    $0544d5bc706c7688$var$initGifOptions();
    $0544d5bc706c7688$var$initRotateDialog();
    $0544d5bc706c7688$var$innerBox.addEventListener("mousedown", $0544d5bc706c7688$var$mouseDownListener);
    $0544d5bc706c7688$var$menuBox.addEventListener("mousedown", $0544d5bc706c7688$var$unfocusInnerBox);
    document.addEventListener("mousemove", $0544d5bc706c7688$var$mouseMoveListener);
    document.addEventListener("mouseup", $0544d5bc706c7688$var$mouseUpListener);
    document.addEventListener("blur", $0544d5bc706c7688$var$mouseUpListener);
    $0544d5bc706c7688$var$innerBox.addEventListener("wheel", $0544d5bc706c7688$var$wheelListener, {
        passive: true
    });
    if ("ontouchstart" in document) {
        $0544d5bc706c7688$var$innerBox.addEventListener("touchstart", $0544d5bc706c7688$var$touchStartListener, {
            passive: true
        });
        document.addEventListener("touchmove", $0544d5bc706c7688$var$touchMoveListener, {
            passive: true
        });
        document.addEventListener("touchend", $0544d5bc706c7688$var$touchEndListener, {
            passive: true
        });
    }
    document.addEventListener("keydown", $0544d5bc706c7688$var$keyDownListener);
}
function $0544d5bc706c7688$var$initInnerBox() {
    $0544d5bc706c7688$var$innerBox = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox;
    $0544d5bc706c7688$var$innerBox.element.id = "editorInnerBox";
    $0544d5bc706c7688$var$innerBox.element.style.cursor = "grab";
    $0544d5bc706c7688$var$box.appendChild($0544d5bc706c7688$var$innerBox);
    $0544d5bc706c7688$var$canvasBox = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Widget;
    $0544d5bc706c7688$var$canvasBox.element.id = "canvasBox";
    $0544d5bc706c7688$var$innerBox.appendChild($0544d5bc706c7688$var$canvasBox);
    $0544d5bc706c7688$var$imgCanvas = document.createElement("canvas");
    $0544d5bc706c7688$var$imgCanvas.id = "imgCanvas";
    $0544d5bc706c7688$var$canvasBox.body.appendChild($0544d5bc706c7688$var$imgCanvas);
    $0544d5bc706c7688$var$imgCtx = $0544d5bc706c7688$var$imgCanvas.getContext("2d");
    $0544d5bc706c7688$var$editorCanvas = document.createElement("canvas");
    $0544d5bc706c7688$var$editorCanvas.id = "editorCanvas";
    $0544d5bc706c7688$var$canvasBox.body.appendChild($0544d5bc706c7688$var$editorCanvas);
    $0544d5bc706c7688$var$editorCtx = $0544d5bc706c7688$var$editorCanvas.getContext("2d");
    $0544d5bc706c7688$var$editorCtx.lineWidth = 1;
    var fullscreenBtn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("\u26F6");
    fullscreenBtn.element.classList.add("innerBoxBtn");
    fullscreenBtn.element.title = "";
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(fullscreenBtn.element, "Toggle fullscreen", "title");
    fullscreenBtn.element.style.right = "0";
    fullscreenBtn.element.style.lineHeight = "1.4";
    $0544d5bc706c7688$var$innerBox.appendChild(fullscreenBtn);
    var tutorialBtn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("?");
    tutorialBtn.element.classList.add("innerBoxBtn");
    tutorialBtn.element.title = "";
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(tutorialBtn.element, "Show tutorial", "title");
    tutorialBtn.element.style.right = "2.5rem";
    tutorialBtn.element.style.lineHeight = "1.4";
    $0544d5bc706c7688$var$innerBox.appendChild(tutorialBtn);
    fullscreenBtn.addEventListener("click", function() {
        if (document.fullscreenElement) document.exitFullscreen();
        else document.body.requestFullscreen();
    });
    $0544d5bc706c7688$var$initTutorialDialog();
    tutorialBtn.addEventListener("click", $0544d5bc706c7688$var$showTutorialDialog);
    $0544d5bc706c7688$var$previewBox = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox;
    $0544d5bc706c7688$var$previewBox.element.id = "previewBox";
    $0544d5bc706c7688$var$previewImages = [];
    for(let i = 0; i < 3; ++i){
        var size = $0544d5bc706c7688$var$previewSizes[i];
        let container = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Widget;
        let style = container.element.style;
        style.width = style.height = size + "px";
        style.borderRadius = size / 2 + "px";
        $0544d5bc706c7688$var$previewBox.appendChild(container);
        let img = new Image;
        container.element.appendChild(img);
        $0544d5bc706c7688$var$previewImages.push(img);
    }
    $0544d5bc706c7688$var$innerBox.appendChild($0544d5bc706c7688$var$previewBox);
}
var $0544d5bc706c7688$var$tutorialDialog, $0544d5bc706c7688$var$demoVideo;
var $d7628766a082d6bb$exports = {};
$d7628766a082d6bb$exports = $parcel$resolve("1SrrK");


function $0544d5bc706c7688$var$initTutorialDialog() {
    $0544d5bc706c7688$var$tutorialDialog = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Dialog("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)($0544d5bc706c7688$var$tutorialDialog.title, "Tutorial");
    $0544d5bc706c7688$var$tutorialDialog.element.style.textAlign = "center";
    $0544d5bc706c7688$var$container.appendChild($0544d5bc706c7688$var$tutorialDialog);
    var text1 = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Label("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(text1.element, "Drag the crop selector to move or resize it.");
    $0544d5bc706c7688$var$tutorialDialog.appendChild(text1);
    $0544d5bc706c7688$var$demoVideo = document.createElement("video");
    $0544d5bc706c7688$var$demoVideo.style.pointerEvents = "none";
    $0544d5bc706c7688$var$demoVideo.style.width = "100%";
    $0544d5bc706c7688$var$demoVideo.style.marginTop = "0.5rem";
    $0544d5bc706c7688$var$demoVideo.loop = true;
    $0544d5bc706c7688$var$demoVideo.poster = new URL($d7628766a082d6bb$exports);
    $0544d5bc706c7688$var$tutorialDialog.body.appendChild($0544d5bc706c7688$var$demoVideo);
    var text2 = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Label("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(text2.element, "Dragging anywhere outside of the crop selector will move the viewport. Use the mouse wheel or pinch the screen with two fingers to zoom in/out.\nOnce you're done, press the \"Save image...\" button to save your cropped image.\n\nYou may view this tutorial at any time by pressing the \"?\" button at the top right of the screen.");
    $0544d5bc706c7688$var$tutorialDialog.appendChild(text2);
    $0544d5bc706c7688$var$tutorialDialog.appendHideButton("OK");
}
function $0544d5bc706c7688$var$showTutorialDialog() {
    if (!$0544d5bc706c7688$var$demoVideo.src) {
        $0544d5bc706c7688$var$demoVideo.src = "/assets/demo.mp4";
        $0544d5bc706c7688$var$demoVideo.play();
    }
    $0544d5bc706c7688$var$tutorialDialog.show();
}
function $0544d5bc706c7688$var$initMenuBox() {
    (0, $63fd6a7b35566806$export$2e2bcd8739ae039).init($0544d5bc706c7688$var$container);
    $0544d5bc706c7688$var$menuBox = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox;
    $0544d5bc706c7688$var$menuBox.element.id = "editorMenu";
    $0544d5bc706c7688$var$box.appendChild($0544d5bc706c7688$var$menuBox);
    var saveBtn = $0544d5bc706c7688$var$createMenuButton("Save image...");
    var saveGifBtn = $0544d5bc706c7688$var$createMenuButton("Save as GIF...");
    var fitBtn = $0544d5bc706c7688$var$createMenuButton("Fit image to viewport");
    var rotateBtn = $0544d5bc706c7688$var$createMenuButton("Rotate...");
    var shapeBtnContainer = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Widget;
    shapeBtnContainer.element.id = "shapeBtnContainer";
    var circleBtn = $0544d5bc706c7688$var$createShapeButton("Circle", "circle", true);
    var squareBtn = $0544d5bc706c7688$var$createShapeButton("Square", "square");
    var freeformBtn = $0544d5bc706c7688$var$createShapeButton("Freeform", "freeform");
    shapeBtnContainer.appendChildren([
        circleBtn,
        squareBtn,
        freeformBtn
    ]);
    $0544d5bc706c7688$var$prevShapeBtn = circleBtn.element;
    $0544d5bc706c7688$var$menuBox.appendChildren([
        /* Save */ $0544d5bc706c7688$var$createSectionTitle("Save"),
        saveBtn,
        saveGifBtn,
        /* Crop Area */ $0544d5bc706c7688$var$createSectionTitle("Crop Area"),
        $0544d5bc706c7688$var$inputs.create("width", "Width", "text", true),
        $0544d5bc706c7688$var$inputs.create("height", "Height", "text", true),
        $0544d5bc706c7688$var$inputs.create("xPos", "X Pos", "text", true),
        $0544d5bc706c7688$var$inputs.create("yPos", "Y Pos", "text", true),
        $0544d5bc706c7688$var$inputs.create("allowOffscreen", "Allow offscreen", "checkbox"),
        /* Crop Shape */ $0544d5bc706c7688$var$createSectionTitle("Crop Shape"),
        shapeBtnContainer,
        $0544d5bc706c7688$var$inputs.create("showGuidelines", "Show guidelines", "checkbox"),
        $0544d5bc706c7688$var$inputs.create("guideColor", "Guidelines color", "color"),
        /* Image */ $0544d5bc706c7688$var$createSectionTitle("Image"),
        $0544d5bc706c7688$var$inputs.create("flipH", "Flip horizontally", "checkbox"),
        $0544d5bc706c7688$var$inputs.create("flipV", "Flip vertically", "checkbox"),
        rotateBtn,
        $0544d5bc706c7688$var$inputs.create("frame", "Frame", "range"),
        $0544d5bc706c7688$var$inputs.create("playGif", "Play GIF", "checkbox"),
        $0544d5bc706c7688$var$inputs.create("bgColor", "Background color", "color"),
        /* Viewport */ $0544d5bc706c7688$var$createSectionTitle("Viewport"),
        $0544d5bc706c7688$var$inputs.create("zoom", "Zoom", "range"),
        $0544d5bc706c7688$var$inputs.create("scaleDevicePixel", "Scale to device pixel", "checkbox"),
        fitBtn,
        $0544d5bc706c7688$var$inputs.create("showPreview", "Show preview", "checkbox")
    ]);
    /* Input defaults */ $0544d5bc706c7688$var$inputs.frame.value = 0;
    $0544d5bc706c7688$var$inputs.frame.disabled = true;
    $0544d5bc706c7688$var$inputs.showPreview.checked = true;
    $0544d5bc706c7688$var$inputs.bgColor.style.backgroundColor = "rgba(255,255,255,0)";
    $0544d5bc706c7688$var$inputs.guideColor.style.backgroundColor = "rgb(255,255,0)";
    /* Other */ var returnBtn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(returnBtn.element, "Open another image");
    returnBtn.element.id = "returnBtn";
    returnBtn.element.classList.add("secondary");
    $0544d5bc706c7688$var$box.appendChild(returnBtn);
    var hideBtn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("");
    hideBtn.element.id = "hideBtn";
    $0544d5bc706c7688$var$box.appendChild(hideBtn);
    var panelHidden = false;
    function updateHideBtnLabel() {
        hideBtn.text = (0, $313f6ce5359206e9$export$71511d61b312f219)(panelHidden ? "Show panel" : "Hide panel");
    }
    updateHideBtnLabel();
    // Re-localize the state-dependent label whenever the language switches.
    window.addEventListener("i18n:change", updateHideBtnLabel);
    /* Events */ returnBtn.addEventListener("click", function() {
        history.pushState(null, "", "/");
        $0544d5bc706c7688$var$hide();
        (0, $fac49d8f1486f244$export$2e2bcd8739ae039).show();
    });
    hideBtn.addEventListener("click", function() {
        if ($0544d5bc706c7688$var$menuBox.element.style.display === "none") {
            $0544d5bc706c7688$var$menuBox.element.style.display = "";
            $0544d5bc706c7688$var$previewBox.element.classList.remove("panelHidden");
            panelHidden = false;
        } else {
            $0544d5bc706c7688$var$menuBox.element.style.display = "none";
            $0544d5bc706c7688$var$previewBox.element.classList.add("panelHidden");
            panelHidden = true;
        }
        updateHideBtnLabel();
    });
    $0544d5bc706c7688$var$inputs.width.addEventListener("input", function() {
        $0544d5bc706c7688$var$updateSizeInputValue(this, "width");
    });
    $0544d5bc706c7688$var$inputs.height.addEventListener("input", function() {
        $0544d5bc706c7688$var$updateSizeInputValue(this, "height");
    });
    $0544d5bc706c7688$var$inputs.xPos.addEventListener("input", function() {
        $0544d5bc706c7688$var$updatePosInputValue(this, "x");
    });
    $0544d5bc706c7688$var$inputs.yPos.addEventListener("input", function() {
        $0544d5bc706c7688$var$updatePosInputValue(this, "y");
    });
    $0544d5bc706c7688$var$inputs.showGuidelines.addEventListener("change", $0544d5bc706c7688$var$redrawEditor);
    $0544d5bc706c7688$var$inputs.flipH.addEventListener("change", $0544d5bc706c7688$var$updateImgRenders);
    $0544d5bc706c7688$var$inputs.flipV.addEventListener("change", $0544d5bc706c7688$var$updateImgRenders);
    var zoomDetents = (0, $81b042702cd50b64$export$95ffc9bdbe14045b)("zoomDetents", [
        50,
        100,
        200,
        400
    ]);
    var zoomInput = $0544d5bc706c7688$var$inputs.zoom;
    zoomInput.min = 10;
    zoomInput.max = 800;
    zoomInput.value = $0544d5bc706c7688$var$canvasScale;
    zoomInput.setAttribute("list", zoomDetents);
    zoomInput.addEventListener("input", function() {
        $0544d5bc706c7688$var$setCanvasScale(this.value / 100);
    });
    $0544d5bc706c7688$var$inputs.scaleDevicePixel.addEventListener("change", function() {
        $0544d5bc706c7688$var$setCanvasScale($0544d5bc706c7688$var$canvasScale);
    });
    fitBtn.addEventListener("click", function() {
        $0544d5bc706c7688$var$fitImageToViewport();
    });
    $0544d5bc706c7688$var$inputs.showPreview.addEventListener("change", function(e) {
        if (this.checked) {
            $0544d5bc706c7688$var$previewBox.element.style.display = "flex";
            $0544d5bc706c7688$var$initPreview();
        } else $0544d5bc706c7688$var$previewBox.element.style.display = "none";
    });
    rotateBtn.addEventListener("click", $0544d5bc706c7688$var$showRotateDialog);
    $0544d5bc706c7688$var$inputs.frame.addEventListener("input", function() {
        if ((0, $3816ae512892ed40$export$2e2bcd8739ae039).isAnimated()) {
            var value = this.value;
            $0544d5bc706c7688$var$img = (0, $3816ae512892ed40$export$2e2bcd8739ae039).frames[value].bitmap;
            $0544d5bc706c7688$var$updateImgRenders();
            $0544d5bc706c7688$var$showNotification((0, $313f6ce5359206e9$export$71511d61b312f219)("Frame: ") + value);
        }
    });
    saveBtn.addEventListener("click", $0544d5bc706c7688$var$showSaveDialog);
    saveGifBtn.addEventListener("click", $0544d5bc706c7688$var$showGifOptions);
    $0544d5bc706c7688$var$inputs.playGif.addEventListener("change", function() {
        if ((0, $3816ae512892ed40$export$2e2bcd8739ae039).frames.length < 2) return;
        if (this.checked) $0544d5bc706c7688$var$playNextGifFrame();
    });
    $0544d5bc706c7688$var$inputs.bgColor.addEventListener("click", function() {
        (0, $63fd6a7b35566806$export$2e2bcd8739ae039).show(this, $0544d5bc706c7688$var$imgCanvas);
    });
    $0544d5bc706c7688$var$inputs.guideColor.addEventListener("click", function() {
        (0, $63fd6a7b35566806$export$2e2bcd8739ae039).show(this, $0544d5bc706c7688$var$imgCanvas);
    });
    $0544d5bc706c7688$var$inputs.bgColor.addEventListener("colorchange", function() {
        $0544d5bc706c7688$var$redrawImgCanvas();
        var color = $0544d5bc706c7688$var$inputs.bgColor.style.backgroundColor;
        for(let i = 0; i < $0544d5bc706c7688$var$previewImages.length; ++i){
            var parentStyle = $0544d5bc706c7688$var$previewImages[i].parentNode.style;
            parentStyle.backgroundColor = color;
        }
    });
    $0544d5bc706c7688$var$inputs.guideColor.addEventListener("colorchange", $0544d5bc706c7688$var$redrawEditor);
    $0544d5bc706c7688$var$menuBox.addEventListener("scroll", (0, $63fd6a7b35566806$export$2e2bcd8739ae039).hide, {
        passive: true
    });
    $0544d5bc706c7688$var$imgCanvas.addEventListener("edstatechange", function(e) {
        if (e.detail) $0544d5bc706c7688$var$editorCanvas.style.display = "none";
        else $0544d5bc706c7688$var$editorCanvas.style.removeProperty("display");
    });
}
function $0544d5bc706c7688$var$updateSizeInputValue(input, type) {
    var value = $0544d5bc706c7688$var$parseInputValue(input);
    if (!value || value < 10) return;
    if ($0544d5bc706c7688$var$cropShape != $0544d5bc706c7688$var$cropShapes.FREEFORM) {
        $0544d5bc706c7688$var$inputs.width.value = $0544d5bc706c7688$var$inputs.height.value = value;
        $0544d5bc706c7688$var$crop.width = $0544d5bc706c7688$var$crop.height = value;
    } else $0544d5bc706c7688$var$crop[type] = value;
    $0544d5bc706c7688$var$setCropSize($0544d5bc706c7688$var$crop.width, $0544d5bc706c7688$var$crop.height);
    $0544d5bc706c7688$var$redrawEditor();
    if ($0544d5bc706c7688$var$inputs.showPreview.checked) $0544d5bc706c7688$var$updatePreview();
}
function $0544d5bc706c7688$var$updatePosInputValue(input, type) {
    var value = $0544d5bc706c7688$var$parseInputValue(input);
    if (value === undefined) return;
    $0544d5bc706c7688$var$crop[type] = value;
    $0544d5bc706c7688$var$setCropPosition($0544d5bc706c7688$var$crop.x, $0544d5bc706c7688$var$crop.y);
    $0544d5bc706c7688$var$redrawEditor();
    if ($0544d5bc706c7688$var$inputs.showPreview.checked) $0544d5bc706c7688$var$updatePreview();
}
function $0544d5bc706c7688$var$playNextGifFrame() {
    if (!$0544d5bc706c7688$var$inputs.playGif.checked) return;
    var nextFrame = ++$0544d5bc706c7688$var$inputs.frame.value;
    if (nextFrame == (0, $3816ae512892ed40$export$2e2bcd8739ae039).frames.length) $0544d5bc706c7688$var$inputs.frame.value = nextFrame = 0;
    var frame = (0, $3816ae512892ed40$export$2e2bcd8739ae039).frames[nextFrame];
    $0544d5bc706c7688$var$img = frame.bitmap;
    $0544d5bc706c7688$var$updateImgRenders();
    setTimeout($0544d5bc706c7688$var$playNextGifFrame, frame.info.delay * 10);
}
function $0544d5bc706c7688$var$createSectionTitle(textKey) {
    var title = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Label("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(title.element, textKey);
    title.element.classList.add("sectionTitle");
    return title;
}
var $0544d5bc706c7688$var$prevShapeBtn;
function $0544d5bc706c7688$var$shapeBtnHandler(value) {
    return function() {
        if ($0544d5bc706c7688$var$cropShape == value) return;
        $0544d5bc706c7688$var$cropShape = value;
        if (value != $0544d5bc706c7688$var$cropShapes.FREEFORM) $0544d5bc706c7688$var$setCropSize($0544d5bc706c7688$var$crop.width, $0544d5bc706c7688$var$crop.width);
        for(let i = 0; i < $0544d5bc706c7688$var$previewImages.length; ++i){
            let parent = $0544d5bc706c7688$var$previewImages[i].parentNode;
            parent.style.borderRadius = (value == $0544d5bc706c7688$var$cropShapes.CIRCLE ? $0544d5bc706c7688$var$previewSizes[i] : 0) + "px";
        }
        this.classList.add("chosen");
        $0544d5bc706c7688$var$prevShapeBtn.classList.remove("chosen");
        $0544d5bc706c7688$var$prevShapeBtn = this;
        $0544d5bc706c7688$var$redrawEditor();
        if ($0544d5bc706c7688$var$inputs.showPreview.checked) $0544d5bc706c7688$var$updatePreview();
    };
}
function $0544d5bc706c7688$var$parseInputValue(el) {
    if (el.value == "") return;
    var value = Number(el.value);
    if (isNaN(value)) {
        $0544d5bc706c7688$var$showNotification((0, $313f6ce5359206e9$export$71511d61b312f219)("Invalid value"));
        return;
    }
    return value;
}
function $0544d5bc706c7688$var$createMenuButton(labelKey, split, chosen) {
    var btn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(btn.element, labelKey);
    var classes = [
        "menuBtn"
    ];
    if (split) classes.push("split");
    if (chosen) classes.push("chosen");
    btn.element.classList.add(...classes);
    return btn;
}
function $0544d5bc706c7688$var$createShapeIcon(type) {
    var el = document.createElement("span");
    el.classList.add("shapeIcon", type);
    return el;
}
function $0544d5bc706c7688$var$createShapeButton(label, type, chosen) {
    var btn = $0544d5bc706c7688$var$createMenuButton(label, false, chosen);
    var icon = $0544d5bc706c7688$var$createShapeIcon(type);
    btn.element.prepend(icon);
    btn.addEventListener("click", $0544d5bc706c7688$var$shapeBtnHandler($0544d5bc706c7688$var$cropShapes[type.toUpperCase()]));
    return btn;
}
function $0544d5bc706c7688$var$initNotifBox() {
    $0544d5bc706c7688$var$notifBox = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Floatbox;
    $0544d5bc706c7688$var$notifBox.element.id = "notifBox";
    $0544d5bc706c7688$var$box.appendChild($0544d5bc706c7688$var$notifBox);
}
var $0544d5bc706c7688$var$notifTimeout = null;
function $0544d5bc706c7688$var$showNotification(text, time) {
    if ($0544d5bc706c7688$var$notifTimeout != null) clearTimeout($0544d5bc706c7688$var$notifTimeout);
    if (!time) time = 1000;
    var notifEl = $0544d5bc706c7688$var$notifBox.element;
    notifEl.innerText = text;
    notifEl.classList.add("show");
    $0544d5bc706c7688$var$notifTimeout = setTimeout(function() {
        notifEl.classList.remove("show");
        $0544d5bc706c7688$var$notifTimeout = null;
    }, time);
}
function $0544d5bc706c7688$var$initGifOptions() {
    $0544d5bc706c7688$var$gifOptionsDialog = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Dialog("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)($0544d5bc706c7688$var$gifOptionsDialog.title, "GIF Options");
    $0544d5bc706c7688$var$gifOptionsDialog.appendChildren([
        $0544d5bc706c7688$var$inputs.create("startFrame", "Start frame", "number"),
        $0544d5bc706c7688$var$inputs.create("endFrame", "End frame", "number"),
        $0544d5bc706c7688$var$inputs.create("loopCount", "Loop count", "number"),
        $0544d5bc706c7688$var$inputs.create("speedMult", "Speed multiplier", "number"),
        $0544d5bc706c7688$var$inputs.create("keepGifColors", "Keep original colors", "checkbox")
    ]);
    var filtersLabel = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Label("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(filtersLabel.element, "Filters");
    filtersLabel.element.classList.add("menuInputBox");
    $0544d5bc706c7688$var$gifOptionsDialog.appendChild(filtersLabel);
    var filtersBtn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("");
    var fxEmoji = document.createElement("span");
    fxEmoji.textContent = "\u2728 ";
    var fxText = document.createElement("span");
    filtersBtn.element.appendChild(fxEmoji);
    filtersBtn.element.appendChild(fxText);
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(fxText, "Options...");
    filtersBtn.element.style.marginLeft = "auto";
    filtersLabel.appendChild(filtersBtn);
    $0544d5bc706c7688$var$inputs.startFrame.value = $0544d5bc706c7688$var$inputs.startFrame.min = 0;
    $0544d5bc706c7688$var$inputs.endFrame.value = $0544d5bc706c7688$var$inputs.endFrame.min = 0;
    $0544d5bc706c7688$var$inputs.loopCount.value = $0544d5bc706c7688$var$inputs.loopCount.min = 0;
    $0544d5bc706c7688$var$inputs.speedMult.value = 1;
    $0544d5bc706c7688$var$inputs.speedMult.step = 0.25;
    $0544d5bc706c7688$var$inputs.speedMult.min = 0;
    $0544d5bc706c7688$var$inputs.keepGifColors.style.paddingTop = "0";
    var saveBtn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(saveBtn.element, "Save");
    $0544d5bc706c7688$var$gifOptionsDialog.appendButton(saveBtn);
    saveBtn.addEventListener("click", function() {
        $0544d5bc706c7688$var$gifOptionsDialog.hide();
        $0544d5bc706c7688$var$renderAndSaveGif();
    });
    filtersBtn.addEventListener("click", function() {
        $0544d5bc706c7688$var$gifOptionsDialog.hide();
        // Render a static image for the image filters canvas
        $0544d5bc706c7688$var$render();
        (0, $8432c3b0480904ec$export$2e2bcd8739ae039).showOptions($0544d5bc706c7688$var$gifFilters, $0544d5bc706c7688$var$renderCanvas, function() {
            $0544d5bc706c7688$var$gifOptionsDialog.show();
        });
    });
    $0544d5bc706c7688$var$gifOptionsDialog.appendHideButton("Cancel", "secondary");
    $0544d5bc706c7688$var$container.appendChild($0544d5bc706c7688$var$gifOptionsDialog);
}
var $0544d5bc706c7688$var$gifFilters;
function $0544d5bc706c7688$var$showGifOptions() {
    $0544d5bc706c7688$var$gifFilters = {};
    $0544d5bc706c7688$var$gifOptionsDialog.show();
}
function $0544d5bc706c7688$var$initSaveDialog() {
    (0, $8432c3b0480904ec$export$2e2bcd8739ae039).init($0544d5bc706c7688$var$container);
    (0, $87450d491c8f5778$export$2e2bcd8739ae039).init($0544d5bc706c7688$var$container);
    $0544d5bc706c7688$var$saveDialog = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Dialog("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)($0544d5bc706c7688$var$saveDialog.title, "Save Image");
    $0544d5bc706c7688$var$saveDialog.element.id = "saveDialog";
    $0544d5bc706c7688$var$container.appendChild($0544d5bc706c7688$var$saveDialog);
    var label = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Label("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(label.element, "You can save the image now, or apply some filters and check how your avatar would look on some websites.");
    $0544d5bc706c7688$var$saveDialog.appendChild(label);
    $0544d5bc706c7688$var$saveDialog.body.appendChild(document.createElement("br"));
    $0544d5bc706c7688$var$renderCanvas = document.createElement("canvas");
    $0544d5bc706c7688$var$renderCtx = $0544d5bc706c7688$var$renderCanvas.getContext("2d", {
        willReadFrequently: true
    });
    $0544d5bc706c7688$var$saveDialog.body.appendChild($0544d5bc706c7688$var$renderCanvas);
    var actionsContainer = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Widget;
    actionsContainer.element.id = "imgActionsContainer";
    $0544d5bc706c7688$var$saveDialog.appendChild(actionsContainer);
    var filtersBtn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("");
    var flEmoji = document.createElement("span");
    flEmoji.textContent = "\u2728 ";
    var flText = document.createElement("span");
    filtersBtn.element.appendChild(flEmoji);
    filtersBtn.element.appendChild(flText);
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(flText, "Filters...");
    actionsContainer.appendChild(filtersBtn);
    var previewBtn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("");
    var pvEmoji = document.createElement("span");
    pvEmoji.textContent = "\uD83D\uDDBC\uFE0F ";
    var pvText = document.createElement("span");
    previewBtn.element.appendChild(pvEmoji);
    previewBtn.element.appendChild(pvText);
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(pvText, "Preview...");
    actionsContainer.appendChild(previewBtn);
    var saveBtn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(saveBtn.element, "Save");
    $0544d5bc706c7688$var$saveDialog.appendButton(saveBtn);
    var closeBtn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(closeBtn.element, "Close");
    closeBtn.element.classList.add("secondary");
    $0544d5bc706c7688$var$saveDialog.appendButton(closeBtn);
    saveBtn.addEventListener("click", $0544d5bc706c7688$var$saveImage);
    closeBtn.addEventListener("click", function() {
        $0544d5bc706c7688$var$saveDialog.hide();
    });
    filtersBtn.addEventListener("click", function() {
        $0544d5bc706c7688$var$saveDialog.hide();
        (0, $8432c3b0480904ec$export$2e2bcd8739ae039).showOptions(null, $0544d5bc706c7688$var$renderCanvas, function() {
            $0544d5bc706c7688$var$renderCtx.clearRect(0, 0, $0544d5bc706c7688$var$crop.width, $0544d5bc706c7688$var$crop.height);
            $0544d5bc706c7688$var$renderCtx.drawImage((0, $8432c3b0480904ec$export$2e2bcd8739ae039).canvas, 0, 0);
            $0544d5bc706c7688$var$saveDialog.show();
        });
    });
    previewBtn.addEventListener("click", function() {
        $0544d5bc706c7688$var$saveDialog.hide();
        (0, $87450d491c8f5778$export$2e2bcd8739ae039).show($0544d5bc706c7688$var$renderCanvas, function() {
            $0544d5bc706c7688$var$saveDialog.show();
        });
    });
}
function $0544d5bc706c7688$var$showSaveDialog() {
    $0544d5bc706c7688$var$render();
    $0544d5bc706c7688$var$saveDialog.show();
}
var $0544d5bc706c7688$var$rotateCanvas, $0544d5bc706c7688$var$rotateCtx, $0544d5bc706c7688$var$rotateSlider, $0544d5bc706c7688$var$angleLabel;
function $0544d5bc706c7688$var$initRotateDialog() {
    $0544d5bc706c7688$var$rotateDialog = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Dialog("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)($0544d5bc706c7688$var$rotateDialog.title, "Rotate");
    $0544d5bc706c7688$var$rotateDialog.element.style.textAlign = "center";
    $0544d5bc706c7688$var$container.appendChild($0544d5bc706c7688$var$rotateDialog);
    $0544d5bc706c7688$var$rotateCanvas = document.createElement("canvas");
    $0544d5bc706c7688$var$rotateCanvas.id = "rotateCanvas";
    $0544d5bc706c7688$var$rotateCtx = $0544d5bc706c7688$var$rotateCanvas.getContext("2d");
    $0544d5bc706c7688$var$rotateDialog.body.appendChild($0544d5bc706c7688$var$rotateCanvas);
    $0544d5bc706c7688$var$angleLabel = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Label("0\xb0");
    $0544d5bc706c7688$var$rotateDialog.appendChild($0544d5bc706c7688$var$angleLabel);
    var rotateDetents = (0, $81b042702cd50b64$export$95ffc9bdbe14045b)("rotateDetents", [
        90,
        180,
        270
    ]);
    $0544d5bc706c7688$var$rotateSlider = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Input("range");
    $0544d5bc706c7688$var$rotateSlider.element.id = "rotateSlider";
    $0544d5bc706c7688$var$rotateSlider.element.style.width = "100%";
    $0544d5bc706c7688$var$rotateSlider.min = 0;
    $0544d5bc706c7688$var$rotateSlider.max = 360;
    $0544d5bc706c7688$var$rotateSlider.step = 0.1;
    $0544d5bc706c7688$var$rotateSlider.value = 0;
    $0544d5bc706c7688$var$rotateSlider.element.setAttribute("list", rotateDetents);
    $0544d5bc706c7688$var$rotateSlider.element.setAttribute("aria-label", "");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)($0544d5bc706c7688$var$rotateSlider.element, "Rotation angle", "aria-label");
    $0544d5bc706c7688$var$rotateDialog.appendChild($0544d5bc706c7688$var$rotateSlider);
    var applyBtn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(applyBtn.element, "Apply");
    $0544d5bc706c7688$var$rotateDialog.appendButton(applyBtn);
    applyBtn.addEventListener("click", function() {
        $0544d5bc706c7688$var$rotateDialog.hide();
        $0544d5bc706c7688$var$openRotatedImg($0544d5bc706c7688$var$rotateSlider.value);
    });
    $0544d5bc706c7688$var$rotateDialog.appendHideButton("Cancel", "secondary");
    $0544d5bc706c7688$var$rotateSlider.addEventListener("input", function() {
        $0544d5bc706c7688$var$angleLabel.text = this.value + "\xb0";
        $0544d5bc706c7688$var$rotateCanvas.style.transform = "rotate(" + this.value + "deg)";
    });
}
var $0544d5bc706c7688$var$origImg, $0544d5bc706c7688$var$origFrames, $0544d5bc706c7688$var$rotateCanvasInit;
function $0544d5bc706c7688$var$showRotateDialog() {
    if ($0544d5bc706c7688$var$rotateCanvasInit) {
        var src = (0, $3816ae512892ed40$export$2e2bcd8739ae039).isAnimated() ? (0, $3816ae512892ed40$export$2e2bcd8739ae039).frames[0].bitmap : $0544d5bc706c7688$var$img;
        $0544d5bc706c7688$var$rotateCanvas.width = src.width;
        $0544d5bc706c7688$var$rotateCanvas.height = src.height;
        $0544d5bc706c7688$var$rotateCtx.drawImage(src, 0, 0);
        $0544d5bc706c7688$var$rotateCanvasInit = false;
    }
    $0544d5bc706c7688$var$rotateDialog.show();
}
function $0544d5bc706c7688$var$renderRotatedImg(src, angle) {
    var w = src.width;
    var h = src.height;
    var absSin = Math.abs(Math.sin(angle));
    var absCos = Math.abs(Math.cos(angle));
    var rw = Math.ceil(w * absCos + h * absSin);
    var rh = Math.ceil(w * absSin + h * absCos);
    $0544d5bc706c7688$var$renderCanvas.width = rw;
    $0544d5bc706c7688$var$renderCanvas.height = rh;
    $0544d5bc706c7688$var$renderCtx.translate(rw / 2, rh / 2);
    $0544d5bc706c7688$var$renderCtx.rotate(angle);
    $0544d5bc706c7688$var$renderCtx.drawImage(src, -w / 2, -h / 2);
    return createImageBitmap($0544d5bc706c7688$var$renderCtx.getImageData(0, 0, rw, rh));
}
async function $0544d5bc706c7688$var$openRotatedImg(angle) {
    if (angle != 0 && angle != 360) {
        angle = angle * Math.PI / 180;
        if ((0, $3816ae512892ed40$export$2e2bcd8739ae039).isAnimated()) {
            if (!$0544d5bc706c7688$var$origFrames) $0544d5bc706c7688$var$origFrames = (0, $3816ae512892ed40$export$2e2bcd8739ae039).frames;
            var frames = [];
            for(var i = 0; i < $0544d5bc706c7688$var$origFrames.length; ++i){
                var { info: info, bitmap: bitmap } = $0544d5bc706c7688$var$origFrames[i];
                var rotBitmap = await $0544d5bc706c7688$var$renderRotatedImg(bitmap, angle);
                frames[i] = {
                    info: info,
                    bitmap: rotBitmap
                };
            }
            (0, $3816ae512892ed40$export$2e2bcd8739ae039).frames = frames;
        } else {
            if (!$0544d5bc706c7688$var$origImg) $0544d5bc706c7688$var$origImg = $0544d5bc706c7688$var$img;
            $0544d5bc706c7688$var$img = await $0544d5bc706c7688$var$renderRotatedImg($0544d5bc706c7688$var$origImg, angle);
        }
    } else if ($0544d5bc706c7688$var$origImg) {
        $0544d5bc706c7688$var$img = $0544d5bc706c7688$var$origImg;
        $0544d5bc706c7688$var$origImg = null;
    } else if ($0544d5bc706c7688$var$origFrames) {
        (0, $3816ae512892ed40$export$2e2bcd8739ae039).frames = $0544d5bc706c7688$var$origFrames;
        $0544d5bc706c7688$var$origFrames = null;
    } else return;
    if ((0, $3816ae512892ed40$export$2e2bcd8739ae039).isAnimated()) {
        var currentFrame = $0544d5bc706c7688$var$inputs.frame.value;
        $0544d5bc706c7688$var$img = (0, $3816ae512892ed40$export$2e2bcd8739ae039).frames[currentFrame].bitmap;
    }
    $0544d5bc706c7688$var$setMainCanvasesSize($0544d5bc706c7688$var$img.width, $0544d5bc706c7688$var$img.height);
    $0544d5bc706c7688$var$editorCanvasInit = true;
    $0544d5bc706c7688$var$show();
    $0544d5bc706c7688$var$reset();
}
function $0544d5bc706c7688$var$setMainCanvasesSize(w, h) {
    $0544d5bc706c7688$var$imgCanvas.width = $0544d5bc706c7688$var$editorCanvas.width = $0544d5bc706c7688$var$previewCanvas.width = w;
    $0544d5bc706c7688$var$imgCanvas.height = $0544d5bc706c7688$var$editorCanvas.height = $0544d5bc706c7688$var$previewCanvas.height = h;
}
var $0544d5bc706c7688$var$img;
var $0544d5bc706c7688$var$usingObjectUrl = false;
var $0544d5bc706c7688$var$currentName;
function $0544d5bc706c7688$var$open(src, successCb) {
    if ($0544d5bc706c7688$var$usingObjectUrl) {
        URL.revokeObjectURL($0544d5bc706c7688$var$origImg ? $0544d5bc706c7688$var$origImg.src : $0544d5bc706c7688$var$img.src);
        $0544d5bc706c7688$var$usingObjectUrl = false;
    }
    $0544d5bc706c7688$var$origImg = $0544d5bc706c7688$var$origFrames = null;
    if ((0, $3816ae512892ed40$export$2e2bcd8739ae039).reset()) {
        $0544d5bc706c7688$var$inputs.frame.value = 0;
        $0544d5bc706c7688$var$inputs.frame.disabled = true;
        $0544d5bc706c7688$var$inputs.startFrame.value = 0;
        $0544d5bc706c7688$var$inputs.endFrame.value = 0;
        $0544d5bc706c7688$var$inputs.loopCount.value = 0;
        $0544d5bc706c7688$var$inputs.keepGifColors.checked = false;
        $0544d5bc706c7688$var$inputs.playGif.checked = false;
    }
    (0, $4244c5b4a8c0a9c7$export$2e2bcd8739ae039).setProgress(-1);
    (0, $4244c5b4a8c0a9c7$export$2e2bcd8739ae039).show();
    if (src instanceof File) {
        $0544d5bc706c7688$var$currentName = src.name.slice(0, src.name.lastIndexOf("."));
        if (src.type == "image/gif") (0, $3816ae512892ed40$export$2e2bcd8739ae039).load(src, $0544d5bc706c7688$var$inputs);
        src = URL.createObjectURL(src);
        $0544d5bc706c7688$var$usingObjectUrl = true;
    } else {
        if (src == "") return;
        if ($0544d5bc706c7688$var$img && src == $0544d5bc706c7688$var$img.src) {
            (0, $4244c5b4a8c0a9c7$export$2e2bcd8739ae039).hide();
            $0544d5bc706c7688$var$show();
            $0544d5bc706c7688$var$reset();
            successCb();
            return;
        }
        $0544d5bc706c7688$var$currentName = src.slice(src.lastIndexOf("/") + 1, src.lastIndexOf("."));
    }
    if (!($0544d5bc706c7688$var$img instanceof Image)) $0544d5bc706c7688$var$img = new Image;
    var loadCb, errorCb;
    $0544d5bc706c7688$var$img.addEventListener("load", loadCb = function() {
        (0, $4244c5b4a8c0a9c7$export$2e2bcd8739ae039).setProgress(1);
        (0, $4244c5b4a8c0a9c7$export$2e2bcd8739ae039).hide();
        $0544d5bc706c7688$var$setMainCanvasesSize($0544d5bc706c7688$var$img.width, $0544d5bc706c7688$var$img.height);
        $0544d5bc706c7688$var$editorCanvasInit = true;
        $0544d5bc706c7688$var$rotateSlider.value = 0;
        $0544d5bc706c7688$var$angleLabel.text = "0\xb0";
        $0544d5bc706c7688$var$rotateCanvas.style.transform = "";
        $0544d5bc706c7688$var$rotateCanvasInit = true;
        $0544d5bc706c7688$var$show();
        $0544d5bc706c7688$var$reset();
        successCb();
        $0544d5bc706c7688$var$img.removeEventListener("load", loadCb);
        $0544d5bc706c7688$var$img.removeEventListener("error", errorCb);
    });
    $0544d5bc706c7688$var$img.addEventListener("error", errorCb = function() {
        (0, $4244c5b4a8c0a9c7$export$2e2bcd8739ae039).hide();
        (0, $cff5b25a521f554e$export$2e2bcd8739ae039).show((0, $313f6ce5359206e9$export$71511d61b312f219)("Failed to load image."));
        $0544d5bc706c7688$var$img.removeEventListener("load", loadCb);
        $0544d5bc706c7688$var$img.removeEventListener("error", errorCb);
    });
    $0544d5bc706c7688$var$img.src = src;
}
function $0544d5bc706c7688$var$show() {
    $0544d5bc706c7688$var$container.appendChild($0544d5bc706c7688$var$box);
    setTimeout(function() {
        $0544d5bc706c7688$var$box.element.classList.remove("hide");
    }, 0);
    if (!localStorage.getItem("tutorialShown")) {
        $0544d5bc706c7688$var$showTutorialDialog();
        localStorage.setItem("tutorialShown", "true");
    }
}
function $0544d5bc706c7688$var$hide() {
    if ($0544d5bc706c7688$var$isHidden()) return;
    $0544d5bc706c7688$var$box.element.classList.add("hide");
    var currentBox = $0544d5bc706c7688$var$box;
    var onEnd = function(e) {
        if (e.target !== currentBox.element) return;
        currentBox.element.removeEventListener("transitionend", onEnd);
        if (!currentBox.element.classList.contains("hide")) return;
        if ($0544d5bc706c7688$var$container.contains(currentBox)) $0544d5bc706c7688$var$container.removeChild(currentBox);
    };
    currentBox.element.addEventListener("transitionend", onEnd);
    (0, $63fd6a7b35566806$export$2e2bcd8739ae039).hide();
    $0544d5bc706c7688$var$inputs.playGif.checked = false;
}
function $0544d5bc706c7688$var$isHidden() {
    return $0544d5bc706c7688$var$box.element.classList.contains("hide");
}
function $0544d5bc706c7688$var$reset() {
    $0544d5bc706c7688$var$fitImageToViewport();
    $0544d5bc706c7688$var$resetCropArea();
    $0544d5bc706c7688$var$inputs.flipH.checked = $0544d5bc706c7688$var$inputs.flipV.checked = false;
    $0544d5bc706c7688$var$redrawEditor();
    $0544d5bc706c7688$var$updateImgRenders();
}
function $0544d5bc706c7688$var$resetCropArea() {
    var s = Math.floor(($0544d5bc706c7688$var$img.width < $0544d5bc706c7688$var$img.height ? $0544d5bc706c7688$var$img.width : $0544d5bc706c7688$var$img.height) * 0.5);
    s -= s % 10;
    $0544d5bc706c7688$var$crop.x = $0544d5bc706c7688$var$crop.y = 0;
    $0544d5bc706c7688$var$setCropSize(s, s);
    $0544d5bc706c7688$var$setCropPosition(0, 0);
}
function $0544d5bc706c7688$var$fitImageToViewport() {
    var innerEl = $0544d5bc706c7688$var$innerBox.element;
    var vpWidth = innerEl.offsetWidth;
    var vpHeight = innerEl.offsetHeight;
    var vpAspectRatio = vpWidth / vpHeight;
    var imgAspectRatio = $0544d5bc706c7688$var$img.width / $0544d5bc706c7688$var$img.height;
    var ratio = $0544d5bc706c7688$var$inputs.scaleDevicePixel.checked ? 1 : devicePixelRatio;
    $0544d5bc706c7688$var$setCanvasScale((vpAspectRatio > imgAspectRatio ? vpHeight / $0544d5bc706c7688$var$img.height : vpWidth / $0544d5bc706c7688$var$img.width) * ratio);
    $0544d5bc706c7688$var$setCanvasMargins(0, 0);
}
function $0544d5bc706c7688$var$setCropPosition(x, y) {
    if (!$0544d5bc706c7688$var$inputs.allowOffscreen.checked) {
        x = Math.max(0, Math.min(x, $0544d5bc706c7688$var$img.width - $0544d5bc706c7688$var$crop.width));
        y = Math.max(0, Math.min(y, $0544d5bc706c7688$var$img.height - $0544d5bc706c7688$var$crop.height));
    }
    $0544d5bc706c7688$var$crop.x = x;
    $0544d5bc706c7688$var$crop.y = y;
    $0544d5bc706c7688$var$inputs.xPos.value = x;
    $0544d5bc706c7688$var$inputs.yPos.value = y;
}
function $0544d5bc706c7688$var$setCropSize(width, height, preferHigher) {
    if (!$0544d5bc706c7688$var$inputs.allowOffscreen.checked) {
        width = Math.min(width, $0544d5bc706c7688$var$img.width - $0544d5bc706c7688$var$crop.x);
        height = Math.min(height, $0544d5bc706c7688$var$img.height - $0544d5bc706c7688$var$crop.y);
    }
    var min = $0544d5bc706c7688$var$img.width < 50 || $0544d5bc706c7688$var$img.height < 50 ? 1 : 10;
    width = Math.max(min, width);
    height = Math.max(min, height);
    if ($0544d5bc706c7688$var$cropShape != $0544d5bc706c7688$var$cropShapes.FREEFORM) {
        if (preferHigher ? width > height : width < height) height = width;
        else width = height;
    }
    $0544d5bc706c7688$var$crop.width = width;
    $0544d5bc706c7688$var$crop.height = height;
    $0544d5bc706c7688$var$inputs.width.value = width;
    $0544d5bc706c7688$var$inputs.height.value = height;
}
var $0544d5bc706c7688$var$canvasX = 0, $0544d5bc706c7688$var$canvasY = 0;
function $0544d5bc706c7688$var$setCanvasMargins(x, y) {
    $0544d5bc706c7688$var$canvasX = x;
    $0544d5bc706c7688$var$canvasY = y;
    var element = $0544d5bc706c7688$var$canvasBox.element;
    element.style.marginLeft = $0544d5bc706c7688$var$canvasX + "px";
    element.style.marginTop = $0544d5bc706c7688$var$canvasY + "px";
}
var $0544d5bc706c7688$var$canvasScale = 1;
function $0544d5bc706c7688$var$setCanvasScale(scale) {
    var ratio = $0544d5bc706c7688$var$inputs.scaleDevicePixel.checked ? 1 : devicePixelRatio;
    scale = Math.round(Math.max(0.1, Math.min(scale, 8)) * 1000) / 1000;
    var realScale = scale / ratio;
    /*
        from a certain chromium version, images with a high resolution will
        get cropped off when using scale()
    */ //canvasBox.element.style.transform = "scale(" + realScale.toFixed(3) + ")";
    // Workaround
    var displayWidth = $0544d5bc706c7688$var$img.width * realScale + "px";
    var displayHeight = $0544d5bc706c7688$var$img.height * realScale + "px";
    var canvasBoxStyle = $0544d5bc706c7688$var$canvasBox.element.style;
    canvasBoxStyle.width = canvasBoxStyle.minWidth = displayWidth;
    canvasBoxStyle.height = canvasBoxStyle.minHeight = displayHeight;
    $0544d5bc706c7688$var$inputs.zoom.value = Math.round(scale * 100);
    var newLineWidth = Math.ceil(Math.max(1, 1 / (realScale * devicePixelRatio)));
    if (newLineWidth != $0544d5bc706c7688$var$editorCtx.lineWidth) {
        $0544d5bc706c7688$var$editorCtx.lineWidth = newLineWidth;
        $0544d5bc706c7688$var$redrawEditor();
    }
    var mScale = scale / $0544d5bc706c7688$var$canvasScale;
    $0544d5bc706c7688$var$setCanvasMargins($0544d5bc706c7688$var$canvasX * mScale, $0544d5bc706c7688$var$canvasY * mScale);
    $0544d5bc706c7688$var$canvasScale = scale;
    $0544d5bc706c7688$var$showNotification((0, $313f6ce5359206e9$export$71511d61b312f219)("Zoom: ") + +(scale * 100).toFixed(1) + "%");
}
function $0544d5bc706c7688$var$applyFlipTransform(canvas, ctx) {
    var flipH = $0544d5bc706c7688$var$inputs.flipH.checked;
    var flipV = $0544d5bc706c7688$var$inputs.flipV.checked;
    var sx = 1, sy = 1;
    if (flipH) {
        ctx.translate(canvas.width, 0);
        sx = -1;
    }
    if (flipV) {
        ctx.translate(0, canvas.height);
        sy = -1;
    }
    ctx.scale(sx, sy);
}
var $0544d5bc706c7688$var$crop = {
    x: 0,
    y: 0,
    width: 0,
    height: 0
};
var $0544d5bc706c7688$var$prevRect;
var $0544d5bc706c7688$var$editorCanvasInit = false;
function $0544d5bc706c7688$var$drawEditor() {
    var ctx = $0544d5bc706c7688$var$editorCtx;
    ctx.globalCompositeOperation = "source-over";
    // Draw the mask
    var maskRect;
    if ($0544d5bc706c7688$var$editorCanvasInit) {
        maskRect = [
            0,
            0,
            $0544d5bc706c7688$var$editorCanvas.width,
            $0544d5bc706c7688$var$editorCanvas.height
        ];
        $0544d5bc706c7688$var$editorCanvasInit = false;
    } else {
        maskRect = $0544d5bc706c7688$var$prevRect;
        ctx.clearRect(...maskRect);
    }
    ctx.fillStyle = "rgba(0,0,0,0.5)";
    ctx.fillRect(...maskRect);
    // Draw the crop selector
    var lw = ctx.lineWidth;
    var x = $0544d5bc706c7688$var$crop.x - lw / 2, y = $0544d5bc706c7688$var$crop.y - lw / 2, width = $0544d5bc706c7688$var$crop.width + lw, height = $0544d5bc706c7688$var$crop.height + lw;
    var cx, cy;
    ctx.strokeStyle = "#ffffff";
    if ($0544d5bc706c7688$var$cropShape == $0544d5bc706c7688$var$cropShapes.CIRCLE) {
        ctx.strokeRect(x, y, width, height);
        cx = $0544d5bc706c7688$var$crop.x + $0544d5bc706c7688$var$crop.width / 2;
        cy = $0544d5bc706c7688$var$crop.y + $0544d5bc706c7688$var$crop.height / 2;
        ctx.beginPath();
        ctx.arc(cx, cy, width / 2 - lw / 2, 0, 2 * Math.PI);
    } else {
        ctx.beginPath();
        ctx.rect(x, y, width, height);
    }
    // Save the path, draw the outline, then poke the hole
    ctx.save();
    ctx.stroke();
    ctx.restore();
    ctx.globalCompositeOperation = "destination-out";
    ctx.fillStyle = "#000000";
    ctx.fill();
    // Draw guidelines
    if ($0544d5bc706c7688$var$inputs.showGuidelines.checked) {
        ctx.globalCompositeOperation = "source-over";
        ctx.setLineDash([
            10,
            10
        ]);
        ctx.strokeStyle = $0544d5bc706c7688$var$inputs.guideColor.style.backgroundColor;
        ctx.lineWidth += 1 + Math.floor($0544d5bc706c7688$var$crop.width * $0544d5bc706c7688$var$crop.height / 1000000);
        if (cx === undefined) {
            cx = $0544d5bc706c7688$var$crop.x + $0544d5bc706c7688$var$crop.width / 2;
            cy = $0544d5bc706c7688$var$crop.y + $0544d5bc706c7688$var$crop.height / 2;
        }
        var right = $0544d5bc706c7688$var$crop.x + $0544d5bc706c7688$var$crop.width;
        var bottom = $0544d5bc706c7688$var$crop.y + $0544d5bc706c7688$var$crop.height;
        ctx.beginPath();
        (0, $81b042702cd50b64$export$d015f26f64ff14db)(ctx, cx, cy, cx, $0544d5bc706c7688$var$crop.y); // top
        (0, $81b042702cd50b64$export$d015f26f64ff14db)(ctx, cx, cy, $0544d5bc706c7688$var$crop.x, cy); // left
        (0, $81b042702cd50b64$export$d015f26f64ff14db)(ctx, cx, cy, cx, bottom); // bottom
        (0, $81b042702cd50b64$export$d015f26f64ff14db)(ctx, cx, cy, right, cy); // right
        ctx.stroke();
        ctx.setLineDash([]);
        ctx.lineWidth = lw;
    }
    $0544d5bc706c7688$var$prevRect = [
        $0544d5bc706c7688$var$crop.x - lw,
        $0544d5bc706c7688$var$crop.y - lw,
        $0544d5bc706c7688$var$crop.width + lw * 2,
        $0544d5bc706c7688$var$crop.height + lw * 2
    ];
}
function $0544d5bc706c7688$var$drawImgCanvas() {
    var ctx = $0544d5bc706c7688$var$imgCtx;
    ctx.clearRect(0, 0, $0544d5bc706c7688$var$img.width, $0544d5bc706c7688$var$img.height);
    ctx.fillStyle = $0544d5bc706c7688$var$inputs.bgColor.style.backgroundColor;
    ctx.fillRect(0, 0, $0544d5bc706c7688$var$img.width, $0544d5bc706c7688$var$img.height);
    $0544d5bc706c7688$var$applyFlipTransform($0544d5bc706c7688$var$imgCanvas, ctx);
    ctx.drawImage($0544d5bc706c7688$var$img, 0, 0, $0544d5bc706c7688$var$img.width, $0544d5bc706c7688$var$img.height);
    ctx.resetTransform();
}
var $0544d5bc706c7688$var$redrawEditor = (0, $81b042702cd50b64$export$f98ed0023cec5998)($0544d5bc706c7688$var$drawEditor);
var $0544d5bc706c7688$var$redrawImgCanvas = (0, $81b042702cd50b64$export$f98ed0023cec5998)($0544d5bc706c7688$var$drawImgCanvas);
var $0544d5bc706c7688$var$pvRedrawing = false;
var $0544d5bc706c7688$var$pvRedrawNext = false;
async function $0544d5bc706c7688$var$redrawPreview() {
    if ($0544d5bc706c7688$var$pvRedrawing) {
        $0544d5bc706c7688$var$pvRedrawNext = true;
        return;
    }
    $0544d5bc706c7688$var$pvRedrawing = true;
    var flipH = $0544d5bc706c7688$var$inputs.flipH.checked;
    var flipV = $0544d5bc706c7688$var$inputs.flipV.checked;
    var src, isBlob;
    if ((0, $3816ae512892ed40$export$2e2bcd8739ae039).isAnimated() || flipH || flipV || !($0544d5bc706c7688$var$img instanceof Image)) {
        // Use the image data of the rendered ImageBitmap
        var blob = await $0544d5bc706c7688$var$renderPreviewImg();
        src = URL.createObjectURL(blob);
        isBlob = true;
    } else // Load the image directly if it's not an ANIMATED gif and there are no image modifications
    // (except for background color)
    src = $0544d5bc706c7688$var$img.src;
    let count = 0;
    for(let i = 0; i < $0544d5bc706c7688$var$previewImages.length; ++i){
        var pImage = $0544d5bc706c7688$var$previewImages[i];
        pImage.addEventListener("load", function() {
            if (++count == $0544d5bc706c7688$var$previewImages.length) {
                $0544d5bc706c7688$var$pvRedrawing = false;
                if (isBlob) URL.revokeObjectURL(src);
                if ($0544d5bc706c7688$var$pvRedrawNext) {
                    $0544d5bc706c7688$var$pvRedrawNext = false;
                    $0544d5bc706c7688$var$redrawPreview();
                }
            }
        }, {
            once: true
        });
        pImage.src = src;
    }
}
var $0544d5bc706c7688$var$previewCanvas = document.createElement("canvas");
var $0544d5bc706c7688$var$previewCtx = $0544d5bc706c7688$var$previewCanvas.getContext("2d");
function $0544d5bc706c7688$var$renderPreviewImg() {
    let ctx = $0544d5bc706c7688$var$previewCtx;
    ctx.clearRect(0, 0, $0544d5bc706c7688$var$img.width, $0544d5bc706c7688$var$img.height);
    $0544d5bc706c7688$var$applyFlipTransform($0544d5bc706c7688$var$previewCanvas, ctx);
    ctx.drawImage($0544d5bc706c7688$var$img, 0, 0, $0544d5bc706c7688$var$img.width, $0544d5bc706c7688$var$img.height);
    ctx.resetTransform();
    return new Promise((resolve)=>$0544d5bc706c7688$var$previewCanvas.toBlob(resolve));
}
function $0544d5bc706c7688$var$updatePreview() {
    for(let i = 0; i < $0544d5bc706c7688$var$previewImages.length; ++i){
        let pImage = $0544d5bc706c7688$var$previewImages[i];
        var size = $0544d5bc706c7688$var$previewSizes[i];
        var sx = size / $0544d5bc706c7688$var$crop.width, sy = size / $0544d5bc706c7688$var$crop.height;
        pImage.style.left = -$0544d5bc706c7688$var$crop.x * sx + "px";
        pImage.style.top = -$0544d5bc706c7688$var$crop.y * sy + "px";
        pImage.style.width = $0544d5bc706c7688$var$img.width * sx + "px";
        pImage.style.height = $0544d5bc706c7688$var$img.height * sy + "px";
    }
}
function $0544d5bc706c7688$var$initPreview() {
    $0544d5bc706c7688$var$redrawPreview();
    $0544d5bc706c7688$var$updatePreview();
}
function $0544d5bc706c7688$var$updateImgRenders() {
    $0544d5bc706c7688$var$redrawImgCanvas();
    if ($0544d5bc706c7688$var$inputs.showPreview.checked) $0544d5bc706c7688$var$initPreview();
}
function $0544d5bc706c7688$var$getRenderPos() {
    var flipH = $0544d5bc706c7688$var$inputs.flipH.checked;
    var flipV = $0544d5bc706c7688$var$inputs.flipV.checked;
    let x = $0544d5bc706c7688$var$crop.x, y = $0544d5bc706c7688$var$crop.y;
    if (flipH) x = $0544d5bc706c7688$var$img.width - $0544d5bc706c7688$var$crop.width - x;
    if (flipV) y = $0544d5bc706c7688$var$img.height - $0544d5bc706c7688$var$crop.height - y;
    return [
        x,
        y
    ];
}
function $0544d5bc706c7688$var$drawCroppedImage(canvas, ctx) {
    $0544d5bc706c7688$var$applyFlipTransform(canvas, ctx);
    let [x, y] = $0544d5bc706c7688$var$getRenderPos();
    ctx.drawImage($0544d5bc706c7688$var$img, x, y, $0544d5bc706c7688$var$crop.width, $0544d5bc706c7688$var$crop.height, 0, 0, $0544d5bc706c7688$var$crop.width, $0544d5bc706c7688$var$crop.height // Placement
    );
    ctx.resetTransform();
}
function $0544d5bc706c7688$var$render(canvas, filter) {
    if (!canvas) canvas = $0544d5bc706c7688$var$renderCanvas;
    let ctx = canvas.getContext("2d");
    canvas.width = $0544d5bc706c7688$var$crop.width;
    canvas.height = $0544d5bc706c7688$var$crop.height;
    ctx.fillStyle = $0544d5bc706c7688$var$inputs.bgColor.style.backgroundColor;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    if (filter) ctx.filter = filter;
    if ($0544d5bc706c7688$var$cropShape == $0544d5bc706c7688$var$cropShapes.CIRCLE) {
        ctx.beginPath();
        ctx.arc($0544d5bc706c7688$var$crop.width / 2, $0544d5bc706c7688$var$crop.height / 2, $0544d5bc706c7688$var$crop.width / 2, 0, 2 * Math.PI);
        ctx.clip();
    }
    $0544d5bc706c7688$var$drawCroppedImage(canvas, ctx);
}
function $0544d5bc706c7688$var$saveFile(href, filename) {
    $0544d5bc706c7688$var$saveAnchor.href = href;
    $0544d5bc706c7688$var$saveAnchor.download = filename;
    $0544d5bc706c7688$var$saveAnchor.click();
}
function $0544d5bc706c7688$var$saveImage() {
    $0544d5bc706c7688$var$renderCanvas.toBlob(function(blob) {
        var url = URL.createObjectURL(blob);
        $0544d5bc706c7688$var$saveFile(url, $0544d5bc706c7688$var$currentName + "_cropped.png");
        setTimeout(function() {
            URL.revokeObjectURL(url);
        }, 0);
    });
}
async function $0544d5bc706c7688$var$renderAndSaveGif() {
    var renderer = new (0, $3816ae512892ed40$export$2e2bcd8739ae039).Renderer($0544d5bc706c7688$var$crop.width, $0544d5bc706c7688$var$crop.height, {
        loop: Math.floor($0544d5bc706c7688$var$inputs.loopCount.value)
    });
    var frames = (0, $3816ae512892ed40$export$2e2bcd8739ae039).frames;
    var lastFrame = frames.length ? frames.length - 1 : 0;
    var start = Math.max(0, Math.min(Math.floor($0544d5bc706c7688$var$inputs.startFrame.value), lastFrame));
    var length = Math.max(0, Math.min(Math.floor($0544d5bc706c7688$var$inputs.endFrame.value), lastFrame)) + 1;
    var filter = (0, $8432c3b0480904ec$export$2e2bcd8739ae039).optionsToFilter($0544d5bc706c7688$var$gifFilters);
    (0, $4244c5b4a8c0a9c7$export$2e2bcd8739ae039).setProgress(0);
    (0, $4244c5b4a8c0a9c7$export$2e2bcd8739ae039).show();
    var keepColors = $0544d5bc706c7688$var$inputs.keepGifColors.checked;
    var speedMult = +$0544d5bc706c7688$var$inputs.speedMult.value;
    for(let i = start; i < length; ++i){
        // Allow rendering static image
        let delay = 0;
        if (frames.length) {
            var frame = frames[i];
            $0544d5bc706c7688$var$img = frame.bitmap;
            delay = speedMult ? frame.info.delay / speedMult : 0;
        }
        $0544d5bc706c7688$var$render($0544d5bc706c7688$var$renderCanvas, filter);
        let imageData = $0544d5bc706c7688$var$renderCtx.getImageData(0, 0, $0544d5bc706c7688$var$crop.width, $0544d5bc706c7688$var$crop.height);
        renderer.addFrame(imageData, {
            delay: delay,
            keepColors: keepColors
        });
        (0, $4244c5b4a8c0a9c7$export$2e2bcd8739ae039).setProgress((i + 1) / length);
    }
    renderer.end();
    (0, $4244c5b4a8c0a9c7$export$2e2bcd8739ae039).hide();
    $0544d5bc706c7688$var$renderCtx.filter = "none";
    var uArray = renderer.getUint8Array();
    var blob = new Blob([
        uArray
    ], {
        type: "image/gif"
    });
    var url = URL.createObjectURL(blob);
    $0544d5bc706c7688$var$saveFile(url, $0544d5bc706c7688$var$currentName + "_cropped.gif");
    setTimeout(function() {
        URL.revokeObjectURL(url);
    }, 0);
    // Reload current frame
    if (frames.length) $0544d5bc706c7688$var$img = frames[$0544d5bc706c7688$var$inputs.frame.value].bitmap;
}
var $0544d5bc706c7688$var$isInSelection = false;
var $0544d5bc706c7688$var$isResizing = false;
var $0544d5bc706c7688$var$resizeFromLeft = false;
var $0544d5bc706c7688$var$resizeFromTop = false;
function $0544d5bc706c7688$var$checkMousePos(e) {
    if ((0, $63fd6a7b35566806$export$2e2bcd8739ae039).isEyeDropperActive()) {
        $0544d5bc706c7688$var$innerBox.element.style.cursor = "default";
        return;
    }
    var rect = $0544d5bc706c7688$var$canvasBox.element.getBoundingClientRect();
    // canvas rect -> selection rect
    rect.x += rect.width * ($0544d5bc706c7688$var$crop.x / $0544d5bc706c7688$var$img.width);
    rect.y += rect.height * ($0544d5bc706c7688$var$crop.y / $0544d5bc706c7688$var$img.height);
    rect.width *= $0544d5bc706c7688$var$crop.width / $0544d5bc706c7688$var$img.width;
    rect.height *= $0544d5bc706c7688$var$crop.height / $0544d5bc706c7688$var$img.height;
    var cursor;
    $0544d5bc706c7688$var$isInSelection = (0, $81b042702cd50b64$export$3ed9b644ed65412a)(e.clientX, e.clientY, rect);
    if ($0544d5bc706c7688$var$isInSelection && !$0544d5bc706c7688$var$touchPinching) {
        var cx = rect.x + rect.width / 2;
        var cy = rect.y + rect.height / 2;
        $0544d5bc706c7688$var$isResizing = !(0, $81b042702cd50b64$export$489c99c59eb9ceb1)(e.clientX, e.clientY, cx, cy, rect.width / 2);
        if ($0544d5bc706c7688$var$isResizing) {
            $0544d5bc706c7688$var$resizeFromLeft = e.clientX < cx;
            $0544d5bc706c7688$var$resizeFromTop = e.clientY < cy;
            if ($0544d5bc706c7688$var$resizeFromTop) {
                if ($0544d5bc706c7688$var$resizeFromLeft) cursor = "nw-resize";
                else cursor = "ne-resize";
            } else if ($0544d5bc706c7688$var$resizeFromLeft) cursor = "sw-resize";
            else cursor = "se-resize";
        } else cursor = "move";
    } else cursor = "grab";
    $0544d5bc706c7688$var$innerBox.element.style.cursor = cursor;
}
var $0544d5bc706c7688$var$mouseDown = false;
var $0544d5bc706c7688$var$innerBoxFocused = true;
function $0544d5bc706c7688$var$mouseDownListener(e) {
    if ($0544d5bc706c7688$var$isHidden() || e.button != 0) return;
    $0544d5bc706c7688$var$innerBoxFocused = true;
    if ((0, $63fd6a7b35566806$export$2e2bcd8739ae039).isEyeDropperActive()) {
        var rect = $0544d5bc706c7688$var$imgCanvas.getBoundingClientRect();
        var detail = {
            mode: "rgb"
        };
        if (!(0, $81b042702cd50b64$export$3ed9b644ed65412a)(e.clientX, e.clientY, rect)) // color of the outer area...lol
        detail.color = [
            30,
            30,
            30,
            255
        ];
        else {
            var x = (e.clientX - rect.x) / rect.width * $0544d5bc706c7688$var$imgCanvas.width;
            var y = (e.clientY - rect.y) / rect.height * $0544d5bc706c7688$var$imgCanvas.height;
            var imageData = $0544d5bc706c7688$var$imgCtx.getImageData(x, y, 1, 1);
            detail.color = imageData.data;
        }
        $0544d5bc706c7688$var$imgCanvas.dispatchEvent(new CustomEvent("eyedrop", {
            detail: detail
        }));
    }
    $0544d5bc706c7688$var$checkMousePos(e);
    if (!$0544d5bc706c7688$var$isInSelection) $0544d5bc706c7688$var$innerBox.element.style.cursor = "grabbing";
    $0544d5bc706c7688$var$mouseDown = true;
}
function $0544d5bc706c7688$var$unfocusInnerBox() {
    $0544d5bc706c7688$var$innerBoxFocused = false;
}
var $0544d5bc706c7688$var$prevX = null, $0544d5bc706c7688$var$prevY = null;
function $0544d5bc706c7688$var$mouseMoveListener(e) {
    if ($0544d5bc706c7688$var$isHidden()) return;
    if (!$0544d5bc706c7688$var$mouseDown) {
        $0544d5bc706c7688$var$checkMousePos(e);
        return;
    }
    if ($0544d5bc706c7688$var$prevX != null && $0544d5bc706c7688$var$prevY != null) {
        var dx = e.clientX - $0544d5bc706c7688$var$prevX;
        var dy = e.clientY - $0544d5bc706c7688$var$prevY;
        var ratio = $0544d5bc706c7688$var$inputs.scaleDevicePixel.checked ? 1 : devicePixelRatio;
        var scale = $0544d5bc706c7688$var$canvasScale / ratio;
        if (e.shiftKey) {
            // = 1 pixel
            dx = scale * Math.sign(dx);
            dy = scale * Math.sign(dy);
        }
        if ($0544d5bc706c7688$var$isInSelection) {
            dx = Math.round(dx / scale);
            dy = Math.round(dy / scale);
            var px = $0544d5bc706c7688$var$crop.x, py = $0544d5bc706c7688$var$crop.y;
            var xSign = $0544d5bc706c7688$var$resizeFromLeft ? -1 : 1;
            var ySign = $0544d5bc706c7688$var$resizeFromTop ? -1 : 1;
            if ($0544d5bc706c7688$var$isResizing) {
                var width = $0544d5bc706c7688$var$crop.width, height = $0544d5bc706c7688$var$crop.height;
                if ($0544d5bc706c7688$var$cropShape == $0544d5bc706c7688$var$cropShapes.FREEFORM) {
                    width += dx * xSign;
                    height += dy * ySign;
                    if ($0544d5bc706c7688$var$resizeFromLeft) {
                        px += dx;
                        if (px < 0) {
                            width += px;
                            px = 0;
                        }
                    }
                    if ($0544d5bc706c7688$var$resizeFromTop) {
                        py += dy;
                        if (py < 0) {
                            height += py;
                            py = 0;
                        }
                    }
                } else {
                    var delta = Math.abs(dx) > Math.abs(dy) ? dx * xSign : dy * ySign;
                    var hDelta = delta * xSign, vDelta = delta * ySign;
                    let left = px + hDelta, top = py + vDelta, right = left + width + delta, bottom = top + height + delta;
                    var d = 0;
                    if (!$0544d5bc706c7688$var$inputs.allowOffscreen.checked) {
                        if ($0544d5bc706c7688$var$resizeFromLeft && left < 0) d = -left;
                        if ($0544d5bc706c7688$var$resizeFromTop && top < 0) d = -top;
                        if (right > $0544d5bc706c7688$var$img.width) d = right - $0544d5bc706c7688$var$img.width - hDelta;
                        if (bottom > $0544d5bc706c7688$var$img.height) d = bottom - $0544d5bc706c7688$var$img.height - vDelta;
                    }
                    if (d) delta = d > delta ? 0 : delta - d;
                    width = height += delta;
                    if ($0544d5bc706c7688$var$resizeFromLeft) px += delta * xSign;
                    if ($0544d5bc706c7688$var$resizeFromTop) py += delta * ySign;
                }
                if ($0544d5bc706c7688$var$resizeFromLeft && width < 10) px -= 10 - width;
                if ($0544d5bc706c7688$var$resizeFromTop && height < 10) py -= 10 - height;
                // Set the crop positions first so setCropSize could clamp the values correctly
                $0544d5bc706c7688$var$crop.x = px;
                $0544d5bc706c7688$var$crop.y = py;
                $0544d5bc706c7688$var$setCropSize(width, height);
                $0544d5bc706c7688$var$setCropPosition(px, py);
            } else {
                px += dx;
                py += dy;
                $0544d5bc706c7688$var$setCropPosition(px, py);
            }
            $0544d5bc706c7688$var$redrawEditor();
            if ($0544d5bc706c7688$var$inputs.showPreview.checked) $0544d5bc706c7688$var$updatePreview();
        } else $0544d5bc706c7688$var$setCanvasMargins($0544d5bc706c7688$var$canvasX + dx, $0544d5bc706c7688$var$canvasY + dy);
    }
    $0544d5bc706c7688$var$prevX = e.clientX;
    $0544d5bc706c7688$var$prevY = e.clientY;
}
function $0544d5bc706c7688$var$mouseUpListener(e) {
    if ($0544d5bc706c7688$var$isHidden() || e.button != 0) return;
    $0544d5bc706c7688$var$checkMousePos(e);
    $0544d5bc706c7688$var$mouseDown = false;
    $0544d5bc706c7688$var$prevX = $0544d5bc706c7688$var$prevY = null;
    $0544d5bc706c7688$var$isInSelection = false;
}
function $0544d5bc706c7688$var$wheelListener(e) {
    if ($0544d5bc706c7688$var$isHidden()) return;
    var incr = 0.1;
    if (e.deltaY > 0) incr = -incr;
    $0544d5bc706c7688$var$setCanvasScale($0544d5bc706c7688$var$canvasScale + incr);
}
var $0544d5bc706c7688$var$touchPinching = false;
function $0544d5bc706c7688$var$touchStartListener(e) {
    (0, $81b042702cd50b64$export$b9d4e1086abc9c4d).call(this, e);
    if (e.touches.length >= 2) {
        $0544d5bc706c7688$var$touchPinching = true;
        $0544d5bc706c7688$var$prevTouchDist = (0, $81b042702cd50b64$export$98e4a82bd6040cf1)(e.touches[0], e.touches[1]);
        $0544d5bc706c7688$var$isInSelection = false;
    }
}
var $0544d5bc706c7688$var$prevTouchDist;
function $0544d5bc706c7688$var$touchMoveListener(e) {
    if ($0544d5bc706c7688$var$touchPinching) {
        var dist = (0, $81b042702cd50b64$export$98e4a82bd6040cf1)(e.touches[0], e.touches[1]);
        var diff = dist - $0544d5bc706c7688$var$prevTouchDist;
        $0544d5bc706c7688$var$setCanvasScale($0544d5bc706c7688$var$canvasScale + diff / 200);
        $0544d5bc706c7688$var$prevTouchDist = dist;
    }
}
function $0544d5bc706c7688$var$touchEndListener(e) {
    if ($0544d5bc706c7688$var$touchPinching && e.touches.length < 2) $0544d5bc706c7688$var$touchPinching = false;
}
function $0544d5bc706c7688$var$keyDownListener(e) {
    if (!$0544d5bc706c7688$var$innerBoxFocused) return;
    var code;
    if (e.code) code = e.code;
    else switch(e.keyCode){
        case 38:
            code = "ArrowUp";
            break;
        case 40:
            code = "ArrowDown";
            break;
        case 37:
            code = "ArrowLeft";
            break;
        case 39:
            code = "ArrowRight";
            break;
        default:
            return;
    }
    var incr = e.shiftKey ? 2 : 1;
    switch(code){
        case "ArrowUp":
            incr = -incr;
        /* fallthrough */ case "ArrowDown":
            e.ctrlKey ? $0544d5bc706c7688$var$setCropSize($0544d5bc706c7688$var$crop.width, $0544d5bc706c7688$var$crop.height + incr, incr > 0) : $0544d5bc706c7688$var$setCropPosition($0544d5bc706c7688$var$crop.x, $0544d5bc706c7688$var$crop.y + incr);
            break;
        case "ArrowLeft":
            incr = -incr;
        /* fallthrough */ case "ArrowRight":
            e.ctrlKey ? $0544d5bc706c7688$var$setCropSize($0544d5bc706c7688$var$crop.width + incr, $0544d5bc706c7688$var$crop.height, incr > 0) : $0544d5bc706c7688$var$setCropPosition($0544d5bc706c7688$var$crop.x + incr, $0544d5bc706c7688$var$crop.y);
            break;
        default:
            return;
    }
    $0544d5bc706c7688$var$redrawEditor();
    if ($0544d5bc706c7688$var$inputs.showPreview.checked) $0544d5bc706c7688$var$updatePreview();
}
var $0544d5bc706c7688$var$editor = {
    init: $0544d5bc706c7688$var$init,
    open: $0544d5bc706c7688$var$open,
    show: $0544d5bc706c7688$var$show,
    hide: $0544d5bc706c7688$var$hide,
    hasImage: ()=>!!$0544d5bc706c7688$var$img && !!$0544d5bc706c7688$var$img.src
};
var $0544d5bc706c7688$export$2e2bcd8739ae039 = $0544d5bc706c7688$var$editor;





var $5e2a4df4dcef8b9d$var$dialog;
function $5e2a4df4dcef8b9d$var$init(container) {
    $5e2a4df4dcef8b9d$var$dialog = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Dialog("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)($5e2a4df4dcef8b9d$var$dialog.title, "Privacy");
    $5e2a4df4dcef8b9d$var$dialog.element.id = "privacyDialog";
    $5e2a4df4dcef8b9d$var$dialog.element.classList.add("glass-dialog");
    // --- Header Section ---
    var header = document.createElement("div");
    header.className = "glass-header";
    var title = document.createElement("h2");
    title.className = "glass-title";
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(title, "Privacy Policy");
    header.appendChild(title);
    var subtitle = document.createElement("div");
    subtitle.className = "glass-subtitle";
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(subtitle, "Your Data Stays With You");
    header.appendChild(subtitle);
    $5e2a4df4dcef8b9d$var$dialog.body.appendChild(header);
    // --- Content Section ---
    var content = document.createElement("div");
    content.className = "glass-content";
    // Feature 1: Local Processing
    var item1 = $5e2a4df4dcef8b9d$var$createPrivacyItem("\uD83D\uDD12", "Zero Uploads", "This app runs entirely in your browser. Your images are processed locally and are never uploaded to any server.");
    content.appendChild(item1);
    // Feature 2: No Tracking
    var item2 = $5e2a4df4dcef8b9d$var$createPrivacyItem("\uD83D\uDEE1\uFE0F", "No Tracking", "We respect your privacy. We do not collect personal data or track your behavior across the web.");
    content.appendChild(item2);
    // Feature 3: Open Source
    var item3 = $5e2a4df4dcef8b9d$var$createPrivacyItem("\uD83D\uDCD6", "Transparent", "Our code is open. You can verify exactly how your data is handled.");
    content.appendChild(item3);
    $5e2a4df4dcef8b9d$var$dialog.body.appendChild(content);
    // --- Footer / Button ---
    $5e2a4df4dcef8b9d$var$dialog.buttons.innerHTML = "";
    var closeBtn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(closeBtn.element, "Understood & Safe");
    closeBtn.element.className = "glass-btn";
    closeBtn.addEventListener("click", $5e2a4df4dcef8b9d$var$hide);
    $5e2a4df4dcef8b9d$var$dialog.buttons.appendChild(closeBtn.element);
    container.appendChild($5e2a4df4dcef8b9d$var$dialog);
}
function $5e2a4df4dcef8b9d$var$createPrivacyItem(icon, titleKey, descKey) {
    var item = document.createElement("div");
    item.className = "privacy-item";
    var iconElem = document.createElement("div");
    iconElem.className = "privacy-item-icon";
    iconElem.innerText = icon;
    item.appendChild(iconElem);
    var textContainer = document.createElement("div");
    textContainer.className = "privacy-item-text";
    var title = document.createElement("h3");
    title.className = "privacy-item-title";
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(title, titleKey);
    textContainer.appendChild(title);
    var desc = document.createElement("div");
    desc.className = "privacy-item-desc";
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(desc, descKey);
    textContainer.appendChild(desc);
    item.appendChild(textContainer);
    return item;
}
function $5e2a4df4dcef8b9d$var$show() {
    $5e2a4df4dcef8b9d$var$dialog.show();
}
function $5e2a4df4dcef8b9d$var$hide() {
    $5e2a4df4dcef8b9d$var$dialog.hide();
}
var $5e2a4df4dcef8b9d$var$privacyDialog = {
    init: $5e2a4df4dcef8b9d$var$init,
    show: $5e2a4df4dcef8b9d$var$show,
    hide: $5e2a4df4dcef8b9d$var$hide
};
var $5e2a4df4dcef8b9d$export$2e2bcd8739ae039 = $5e2a4df4dcef8b9d$var$privacyDialog;







var $12ba32b57ec48888$exports = {};
$12ba32b57ec48888$exports = $parcel$resolve("dM0jD");


function $6a0f904a87ebf2c2$var$createNavbar() {
    var navbar = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("row");
    navbar.element.id = "mainNavbar";
    navbar.alignItems = "center";
    navbar.justifyContent = "center";
    // Container for constrained width
    var container = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("row");
    container.element.className = "navbar-container";
    container.alignItems = "center";
    container.justifyContent = "space-between";
    container.element.style.width = "100%";
    // Helper for creating nav links
    var currentPath = (0, $bd5af8eefd2d0f75$export$d75f91200e8ff7e0)();
    function createNavLink(key, targetPath) {
        var btn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("", "link");
        btn.element.className = "navbar-link";
        (0, $313f6ce5359206e9$export$625550452a3fa3ec)(btn.element, key);
        var isCurrent = false;
        if (targetPath === "/") {
            if (currentPath === "/" || currentPath === "") isCurrent = true;
        } else if (currentPath === targetPath) isCurrent = true;
        if (isCurrent) btn.element.classList.add("active");
        btn.addEventListener("click", ()=>{
            var lang = (0, $bd5af8eefd2d0f75$export$dec8f99c0c14e178)();
            var prefix = (0, $bd5af8eefd2d0f75$export$3f9924f49378cb2)[lang];
            var path;
            if (targetPath === "/") path = prefix ? "/" + prefix : "/";
            else path = prefix ? "/" + prefix + targetPath : targetPath;
            (0, $bd5af8eefd2d0f75$export$ff7962acd6052c28)(path);
        });
        return btn;
    }
    // Left: Brand + Nav Links
    var leftGroup = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("row");
    leftGroup.alignItems = "center";
    leftGroup.gap = "2.5rem"; // Spacing between Brand and Menu
    // Brand
    var brandBox = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("row");
    brandBox.alignItems = "center";
    brandBox.gap = "0.75rem";
    brandBox.element.className = "navbar-brand";
    brandBox.element.style.cursor = "pointer";
    brandBox.element.addEventListener("click", ()=>{
        var lang = (0, $bd5af8eefd2d0f75$export$dec8f99c0c14e178)();
        var prefix = (0, $bd5af8eefd2d0f75$export$3f9924f49378cb2)[lang];
        var path = prefix ? "/" + prefix : "/";
        (0, $bd5af8eefd2d0f75$export$ff7962acd6052c28)(path); // Re-route
    });
    var icon = document.createElement("img");
    icon.src = new URL($12ba32b57ec48888$exports);
    icon.className = "navbar-icon";
    icon.alt = "Logo";
    var title = document.createElement("h2");
    title.innerText = "Avatar Cropper";
    title.className = "navbar-title";
    brandBox.appendChild({
        element: icon
    });
    brandBox.appendChild({
        element: title
    });
    leftGroup.appendChild(brandBox);
    // Desktop Nav Links
    var menuBox = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("row");
    menuBox.alignItems = "center";
    menuBox.gap = "1.5rem";
    menuBox.element.className = "navbar-menu";
    menuBox.appendChild(createNavLink("Home", "/"));
    menuBox.appendChild(createNavLink("Blog", "/blog"));
    menuBox.appendChild(createNavLink("About", "/about"));
    menuBox.appendChild(createNavLink("Privacy", "/privacy"));
    menuBox.appendChild(createNavLink("Contact", "/contact"));
    menuBox.appendChild(createNavLink("Changelog", "/changelog"));
    leftGroup.appendChild(menuBox);
    container.appendChild(leftGroup);
    // Right: Language Selector + Hamburger
    var rightGroup = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("row");
    rightGroup.alignItems = "center";
    rightGroup.gap = "1rem"; // Add gap for spacing
    // Language Selector (Custom Dropdown)
    var langContainer = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Widget();
    langContainer.element.className = "navbar-lang-container";
    // Trigger Button (Globe Icon)
    var langTrigger = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("", "icon");
    langTrigger.element.className = "navbar-lang-trigger";
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(langTrigger.element, "Select Language", "aria-label");
    langTrigger.element.innerHTML = `<svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>`;
    // Dropdown Menu
    var langDropdown = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("column");
    langDropdown.element.className = "navbar-lang-dropdown";
    var langs = (0, $313f6ce5359206e9$export$2e2bcd8739ae039).getLanguages();
    var currentLang = localStorage.getItem("lang") || "en";
    for(const i in langs){
        var item = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("row");
        item.element.className = "navbar-lang-item";
        item.alignItems = "center";
        item.justifyContent = "space-between";
        var text = langs[i].flag ? langs[i].flag + " " + langs[i].name : langs[i].name;
        var label = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Label(text);
        item.appendChild(label);
        if (i === currentLang) {
            item.element.classList.add("selected");
            var check = document.createElement("div");
            check.className = "navbar-lang-check";
            check.innerHTML = `<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>`;
            item.element.appendChild(check);
        }
        item.addEventListener("click", ()=>{
            if (i === currentLang) return;
            (0, $bd5af8eefd2d0f75$export$fa43c961ec463ef0)(i);
        });
        langDropdown.appendChild(item);
    }
    // Toggle
    langTrigger.addEventListener("click", (e)=>{
        e.stopPropagation();
        langDropdown.element.classList.toggle("show");
    });
    // Close on outside click
    document.addEventListener("click", (e)=>{
        if (!langContainer.element.contains(e.target)) langDropdown.element.classList.remove("show");
    });
    langContainer.appendChild(langTrigger);
    langContainer.appendChild(langDropdown);
    rightGroup.appendChild(langContainer);
    // Hamburger Button
    var hamburgerBtn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("", "icon");
    hamburgerBtn.element.className = "navbar-hamburger";
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(hamburgerBtn.element, "Toggle Menu", "aria-label");
    // Animated hamburger lines
    hamburgerBtn.element.innerHTML = `<span></span><span></span><span></span>`;
    // Mobile Menu
    var mobileMenu = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("column");
    mobileMenu.element.className = "navbar-mobile-menu";
    mobileMenu.element.style.display = ""; // Remove inline flex style to allow CSS control
    // Mobile Links
    mobileMenu.appendChild(createNavLink("Home", "/"));
    mobileMenu.appendChild(createNavLink("Blog", "/blog"));
    mobileMenu.appendChild(createNavLink("About", "/about"));
    mobileMenu.appendChild(createNavLink("Privacy", "/privacy"));
    mobileMenu.appendChild(createNavLink("Contact", "/contact"));
    mobileMenu.appendChild(createNavLink("Changelog", "/changelog"));
    // Toggle Logic
    hamburgerBtn.addEventListener("click", (e)=>{
        e.stopPropagation();
        var isOpen = mobileMenu.element.classList.contains("open");
        if (isOpen) {
            mobileMenu.element.classList.remove("open");
            hamburgerBtn.element.classList.remove("active");
        } else {
            mobileMenu.element.classList.add("open");
            hamburgerBtn.element.classList.add("active");
        }
    });
    // Close when clicking outside
    document.addEventListener("click", (e)=>{
        if (!mobileMenu.element.contains(e.target) && !hamburgerBtn.element.contains(e.target)) {
            mobileMenu.element.classList.remove("open");
            hamburgerBtn.element.classList.remove("active");
        }
    });
    rightGroup.appendChild(hamburgerBtn);
    container.appendChild(rightGroup);
    navbar.appendChild(container);
    navbar.appendChild(mobileMenu); // Append mobile menu to navbar (relative parent)
    return navbar;
}
var $6a0f904a87ebf2c2$export$2e2bcd8739ae039 = $6a0f904a87ebf2c2$var$createNavbar;


var $fac49d8f1486f244$var$container, $fac49d8f1486f244$var$box, $fac49d8f1486f244$var$urlDialog, $fac49d8f1486f244$var$linkDialog;

function $fac49d8f1486f244$var$init(_container, callback) {
    $fac49d8f1486f244$var$container = _container;
    (0, $5e2a4df4dcef8b9d$export$2e2bcd8739ae039).init($fac49d8f1486f244$var$container);
    $fac49d8f1486f244$var$box = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("column");
    $fac49d8f1486f244$var$box.element.id = "welcomeScreen";
    $fac49d8f1486f244$var$box.justifyContent = "center";
    $fac49d8f1486f244$var$box.alignItems = "center";
    // Navbar
    var navbar = (0, $6a0f904a87ebf2c2$export$2e2bcd8739ae039)();
    $fac49d8f1486f244$var$box.appendChild(navbar);
    var innerBox = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox;
    innerBox.element.id = "welcomeInnerBox";
    innerBox.justifyContent = "center";
    innerBox.alignItems = "center";
    var titleBox = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("column");
    titleBox.element.id = "titleBox";
    titleBox.alignItems = "center";
    titleBox.gap = "1rem";
    var icon = document.createElement("img");
    icon.src = new URL($12ba32b57ec48888$exports);
    icon.className = "app-icon";
    icon.alt = "Avatar Cropper Logo";
    icon.width = 64;
    icon.height = 64;
    var titleRow = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("row");
    titleRow.alignItems = "center";
    titleRow.justifyContent = "center";
    titleRow.gap = "0.75rem";
    titleRow.element.style.position = "relative";
    var appName = {
        element: document.createElement("h1")
    };
    appName.element.innerText = "Avatar Cropper";
    appName.element.id = "appName";
    titleRow.appendChild({
        element: icon
    });
    titleRow.appendChild(appName);
    var versionBadge = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Label("v1.2.5");
    versionBadge.element.id = "versionBadge";
    titleRow.appendChild(versionBadge);
    titleBox.appendChild(titleRow);
    var appTagline = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Label("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(appTagline.element, "Quickly Crop Avatar for Discord, X (Twitter), etc.");
    appTagline.element.id = "appTagline";
    titleBox.appendChild(appTagline);
    var buttonsBox = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("column");
    buttonsBox.element.id = "openButtonsBox";
    buttonsBox.gap = "1rem";
    var openButton = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(openButton.element, "Open Image...");
    openButton.element.id = "btnOpenImage";
    buttonsBox.appendChild(openButton);
    var urlButton = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("", "secondary");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(urlButton.element, "or Paste Image...");
    urlButton.element.id = "btnPasteImage";
    buttonsBox.appendChild(urlButton);
    var linkButton = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("", "secondary");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(linkButton.element, "or From A Image URL");
    linkButton.element.id = "btnLinkImage";
    buttonsBox.appendChild(linkButton);
    var hint = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Label("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(hint.element, "or drag and drop an image here.");
    hint.element.id = "dragHint";
    buttonsBox.appendChild(hint);
    innerBox.appendChild(titleBox);
    innerBox.appendChild(buttonsBox);
    $fac49d8f1486f244$var$box.appendChild(innerBox);
    // Footer Section
    var footerBox = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("column");
    footerBox.element.id = "footerBox";
    footerBox.alignItems = "center";
    footerBox.gap = "1rem";
    var linksBox = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("row");
    linksBox.gap = "1.5rem";
    linksBox.alignItems = "center";
    var aboutBtn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("", "link");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(aboutBtn.element, "About");
    aboutBtn.element.classList.add("footer-link");
    linksBox.appendChild(aboutBtn);
    var privacyBtn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("", "link");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(privacyBtn.element, "Privacy");
    privacyBtn.element.classList.add("footer-link");
    linksBox.appendChild(privacyBtn);
    var contactBtn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("", "link");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(contactBtn.element, "Contact");
    contactBtn.element.classList.add("footer-link");
    linksBox.appendChild(contactBtn);
    footerBox.appendChild(linksBox);
    $fac49d8f1486f244$var$box.appendChild(footerBox);
    openButton.addEventListener("click", $fac49d8f1486f244$var$openFilePicker);
    $fac49d8f1486f244$var$initURLDialog();
    urlButton.addEventListener("click", $fac49d8f1486f244$var$urlDialog.show.bind($fac49d8f1486f244$var$urlDialog));
    $fac49d8f1486f244$var$initLinkDialog();
    linkButton.addEventListener("click", $fac49d8f1486f244$var$linkDialog.show.bind($fac49d8f1486f244$var$linkDialog));
    aboutBtn.addEventListener("click", ()=>{
        var lang = (0, $bd5af8eefd2d0f75$export$dec8f99c0c14e178)();
        var prefix = (0, $bd5af8eefd2d0f75$export$3f9924f49378cb2)[lang];
        var path = prefix ? "/" + prefix + "/about" : "/about";
        (0, $bd5af8eefd2d0f75$export$ff7962acd6052c28)(path);
    });
    privacyBtn.addEventListener("click", ()=>{
        var lang = (0, $bd5af8eefd2d0f75$export$dec8f99c0c14e178)();
        var prefix = (0, $bd5af8eefd2d0f75$export$3f9924f49378cb2)[lang];
        var path = prefix ? "/" + prefix + "/privacy" : "/privacy";
        (0, $bd5af8eefd2d0f75$export$ff7962acd6052c28)(path);
    });
    contactBtn.addEventListener("click", ()=>{
        var lang = (0, $bd5af8eefd2d0f75$export$dec8f99c0c14e178)();
        var prefix = (0, $bd5af8eefd2d0f75$export$3f9924f49378cb2)[lang];
        var path = prefix ? "/" + prefix + "/contact" : "/contact";
        (0, $bd5af8eefd2d0f75$export$ff7962acd6052c28)(path);
    });
    $fac49d8f1486f244$var$welcomeScreen.shown = false;
    if (callback) callback();
}
function $fac49d8f1486f244$var$initURLDialog() {
    $fac49d8f1486f244$var$urlDialog = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Dialog("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)($fac49d8f1486f244$var$urlDialog.title, "Paste Image");
    var hint = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Label("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(hint.element, "Paste your image into the input box.");
    hint.element.style.marginBottom = "0.5rem";
    $fac49d8f1486f244$var$urlDialog.appendChild(hint);
    var input = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Input("text");
    input.element.id = "urlInput";
    input.element.setAttribute("aria-label", "Paste your image into the input box.");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(input.element, "Paste your image into the input box.", "aria-label");
    $fac49d8f1486f244$var$urlDialog.appendChild(input);
    $fac49d8f1486f244$var$urlDialog.appendHideButton("Cancel");
    input.addEventListener("paste", function(e) {
        var data = e.clipboardData || e.originalEvent.clipboardData;
        if (!data) return;
        var items = data.items;
        for(let i = 0; i < items.length; ++i){
            let item = items[i];
            if (item.kind == "file") {
                let file = item.getAsFile();
                if (file.type.startsWith("image/")) {
                    (0, $0544d5bc706c7688$export$2e2bcd8739ae039).open(file, $fac49d8f1486f244$var$onEditorOpened);
                    break;
                }
            }
        }
    });
    input.addEventListener("input", function() {
        input.value = "";
    });
    $fac49d8f1486f244$var$container.appendChild($fac49d8f1486f244$var$urlDialog);
}
function $fac49d8f1486f244$var$initLinkDialog() {
    $fac49d8f1486f244$var$linkDialog = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Dialog("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)($fac49d8f1486f244$var$linkDialog.title, "From A Image URL");
    var hint = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Label("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(hint.element, "Paste the image URL below.");
    hint.element.style.marginBottom = "0.5rem";
    $fac49d8f1486f244$var$linkDialog.appendChild(hint);
    var input = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Input("text");
    input.element.id = "linkInput";
    input.element.placeholder = "https://";
    input.element.style.marginBottom = "1rem";
    $fac49d8f1486f244$var$linkDialog.appendChild(input);
    // Button Container
    var buttonBox = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("row");
    buttonBox.gap = "0.5rem";
    buttonBox.justifyContent = "flex-end";
    buttonBox.element.style.width = "100%";
    buttonBox.element.style.marginTop = "0.5rem";
    var cancelBtn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("", "secondary");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(cancelBtn.element, "Cancel");
    cancelBtn.element.style.minWidth = "80px";
    cancelBtn.addEventListener("click", function() {
        $fac49d8f1486f244$var$linkDialog.hide();
    });
    buttonBox.appendChild(cancelBtn);
    var goBtn = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button("");
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(goBtn.element, "GO");
    goBtn.element.style.minWidth = "80px";
    // Allow Enter key to submit
    input.element.addEventListener("keypress", function(e) {
        if (e.key === "Enter") goBtn.element.click();
    });
    goBtn.addEventListener("click", async function() {
        var url = input.value.trim();
        if (!url) {
            (0, $cff5b25a521f554e$export$2e2bcd8739ae039).show((0, $313f6ce5359206e9$export$71511d61b312f219)("URL cannot be empty."));
            return;
        }
        var originalText = goBtn.text;
        goBtn.text = (0, $313f6ce5359206e9$export$71511d61b312f219)("Loading...");
        goBtn.element.disabled = true;
        cancelBtn.element.disabled = true;
        await $fac49d8f1486f244$var$fetch_image_from_link(url, function(file) {
            (0, $0544d5bc706c7688$export$2e2bcd8739ae039).open(file, $fac49d8f1486f244$var$onEditorOpened);
        });
        goBtn.text = originalText;
        goBtn.element.disabled = false;
        cancelBtn.element.disabled = false;
    });
    buttonBox.appendChild(goBtn);
    $fac49d8f1486f244$var$linkDialog.appendChild(buttonBox);
    $fac49d8f1486f244$var$container.appendChild($fac49d8f1486f244$var$linkDialog);
}
async function $fac49d8f1486f244$var$fetch_image_from_link(link, callback) {
    let link_regex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
    if (!link.match(link_regex)) {
        (0, $cff5b25a521f554e$export$2e2bcd8739ae039).show((0, $313f6ce5359206e9$export$71511d61b312f219)("Invalid URL format"));
        return;
    }
    try {
        const proxyUrl = `/api/proxy-image?url=${encodeURIComponent(link)}`;
        let fetched_link = await fetch(proxyUrl).catch((e)=>{
            console.log(`Failed to fetch from ${link}!`, e);
            return null;
        });
        if (!fetched_link) {
            (0, $cff5b25a521f554e$export$2e2bcd8739ae039).show((0, $313f6ce5359206e9$export$71511d61b312f219)("Failed to fetch image. Network error."));
            return;
        }
        if (!fetched_link.ok) {
            (0, $cff5b25a521f554e$export$2e2bcd8739ae039).show((0, $313f6ce5359206e9$export$71511d61b312f219)("Failed to fetch image. Status: ") + fetched_link.status);
            return;
        }
        let blobbed_link = await fetched_link.blob();
        if (!blobbed_link.type.includes("image")) {
            (0, $cff5b25a521f554e$export$2e2bcd8739ae039).show((0, $313f6ce5359206e9$export$71511d61b312f219)("The URL does not point to a valid image."));
            return;
        }
        let ext = blobbed_link.type.split('/')[1] || 'png';
        callback(new File([
            blobbed_link
        ], `avatarcropper.${ext}`, {
            type: blobbed_link.type
        }));
    } catch (e) {
        console.error(e);
        (0, $cff5b25a521f554e$export$2e2bcd8739ae039).show((0, $313f6ce5359206e9$export$71511d61b312f219)("An error occurred while fetching the image."));
    }
}
function $fac49d8f1486f244$var$onEditorOpened() {
    var lang = (0, $bd5af8eefd2d0f75$export$dec8f99c0c14e178)();
    var prefix = (0, $bd5af8eefd2d0f75$export$3f9924f49378cb2)[lang];
    var path = "/avatar-cropper-editor";
    if (prefix) path = "/" + prefix + path;
    history.pushState(null, "", path);
    (0, $bd5af8eefd2d0f75$export$7b1c7456353579f9)();
}
function $fac49d8f1486f244$var$show() {
    setTimeout(function() {
        $fac49d8f1486f244$var$box.element.classList.remove("hide");
    }, 0);
    $fac49d8f1486f244$var$container.appendChild($fac49d8f1486f244$var$box);
    $fac49d8f1486f244$var$container.appendChild($fac49d8f1486f244$var$urlDialog);
    $fac49d8f1486f244$var$container.appendChild($fac49d8f1486f244$var$linkDialog);
    $fac49d8f1486f244$var$welcomeScreen.shown = true;
}
function $fac49d8f1486f244$var$hide() {
    if ($fac49d8f1486f244$var$urlDialog) $fac49d8f1486f244$var$urlDialog.hide();
    if ($fac49d8f1486f244$var$linkDialog) $fac49d8f1486f244$var$linkDialog.hide();
    $fac49d8f1486f244$var$welcomeScreen.shown = false;
    if ($fac49d8f1486f244$var$container.contains($fac49d8f1486f244$var$box)) {
        if ($fac49d8f1486f244$var$box.element.classList.contains("hide")) return;
        $fac49d8f1486f244$var$box.element.classList.add("hide");
        var currentBox = $fac49d8f1486f244$var$box;
        var onEnd = function(e) {
            if (e.target !== currentBox.element) return;
            currentBox.element.removeEventListener("transitionend", onEnd);
            if (!currentBox.element.classList.contains("hide")) return;
            if ($fac49d8f1486f244$var$container.contains(currentBox)) {
                $fac49d8f1486f244$var$container.removeChild(currentBox);
                if ($fac49d8f1486f244$var$urlDialog && $fac49d8f1486f244$var$container.contains($fac49d8f1486f244$var$urlDialog)) $fac49d8f1486f244$var$container.removeChild($fac49d8f1486f244$var$urlDialog);
                if ($fac49d8f1486f244$var$linkDialog && $fac49d8f1486f244$var$container.contains($fac49d8f1486f244$var$linkDialog)) $fac49d8f1486f244$var$container.removeChild($fac49d8f1486f244$var$linkDialog);
            }
        };
        currentBox.element.addEventListener("transitionend", onEnd);
    } else {
        if ($fac49d8f1486f244$var$urlDialog && $fac49d8f1486f244$var$container.contains($fac49d8f1486f244$var$urlDialog)) $fac49d8f1486f244$var$container.removeChild($fac49d8f1486f244$var$urlDialog);
        if ($fac49d8f1486f244$var$linkDialog && $fac49d8f1486f244$var$container.contains($fac49d8f1486f244$var$linkDialog)) $fac49d8f1486f244$var$container.removeChild($fac49d8f1486f244$var$linkDialog);
    }
}
var $fac49d8f1486f244$var$inputEl = document.createElement("input");
$fac49d8f1486f244$var$inputEl.id = "filePickerInput";
$fac49d8f1486f244$var$inputEl.type = "file";
$fac49d8f1486f244$var$inputEl.accept = "image/*";
function $fac49d8f1486f244$var$openFilePicker() {
    $fac49d8f1486f244$var$inputEl.value = null;
    $fac49d8f1486f244$var$inputEl.click();
}
$fac49d8f1486f244$var$inputEl.addEventListener("change", function(e) {
    var fileList = this.files;
    for(let i = 0; i < fileList.length; ++i){
        let file = fileList[i];
        if (file.type.startsWith("image/")) {
            (0, $0544d5bc706c7688$export$2e2bcd8739ae039).open(file, $fac49d8f1486f244$var$onEditorOpened);
            return;
        }
    }
    (0, $cff5b25a521f554e$export$2e2bcd8739ae039).show((0, $313f6ce5359206e9$export$71511d61b312f219)("Invalid image file."));
});
var $fac49d8f1486f244$var$welcomeScreen = {
    shown: false,
    init: $fac49d8f1486f244$var$init,
    show: $fac49d8f1486f244$var$show,
    hide: $fac49d8f1486f244$var$hide
};
var $fac49d8f1486f244$export$2e2bcd8739ae039 = $fac49d8f1486f244$var$welcomeScreen;






var $200cdb1bd3341216$var$container, $200cdb1bd3341216$var$box;
function $200cdb1bd3341216$var$init(_container) {
    $200cdb1bd3341216$var$container = _container;
    $200cdb1bd3341216$var$box = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("column");
    $200cdb1bd3341216$var$box.element.id = "changelogScreen";
    $200cdb1bd3341216$var$box.element.className = "main-screen";
    // Navbar
    var navbar = (0, $6a0f904a87ebf2c2$export$2e2bcd8739ae039)();
    $200cdb1bd3341216$var$box.appendChild(navbar);
    // Content Container
    var contentBox = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("column");
    contentBox.element.id = "changelogContentBox";
    contentBox.alignItems = "center";
    // Breadcrumb Container
    var breadcrumbContainer = document.createElement("div");
    breadcrumbContainer.className = "breadcrumb-container";
    // Breadcrumb
    var breadcrumb = document.createElement("div");
    breadcrumb.className = "breadcrumb";
    breadcrumbContainer.appendChild(breadcrumb);
    // Home Link
    var homeLink = document.createElement("a");
    homeLink.className = "breadcrumb-link";
    homeLink.innerHTML = `<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> <span class="breadcrumb-home-text"></span>`;
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(homeLink.querySelector(".breadcrumb-home-text"), "Home");
    homeLink.addEventListener("click", ()=>{
        var lang = (0, $bd5af8eefd2d0f75$export$dec8f99c0c14e178)();
        var prefix = (0, $bd5af8eefd2d0f75$export$3f9924f49378cb2)[lang];
        var path = prefix ? "/" + prefix : "/";
        (0, $bd5af8eefd2d0f75$export$ff7962acd6052c28)(path);
    });
    breadcrumb.appendChild(homeLink);
    // Separator
    var separator = document.createElement("span");
    separator.className = "breadcrumb-separator";
    separator.innerHTML = `<svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>`;
    breadcrumb.appendChild(separator);
    // Current Page
    var current = document.createElement("span");
    current.className = "breadcrumb-current";
    current.innerText = "";
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(current, "Changelog");
    breadcrumb.appendChild(current);
    contentBox.appendChild({
        element: breadcrumbContainer
    });
    // Title
    var title = document.createElement("h1");
    title.className = "page-title";
    title.innerText = "";
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(title, "Changelog");
    contentBox.appendChild({
        element: title
    });
    // Changelog List Container
    var listContainer = document.createElement("div");
    listContainer.className = "changelog-container";
    var releases = [
        {
            version: "v1.2.5",
            date: (0, $313f6ce5359206e9$export$71511d61b312f219)("December 13th, 2025"),
            highlight: {
                icon: "\uD83D\uDCDD",
                title: (0, $313f6ce5359206e9$export$71511d61b312f219)("Blog & Content Update"),
                desc: (0, $313f6ce5359206e9$export$71511d61b312f219)("Added a new Blog section, optimized blog post experience, and improved site navigation.")
            },
            changes: [
                {
                    type: "new",
                    text: (0, $313f6ce5359206e9$export$71511d61b312f219)("Added a new Blog section and blog list page.")
                },
                {
                    type: "new",
                    text: (0, $313f6ce5359206e9$export$71511d61b312f219)("Added new blog post: 'How do I use avatar cropper to crop avatar from an image?'.")
                },
                {
                    type: "new",
                    text: (0, $313f6ce5359206e9$export$71511d61b312f219)("Added 404 error page.")
                },
                {
                    type: "improve",
                    text: (0, $313f6ce5359206e9$export$71511d61b312f219)("Optimized blog post page with internal links and clickable titles.")
                },
                {
                    type: "improve",
                    text: (0, $313f6ce5359206e9$export$71511d61b312f219)("Updated 'Read Article' button style for better consistency.")
                }
            ]
        },
        {
            version: "v1.2.0",
            date: (0, $313f6ce5359206e9$export$71511d61b312f219)("December 7th, 2025"),
            highlight: {
                icon: "\uD83C\uDFA8",
                title: (0, $313f6ce5359206e9$export$71511d61b312f219)("Major UI/UX Overhaul"),
                desc: (0, $313f6ce5359206e9$export$71511d61b312f219)("A complete redesign of the homepage, navigation, and page structure for a more modern and stable experience.")
            },
            changes: [
                {
                    type: "new",
                    text: (0, $313f6ce5359206e9$export$71511d61b312f219)("Split Welcome and Editor pages with dedicated URLs for better navigation.")
                },
                {
                    type: "new",
                    text: (0, $313f6ce5359206e9$export$71511d61b312f219)("Redesigned Homepage with a stunning dark theme and consistent UI elements.")
                },
                {
                    type: "new",
                    text: (0, $313f6ce5359206e9$export$71511d61b312f219)("Modernized Navigation Bar with glassmorphism design and centered layout.")
                },
                {
                    type: "new",
                    text: (0, $313f6ce5359206e9$export$71511d61b312f219)("Moved Changelog to a standalone page accessible via the new Navbar.")
                },
                {
                    type: "fix",
                    text: (0, $313f6ce5359206e9$export$71511d61b312f219)("Resolved 'Loading...' stuck issue and improved page transition stability.")
                }
            ]
        },
        {
            version: "v1.1.0",
            date: (0, $313f6ce5359206e9$export$71511d61b312f219)("December 4th, 2025"),
            highlight: {
                icon: "\uD83D\uDE80",
                title: (0, $313f6ce5359206e9$export$71511d61b312f219)("New Features & Improvements"),
                desc: (0, $313f6ce5359206e9$export$71511d61b312f219)("Import images directly from URLs and enjoy a fully localized experience in all supported languages.")
            },
            changes: [
                {
                    type: "new",
                    text: (0, $313f6ce5359206e9$export$71511d61b312f219)("Added 'From A Image URL' feature to import images via URL.")
                },
                {
                    type: "improve",
                    text: (0, $313f6ce5359206e9$export$71511d61b312f219)("Completed translations for all supported languages.")
                },
                {
                    type: "improve",
                    text: (0, $313f6ce5359206e9$export$71511d61b312f219)("Enhanced 'Open Image From URL' dialog UI.")
                },
                {
                    type: "fix",
                    text: (0, $313f6ce5359206e9$export$71511d61b312f219)("Fixed deployment compatibility issues.")
                }
            ]
        },
        {
            version: "v1.0.0",
            date: (0, $313f6ce5359206e9$export$71511d61b312f219)("November 30th, 2025"),
            highlight: {
                icon: "\uD83C\uDF89",
                title: (0, $313f6ce5359206e9$export$71511d61b312f219)("Official Release"),
                desc: (0, $313f6ce5359206e9$export$71511d61b312f219)("We are thrilled to announce the first official release of Avatar Cropper! Crop, edit, and perfect your avatars with ease.")
            },
            changes: [
                {
                    type: "new",
                    text: (0, $313f6ce5359206e9$export$71511d61b312f219)("Brand new About & Privacy pages with modern glassmorphism design.")
                },
                {
                    type: "new",
                    text: (0, $313f6ce5359206e9$export$71511d61b312f219)("Enhanced Language Selector with flag support.")
                },
                {
                    type: "improve",
                    text: (0, $313f6ce5359206e9$export$71511d61b312f219)("Optimized image processing for faster cropping.")
                },
                {
                    type: "improve",
                    text: (0, $313f6ce5359206e9$export$71511d61b312f219)("Improved UI responsiveness on mobile devices.")
                },
                {
                    type: "fix",
                    text: (0, $313f6ce5359206e9$export$71511d61b312f219)("Fixed minor layout issues in dark mode.")
                }
            ]
        },
        {
            version: "v0.9.0",
            date: (0, $313f6ce5359206e9$export$71511d61b312f219)("November 15th, 2025"),
            changes: [
                {
                    type: "new",
                    text: (0, $313f6ce5359206e9$export$71511d61b312f219)("Initial beta release.")
                },
                {
                    type: "new",
                    text: (0, $313f6ce5359206e9$export$71511d61b312f219)("Basic cropping functionality (Circle & Square).")
                },
                {
                    type: "new",
                    text: (0, $313f6ce5359206e9$export$71511d61b312f219)("Dark mode support.")
                }
            ]
        }
    ];
    releases.forEach((release, index)=>{
        var wrapper = document.createElement("div");
        wrapper.className = "changelog-card";
        // Header
        var header = document.createElement("div");
        header.className = "changelog-header";
        var version = document.createElement("span");
        version.className = "changelog-version";
        version.innerText = release.version;
        var date = document.createElement("span");
        date.className = "changelog-date";
        date.innerText = release.date;
        header.appendChild(version);
        header.appendChild(date);
        wrapper.appendChild(header);
        // Highlight
        if (release.highlight) {
            var highlight = document.createElement("div");
            highlight.className = "changelog-highlight";
            highlight.innerHTML = `
                <div class="highlight-icon">${release.highlight.icon}</div>
                <div class="highlight-text">
                    <h3>${release.highlight.title}</h3>
                    <p>${release.highlight.desc}</p>
                </div>
            `;
            wrapper.appendChild(highlight);
        }
        // List
        var ul = document.createElement("ul");
        ul.className = "changelog-list";
        if (release.changes) release.changes.forEach((item)=>{
            var li = document.createElement("li");
            li.className = `changelog-item ${item.type}`;
            var icon = item.type === "new" ? "\u2728" : item.type === "improve" ? "\u26A1" : "\uD83D\uDC1B";
            li.innerHTML = `<span class="item-icon">${icon}</span> <span class="item-text">${item.text}</span>`;
            ul.appendChild(li);
        });
        wrapper.appendChild(ul);
        listContainer.appendChild(wrapper);
    });
    contentBox.appendChild({
        element: listContainer
    });
    $200cdb1bd3341216$var$box.appendChild(contentBox);
}
function $200cdb1bd3341216$var$show() {
    $200cdb1bd3341216$var$container.appendChild($200cdb1bd3341216$var$box);
    // Trigger reflow or simple timeout to allow animation if we add one later
    setTimeout(()=>$200cdb1bd3341216$var$box.element.classList.add("show"), 0);
}
function $200cdb1bd3341216$var$hide() {
    if (!$200cdb1bd3341216$var$box) return;
    $200cdb1bd3341216$var$box.element.classList.remove("show");
    if ($200cdb1bd3341216$var$container && $200cdb1bd3341216$var$container.contains($200cdb1bd3341216$var$box)) $200cdb1bd3341216$var$container.removeChild($200cdb1bd3341216$var$box);
}
var $200cdb1bd3341216$var$changelogScreen = {
    init: $200cdb1bd3341216$var$init,
    show: $200cdb1bd3341216$var$show,
    hide: $200cdb1bd3341216$var$hide
};
var $200cdb1bd3341216$export$2e2bcd8739ae039 = $200cdb1bd3341216$var$changelogScreen;







const $5ac34e91e8ba2501$export$5d8b1d054cfb8344 = [
    {
        slug: "perfect-avatar-size-and-format-for-every-platform",
        title: (0, $313f6ce5359206e9$export$71511d61b312f219)("Perfect Avatar Size & Format for Every Platform (2026)"),
        date: "2026-02-10",
        readTime: "7",
        category: (0, $313f6ce5359206e9$export$71511d61b312f219)("Guide"),
        image: "/assets/avatar_cropper_demo3.webp",
        summary: (0, $313f6ce5359206e9$export$71511d61b312f219)("A complete, up-to-date cheat sheet of the ideal avatar dimensions, aspect ratios, and file formats for Discord, X, Instagram, LinkedIn, and more."),
        tags: [
            (0, $313f6ce5359206e9$export$71511d61b312f219)("Avatar Size"),
            (0, $313f6ce5359206e9$export$71511d61b312f219)("Social Media"),
            (0, $313f6ce5359206e9$export$71511d61b312f219)("Guide")
        ],
        color: "#38bdf8",
        content: `
            <div class="blog-article-content">
                <p>Nothing kills a great first impression faster than a blurry, off-center, or awkwardly cropped profile picture. Every platform has its own rules for avatar size, aspect ratio, and accepted file format \u{2014} and getting them wrong means your carefully chosen photo gets squished or cropped in all the wrong places.</p>
                <p>This guide is your one-stop <strong>avatar size cheat sheet</strong> for 2026. Bookmark it, and you'll never second-guess your dimensions again.</p>

                <h2>Why Avatar Dimensions Matter</h2>
                <p>Most platforms store a single high-resolution source image and display it inside a fixed frame \u{2014} usually a circle or a square. If your upload is too small, it gets upscaled and looks pixelated. If it's the wrong aspect ratio, the platform's automatic crop may chop off your head or cut out important detail. Uploading the <em>right</em> size from the start keeps your avatar crisp everywhere.</p>

                <h2>Avatar Size Cheat Sheet (2026)</h2>
                <ul>
                    <li><strong>Discord:</strong> 128 \xd7 128 px ( Displays in a circle. Supports animated GIF/PNG with transparency. )</li>
                    <li><strong>X (Twitter):</strong> 400 \xd7 400 px recommended ( displays at ~400px, circular frame ).</li>
                    <li><strong>Instagram:</strong> 320 \xd7 320 px minimum; uploads at up to 110 \xd7 110 but stored larger. Circular frame.</li>
                    <li><strong>LinkedIn:</strong> 400 \xd7 400 px; displayed as a circle on the profile.</li>
                    <li><strong>Facebook:</strong> 170 \xd7 170 px on desktop ( circular crop on many surfaces ).</li>
                    <li><strong>YouTube:</strong> 800 \xd7 800 px ( shown as a circle ).</li>
                    <li><strong>Twitch:</strong> 256 \xd7 256 px; circular profile image.</li>
                    <li><strong>GitHub:</strong> 460 \xd7 460 px; displayed as a circle.</li>
                </ul>

                <h2>Square vs Circle: Which Should You Design For?</h2>
                <p>Almost every modern platform masks your avatar inside a <strong>circle</strong>. That means the corners of your image are invisible. Keep the important subject \u{2014} your face \u{2014} centered, and avoid putting text or logos in the corners. If you want a guaranteed safe result, design a square image with the subject centered, then let <strong><a href="/" style="color: #38bdf8; text-decoration: none;">Avatar Cropper</a></strong>'s live circular preview guide your framing.</p>

                <h2>PNG or JPG? Choose the Right Format</h2>
                <ul>
                    <li><strong>PNG:</strong> Best for logos, illustrations, and any image that needs transparency (great for Discord). Lossless, so no quality loss.</li>
                    <li><strong>JPG:</strong> Best for real photographs where file size matters. Slightly smaller, but no transparency.</li>
                    <li><strong>WebP:</strong> Modern, efficient, and supported by most platforms \u{2014} a smart default.</li>
                </ul>

                <h2>How to Get It Right in Seconds</h2>
                <p>Open <strong><a href="/" style="color: #38bdf8; text-decoration: none;">Avatar Cropper</a></strong>, drop in your photo, pick the target platform's dimensions, and export a perfectly sized PNG or JPG. Because everything runs locally in your browser, your photo never leaves your device.</p>

                <h2>Conclusion</h2>
                <p>The "right" avatar size is whichever one your platform expects. Use the cheat sheet above, export at the correct dimensions, and your profile will look sharp on every network.</p>
            </div>
        `
    },
    {
        slug: "circle-vs-square-avatars-which-platforms-need-what",
        title: (0, $313f6ce5359206e9$export$71511d61b312f219)("Circle vs Square Avatars: Which Platforms Need What"),
        date: "2026-03-05",
        readTime: "6",
        category: (0, $313f6ce5359206e9$export$71511d61b312f219)("Guide"),
        image: "/assets/avatar_cropper_demo4.webp",
        summary: (0, $313f6ce5359206e9$export$71511d61b312f219)("Circular or square? We break down which social platforms use which shape, and how to frame your photo so it looks great in both."),
        tags: [
            (0, $313f6ce5359206e9$export$71511d61b312f219)("Circle Avatar"),
            (0, $313f6ce5359206e9$export$71511d61b312f219)("Square Avatar"),
            (0, $313f6ce5359206e9$export$71511d61b312f219)("Guide")
        ],
        color: "#818cf8",
        content: `
            <div class="blog-article-content">
                <p>You've probably noticed it: your profile picture looks like a circle on Instagram but a square on Discord. Why the inconsistency, and \u{2014} more importantly \u{2014} how do you make sure your face looks good in <em>both</em>?</p>

                <h2>The Short Answer</h2>
                <p>Most consumer platforms (Instagram, X, LinkedIn, YouTube, Twitch) use a <strong>circular</strong> mask. Developer- and community-focused platforms (Discord, many forums, some gaming services) tend to keep a <strong>square</strong> frame. The safest approach is to compose a centered square image so it survives either crop.</p>

                <h2>Platforms That Use a Circle</h2>
                <ul>
                    <li>Instagram, Threads, X (Twitter)</li>
                    <li>LinkedIn, Facebook, YouTube</li>
                    <li>Twitch, TikTok, most modern mobile apps</li>
                </ul>
                <p>In a circle, roughly the four corners of your square are clipped away. Anything important living in those corners will disappear.</p>

                <h2>Platforms That Use a Square</h2>
                <ul>
                    <li>Discord ( though it rounds the corners slightly )</li>
                    <li>Many forums, wikis, and legacy platforms</li>
                    <li>Some gaming launchers and portfolios</li>
                </ul>

                <h2>How to Frame for Both Shapes</h2>
                <ol>
                    <li><strong>Center your subject.</strong> Keep your face or logo in the middle third of the image.</li>
                    <li><strong>Leave breathing room.</strong> Don't crop too tight \u{2014} a little margin survives the circular mask nicely.</li>
                    <li><strong>Preview before exporting.</strong> Use a tool that shows both a square and a circular preview at the same time.</li>
                </ol>

                <div class="blog-image-container">
                    <img src="/assets/avatar_cropper_demo4.webp" alt="Square and circular avatar preview" class="blog-content-image">
                    <p class="image-caption">Avatar Cropper shows both previews live</p>
                </div>

                <h2>Why a Dedicated Cropper Helps</h2>
                <p><strong><a href="/" style="color: #38bdf8; text-decoration: none;">Avatar Cropper</a></strong> renders a real-time square <em>and</em> circular preview as you adjust. That way you can see exactly how your photo will look on Discord (square) and Instagram (circle) before you download \u{2014} no guesswork, no resubmitting.</p>

                <h2>Conclusion</h2>
                <p>Design for the square, expect the circle. Center your subject, keep margins, and preview both shapes. Do that and your avatar will look intentional everywhere it appears.</p>
            </div>
        `
    },
    {
        slug: "how-to-make-a-transparent-png-avatar",
        title: (0, $313f6ce5359206e9$export$71511d61b312f219)("How to Make a Transparent PNG Avatar (and Why It Matters)"),
        date: "2026-04-02",
        readTime: "5",
        category: (0, $313f6ce5359206e9$export$71511d61b312f219)("Tutorial"),
        image: "/assets/avatar_cropper_demo2.webp",
        summary: (0, $313f6ce5359206e9$export$71511d61b312f219)("Transparent PNG avatars blend seamlessly into any background \u2014 especially on Discord. Learn how to export one in a few clicks."),
        tags: [
            (0, $313f6ce5359206e9$export$71511d61b312f219)("Transparent PNG"),
            (0, $313f6ce5359206e9$export$71511d61b312f219)("Discord Avatar"),
            (0, $313f6ce5359206e9$export$71511d61b312f219)("Tutorial")
        ],
        color: "#22d3ee",
        content: `
            <div class="blog-article-content">
                <p>A transparent background is the secret behind those clean, floating avatars you see on Discord and other chat platforms. Instead of a hard white or black box, your subject sits directly on the app's background \u{2014} looking polished and intentional.</p>

                <h2>What Is a Transparent PNG?</h2>
                <p>A PNG can store an <strong>alpha channel</strong>, which means parts of the image have no color at all \u{2014} they're see-through. When you place that image on a colored or patterned background, the background shows through the transparent areas.</p>

                <h2>Why It Matters</h2>
                <ul>
                    <li><strong>Discord:</strong> Transparent avatars look far cleaner against any theme (light, dark, or custom).</li>
                    <li><strong>Logos & branding:</strong> A transparent mark drops onto any surface without an ugly border.</li>
                    <li><strong>Consistency:</strong> No more clashing white squares behind your art or character.</li>
                </ul>

                <h2>How to Make One with Avatar Cropper</h2>
                <ol>
                    <li>Open <strong><a href="/" style="color: #38bdf8; text-decoration: none;">Avatar Cropper</a></strong> and load your image.</li>
                    <li>Frame your subject using the zoom and pan controls, keeping the important area centered.</li>
                    <li>Choose the <strong>Discord</strong> preset ( 128 \xd7 128 ) for a perfect fit.</li>
                    <li>Export as <strong>PNG</strong> \u{2014} the tool preserves transparency from your source image.</li>
                    <li>Upload the result to Discord and enjoy a crisp, borderless avatar.</li>
                </ol>

                <div class="blog-image-container">
                    <img src="/assets/avatar_cropper_demo2.webp" alt="Avatar Cropper interface" class="blog-content-image">
                    <p class="image-caption">Export a transparent PNG in a few clicks</p>
                </div>

                <h2>Tips for the Best Result</h2>
                <ul>
                    <li>Start from a source that already has a transparent background ( e.g., a PNG export from your drawing app ).</li>
                    <li>If your source has a solid background, consider removing it in a dedicated editor first, then cropping here.</li>
                    <li>Keep the subject centered so the circular Discord mask doesn't clip anything important.</li>
                </ul>

                <h2>Conclusion</h2>
                <p>A transparent PNG avatar is a small touch that makes a big difference. With <strong>Avatar Cropper</strong>, exporting one takes seconds \u{2014} and because processing happens locally, your images never leave your device.</p>
            </div>
        `
    },
    {
        slug: "how-do-i-use-avatar-cropper-to-crop-avatar-from-an-image",
        title: (0, $313f6ce5359206e9$export$71511d61b312f219)("How do I use avatar cropper to crop avatar from an image ?"),
        date: "2025-12-13",
        readTime: "5",
        category: (0, $313f6ce5359206e9$export$71511d61b312f219)("Tutorial"),
        image: "/assets/avatar_cropper_demo2.webp",
        summary: (0, $313f6ce5359206e9$export$71511d61b312f219)("Learn how to use Avatar Cropper to create perfect avatars for your social media profiles."),
        tags: [
            (0, $313f6ce5359206e9$export$71511d61b312f219)("Avatar Cropper"),
            (0, $313f6ce5359206e9$export$71511d61b312f219)("Discord Avatar Cropper")
        ],
        color: "#38bdf8",
        content: `
            <div class="blog-article-content">
                <p>In the digital age, your profile picture is often the very first impression you make online. Whether you are gaming on Discord, networking on LinkedIn, or sharing updates on X (Twitter), having a crisp, perfectly framed avatar is essential. However, finding a simple, privacy-focused tool to get that perfect crop can be surprisingly difficult. Enter <strong><a href="/" style="color: #38bdf8; text-decoration: none;">Avatar Cropper</a></strong>, the ultimate browser-based solution designed to solve your profile picture woes.</p>

                <h2>Why You Need a Dedicated Avatar Cropper</h2>
                <p>We've all been there: you have a fantastic photo, but the subject is too far away, or the aspect ratio is completely wrong for a square or circular profile frame. You try to upload it, and the platform awkwardly chops off half your head. Or, you resort to heavy desktop software just to make a simple edit.</p>
                
                <p><strong><a href="/" style="color: #38bdf8; text-decoration: none;">Avatar Cropper</a></strong> was built to address these specific scenarios. It is designed for users who value speed, privacy, and precision. Unlike other tools that require you to upload your personal photos to a remote server, our <strong>avatar cropper</strong> processes everything locally in your browser. This means your images never leave your device, ensuring maximum privacy.</p>

                <p>Whether you are looking for a reliable <strong>Discord avatar cropper</strong> to fit that 128x128 limit or a versatile <strong>circle avatar cropper</strong> to preview how your face fits in a rounded frame, this tool has you covered.</p>

                <div class="blog-image-container">
                    <img src="/assets/avatar_cropper_demo2.webp" alt="Avatar Cropper Interface" class="blog-content-image">
                    <p class="image-caption">The clean, dark-mode interface of Avatar Cropper</p>
                </div>

                <h2>Core Features</h2>
                <p>What makes Avatar Cropper stand out from the crowd? Here are the key features that make it the go-to choice for thousands of users:</p>
                <ul>
                    <li><strong>Privacy First:</strong> No server uploads. All image processing happens directly on your device using advanced canvas technologies.</li>
                    <li><strong>Smart Zoom & Pan:</strong> Easily zoom in on the focal point and pan around to get the composition just right.</li>
                    <li><strong>Real-time Preview:</strong> See exactly how your avatar will look in both square and circular formats instantly. This is essentially a built-in <strong>circle avatar cropper</strong> preview.</li>
                    <li><strong>High-Quality Output:</strong> Export your avatars in high-resolution PNG or JPG formats without losing clarity.</li>
                    <li><strong>Optimized for Social Platforms:</strong> Pre-set aspect ratios and resolutions make it the perfect <strong>Discord avatar cropper</strong>, ensuring your image looks crisp on any server.</li>
                </ul>

                <div class="blog-image-container">
                    <img src="/assets/avatar_cropper_demo3.webp" alt="Zoom and Rotate Features" class="blog-content-image">
                    <p class="image-caption">Precise controls for zooming and rotating your image</p>
                </div>

                <h2>How to Use Avatar Cropper</h2>
                <p>Using Avatar Cropper is intuitive and fast. Follow this simple guide to create your perfect avatar in seconds:</p>

                <h3>Step 1: Open Your Image</h3>
                <p>Click the "Select Image" area or simply drag and drop your photo onto the canvas. The tool supports all common image formats including JPEG, PNG, and WebP.</p>

                <h3>Step 2: Adjust and Crop</h3>
                <p>Once your image is loaded, use the slider to zoom in or out. Click the "Download" button on the top right to start using <strong><a href="/" style="color: #38bdf8; text-decoration: none;">Avatar Cropper</a></strong> now. Click and drag the image to position it perfectly within the frame. You can also rotate the image if needed to align the horizon or add a creative angle.</p>

                <h3>Step 3: Preview the Result</h3>
                <p>As you adjust, keep an eye on the preview pane on the right (or bottom on mobile). This shows you the final result. Pay special attention to the circular preview if you are creating a profile picture for platforms like Instagram or TikTok.</p>

                <div class="blog-image-container">
                    <img src="/assets/avatar_cropper_demo4.webp" alt="Final Crop Preview" class="blog-content-image">
                    <p class="image-caption">Real-time circular and square previews</p>
                </div>

                <h3>Step 4: Download</h3>
                <p>Satisfied with the look? Click the "Download" button. Your perfectly cropped avatar is instantly saved to your device, ready to be uploaded to your favorite social network.</p>

                <h2>Conclusion</h2>
                <p>Creating a professional-looking avatar doesn't have to be complicated. With <strong>Avatar Cropper</strong>, you have a powerful, free, and secure tool right in your browser. Whether you need a <strong>Discord avatar cropper</strong> for your gaming profile or a general-purpose tool for professional networks, give it a try today and see the difference a perfect crop can make.</p>
            </div>
        `
    }
];
function $5ac34e91e8ba2501$export$f47708b5cead80df(slug) {
    return $5ac34e91e8ba2501$export$5d8b1d054cfb8344.find((p)=>p.slug === slug);
}


var $8c398b5c754c4adc$var$container, $8c398b5c754c4adc$var$box;
function $8c398b5c754c4adc$var$init(_container) {
    $8c398b5c754c4adc$var$container = _container;
    // Clear previous content if exists
    if ($8c398b5c754c4adc$var$box && $8c398b5c754c4adc$var$box.element) $8c398b5c754c4adc$var$box.element.innerHTML = "";
    else {
        $8c398b5c754c4adc$var$box = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("column");
        $8c398b5c754c4adc$var$box.element.id = "blogScreen";
        $8c398b5c754c4adc$var$box.element.className = "main-screen";
    }
    // Navbar
    var navbar = (0, $6a0f904a87ebf2c2$export$2e2bcd8739ae039)();
    $8c398b5c754c4adc$var$box.appendChild(navbar);
    // Content Container
    var contentBox = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("column");
    contentBox.element.id = "blogContentBox";
    contentBox.alignItems = "center";
    // Breadcrumb Container
    var breadcrumbContainer = document.createElement("div");
    breadcrumbContainer.className = "breadcrumb-container";
    // Breadcrumb
    var breadcrumb = document.createElement("div");
    breadcrumb.className = "breadcrumb";
    breadcrumbContainer.appendChild(breadcrumb);
    // Home Link
    var homeLink = document.createElement("a");
    homeLink.className = "breadcrumb-link";
    homeLink.innerHTML = `<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> <span class="breadcrumb-home-text"></span>`;
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(homeLink.querySelector(".breadcrumb-home-text"), "Home");
    homeLink.addEventListener("click", ()=>{
        var lang = (0, $bd5af8eefd2d0f75$export$dec8f99c0c14e178)();
        var prefix = (0, $bd5af8eefd2d0f75$export$3f9924f49378cb2)[lang];
        var path = prefix ? "/" + prefix : "/";
        (0, $bd5af8eefd2d0f75$export$ff7962acd6052c28)(path);
    });
    breadcrumb.appendChild(homeLink);
    // Separator
    var separator = document.createElement("span");
    separator.className = "breadcrumb-separator";
    separator.innerHTML = `<svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>`;
    breadcrumb.appendChild(separator);
    // Current Page
    var current = document.createElement("span");
    current.className = "breadcrumb-current";
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(current, "Blog");
    breadcrumb.appendChild(current);
    contentBox.appendChild({
        element: breadcrumbContainer
    });
    // Title
    var title = document.createElement("h1");
    title.className = "page-title";
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(title, "Blog");
    contentBox.appendChild({
        element: title
    });
    // Blog List Container
    var listContainer = document.createElement("div");
    listContainer.className = "blog-container";
    (0, $5ac34e91e8ba2501$export$5d8b1d054cfb8344).forEach((post)=>{
        var wrapper = document.createElement("div");
        wrapper.className = "blog-card";
        // Thumbnail (Left)
        var thumbnailContainer = document.createElement("div");
        thumbnailContainer.className = "blog-thumbnail-container";
        var img = document.createElement("img");
        img.src = post.image;
        img.className = "blog-thumbnail";
        thumbnailContainer.appendChild(img);
        wrapper.appendChild(thumbnailContainer);
        // Content (Right)
        var content = document.createElement("div");
        content.className = "blog-content";
        // Meta Top (Category badge + Date/Time)
        var metaTop = document.createElement("div");
        metaTop.className = "blog-meta-top";
        var category = document.createElement("span");
        category.className = "blog-category";
        category.innerText = post.category;
        category.style.backgroundColor = post.color;
        metaTop.appendChild(category);
        var metaInfo = document.createElement("span");
        metaInfo.className = "blog-meta-info";
        metaInfo.innerHTML = `\u{1F4C5} ${post.date} &nbsp; \u{23F1} ${post.readTime} <span class="min-read-text"></span>`;
        (0, $313f6ce5359206e9$export$625550452a3fa3ec)(metaInfo.querySelector(".min-read-text"), "min read");
        metaTop.appendChild(metaInfo);
        content.appendChild(metaTop);
        // Title
        var blogTitle = document.createElement("h2");
        blogTitle.className = "blog-title clickable";
        blogTitle.innerText = post.title;
        blogTitle.addEventListener("click", ()=>{
            var lang = (0, $bd5af8eefd2d0f75$export$dec8f99c0c14e178)();
            var prefix = (0, $bd5af8eefd2d0f75$export$3f9924f49378cb2)[lang];
            var path = prefix ? "/" + prefix + "/blog/" + post.slug : "/blog/" + post.slug;
            (0, $bd5af8eefd2d0f75$export$ff7962acd6052c28)(path);
        });
        content.appendChild(blogTitle);
        // Summary
        var summary = document.createElement("p");
        summary.className = "blog-summary";
        summary.innerText = post.summary;
        content.appendChild(summary);
        // Tags
        var tagsContainer = document.createElement("div");
        tagsContainer.className = "blog-tags";
        post.tags.forEach((tag)=>{
            var tagSpan = document.createElement("span");
            tagSpan.className = "blog-tag";
            tagSpan.innerText = tag;
            tagsContainer.appendChild(tagSpan);
        });
        content.appendChild(tagsContainer);
        // Read Button
        var readBtn = document.createElement("button");
        readBtn.className = "blog-read-btn";
        readBtn.innerHTML = `<span class="blog-read-text"></span> \u{2794}`;
        (0, $313f6ce5359206e9$export$625550452a3fa3ec)(readBtn.querySelector(".blog-read-text"), "Read Article");
        readBtn.addEventListener("click", ()=>{
            var lang = (0, $bd5af8eefd2d0f75$export$dec8f99c0c14e178)();
            var prefix = (0, $bd5af8eefd2d0f75$export$3f9924f49378cb2)[lang];
            var path = prefix ? "/" + prefix + "/blog/" + post.slug : "/blog/" + post.slug;
            (0, $bd5af8eefd2d0f75$export$ff7962acd6052c28)(path);
        });
        content.appendChild(readBtn);
        wrapper.appendChild(content);
        listContainer.appendChild(wrapper);
    });
    contentBox.appendChild({
        element: listContainer
    });
    $8c398b5c754c4adc$var$box.appendChild(contentBox);
}
function $8c398b5c754c4adc$var$show() {
    $8c398b5c754c4adc$var$container.appendChild($8c398b5c754c4adc$var$box);
    setTimeout(()=>$8c398b5c754c4adc$var$box.element.classList.add("show"), 0);
}
function $8c398b5c754c4adc$var$hide() {
    if (!$8c398b5c754c4adc$var$box) return;
    $8c398b5c754c4adc$var$box.element.classList.remove("show");
    if ($8c398b5c754c4adc$var$container && $8c398b5c754c4adc$var$container.contains($8c398b5c754c4adc$var$box)) $8c398b5c754c4adc$var$container.removeChild($8c398b5c754c4adc$var$box);
}
var $8c398b5c754c4adc$var$blogScreen = {
    init: $8c398b5c754c4adc$var$init,
    show: $8c398b5c754c4adc$var$show,
    hide: $8c398b5c754c4adc$var$hide
};
var $8c398b5c754c4adc$export$2e2bcd8739ae039 = $8c398b5c754c4adc$var$blogScreen;







var $eab94a9650d2810a$var$container, $eab94a9650d2810a$var$box;
function $eab94a9650d2810a$var$init(_container, slug) {
    if (_container) $eab94a9650d2810a$var$container = _container;
    // Clear previous content if needed
    if ($eab94a9650d2810a$var$box && $eab94a9650d2810a$var$box.element) $eab94a9650d2810a$var$box.element.innerHTML = "";
    else {
        $eab94a9650d2810a$var$box = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("column");
        $eab94a9650d2810a$var$box.element.id = "blogPostScreen";
        $eab94a9650d2810a$var$box.element.className = "main-screen";
    }
    var post = (0, $5ac34e91e8ba2501$export$f47708b5cead80df)(slug);
    // Navbar
    var navbar = (0, $6a0f904a87ebf2c2$export$2e2bcd8739ae039)();
    $eab94a9650d2810a$var$box.appendChild(navbar);
    // Content Container
    var contentBox = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("column");
    contentBox.element.id = "blogPostContentBox";
    contentBox.alignItems = "center";
    // Breadcrumb Container
    var breadcrumbContainer = document.createElement("div");
    breadcrumbContainer.className = "breadcrumb-container";
    // Breadcrumb
    var breadcrumb = document.createElement("div");
    breadcrumb.className = "breadcrumb";
    breadcrumbContainer.appendChild(breadcrumb);
    // Home Link
    var homeLink = document.createElement("a");
    homeLink.className = "breadcrumb-link";
    homeLink.innerHTML = `<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> <span class="breadcrumb-home-text"></span>`;
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(homeLink.querySelector(".breadcrumb-home-text"), "Home");
    homeLink.addEventListener("click", ()=>{
        $eab94a9650d2810a$var$navigate("/");
    });
    breadcrumb.appendChild(homeLink);
    // Separator
    var separator = document.createElement("span");
    separator.className = "breadcrumb-separator";
    separator.innerHTML = `<svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>`;
    breadcrumb.appendChild(separator);
    // Blog Link
    var blogLink = document.createElement("a");
    blogLink.className = "breadcrumb-link";
    blogLink.innerText = "";
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(blogLink, "Blog");
    blogLink.addEventListener("click", ()=>{
        $eab94a9650d2810a$var$navigate("/blog");
    });
    breadcrumb.appendChild(blogLink);
    // Separator
    var separator2 = document.createElement("span");
    separator2.className = "breadcrumb-separator";
    separator2.innerHTML = `<svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>`;
    breadcrumb.appendChild(separator2);
    // Current Page
    var current = document.createElement("span");
    current.className = "breadcrumb-current";
    current.innerText = post ? post.title : "Not Found";
    breadcrumb.appendChild(current);
    contentBox.appendChild({
        element: breadcrumbContainer
    });
    if (post) {
        // Article Container
        var article = document.createElement("article");
        article.className = "blog-article";
        // Header
        var header = document.createElement("header");
        header.className = "blog-article-header";
        var title = document.createElement("h1");
        title.className = "blog-article-title";
        title.innerText = post.title;
        header.appendChild(title);
        var meta = document.createElement("div");
        meta.className = "blog-article-meta";
        meta.innerHTML = `
            <span>\u{1F4C5} ${post.date}</span>
            <span>\u{23F1} ${post.readTime} <span class="min-read-text"></span></span>
            <span style="color: ${post.color}; font-weight: 700;">${post.category}</span>
        `;
        (0, $313f6ce5359206e9$export$625550452a3fa3ec)(meta.querySelector(".min-read-text"), "min read");
        header.appendChild(meta);
        article.appendChild(header);
        // Content
        var body = document.createElement("div");
        body.innerHTML = post.content;
        article.appendChild(body);
        contentBox.appendChild({
            element: article
        });
    } else {
        // Not Found State
        var notFound = document.createElement("div");
        notFound.style.padding = "4rem";
        notFound.style.textAlign = "center";
        notFound.style.color = "#fff";
        notFound.innerText = "Post not found";
        contentBox.appendChild({
            element: notFound
        });
    }
    $eab94a9650d2810a$var$box.appendChild(contentBox);
}
function $eab94a9650d2810a$var$navigate(path) {
    var lang = (0, $bd5af8eefd2d0f75$export$dec8f99c0c14e178)();
    var prefix = (0, $bd5af8eefd2d0f75$export$3f9924f49378cb2)[lang];
    var fullPath = prefix ? "/" + prefix + path : path;
    if (path === "/") fullPath = prefix ? "/" + prefix : "/";
    (0, $bd5af8eefd2d0f75$export$ff7962acd6052c28)(fullPath);
}
function $eab94a9650d2810a$var$show() {
    $eab94a9650d2810a$var$container.appendChild($eab94a9650d2810a$var$box);
    setTimeout(()=>$eab94a9650d2810a$var$box.element.classList.add("show"), 0);
}
function $eab94a9650d2810a$var$hide() {
    if (!$eab94a9650d2810a$var$box) return;
    $eab94a9650d2810a$var$box.element.classList.remove("show");
    if ($eab94a9650d2810a$var$container && $eab94a9650d2810a$var$container.contains($eab94a9650d2810a$var$box)) $eab94a9650d2810a$var$container.removeChild($eab94a9650d2810a$var$box);
}
var $eab94a9650d2810a$var$blogPostScreen = {
    init: $eab94a9650d2810a$var$init,
    show: $eab94a9650d2810a$var$show,
    hide: $eab94a9650d2810a$var$hide
};
var $eab94a9650d2810a$export$2e2bcd8739ae039 = $eab94a9650d2810a$var$blogPostScreen;






var $3f388979afa814df$var$container, $3f388979afa814df$var$box;

function $3f388979afa814df$var$init(_container) {
    $3f388979afa814df$var$container = _container;
    $3f388979afa814df$var$box = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("column");
    $3f388979afa814df$var$box.element.id = "aboutScreen";
    $3f388979afa814df$var$box.element.className = "main-screen";
    // Navbar
    var navbar = (0, $6a0f904a87ebf2c2$export$2e2bcd8739ae039)();
    $3f388979afa814df$var$box.appendChild(navbar);
    // Content Container
    var contentBox = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("column");
    contentBox.element.id = "aboutContentBox";
    contentBox.alignItems = "center";
    // Breadcrumb Container
    var breadcrumbContainer = document.createElement("div");
    breadcrumbContainer.className = "breadcrumb-container";
    // Breadcrumb
    var breadcrumb = document.createElement("div");
    breadcrumb.className = "breadcrumb";
    breadcrumbContainer.appendChild(breadcrumb);
    // Home Link
    var homeLink = document.createElement("a");
    homeLink.className = "breadcrumb-link";
    homeLink.innerHTML = `<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> <span class="breadcrumb-home-text"></span>`;
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(homeLink.querySelector(".breadcrumb-home-text"), "Home");
    homeLink.addEventListener("click", ()=>{
        var lang = (0, $bd5af8eefd2d0f75$export$dec8f99c0c14e178)();
        var prefix = (0, $bd5af8eefd2d0f75$export$3f9924f49378cb2)[lang];
        var path = prefix ? "/" + prefix : "/";
        (0, $bd5af8eefd2d0f75$export$ff7962acd6052c28)(path);
    });
    breadcrumb.appendChild(homeLink);
    // Separator
    var separator = document.createElement("span");
    separator.className = "breadcrumb-separator";
    separator.innerHTML = `<svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>`;
    breadcrumb.appendChild(separator);
    // Current Page
    var current = document.createElement("span");
    current.className = "breadcrumb-current";
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(current, "About");
    breadcrumb.appendChild(current);
    contentBox.appendChild({
        element: breadcrumbContainer
    });
    // About Main Container
    var aboutContainer = document.createElement("div");
    aboutContainer.className = "about-page-container";
    // --- Header Section ---
    var header = document.createElement("div");
    header.className = "about-page-header";
    var icon = document.createElement("img");
    icon.src = new URL($12ba32b57ec48888$exports);
    icon.className = "about-page-icon";
    icon.alt = "Avatar Cropper Icon";
    header.appendChild(icon);
    var title = document.createElement("h1");
    title.className = "page-title";
    title.innerText = "Avatar Cropper";
    header.appendChild(title);
    var version = document.createElement("div");
    version.className = "about-page-version";
    version.innerText = "v1.2.5";
    header.appendChild(version);
    aboutContainer.appendChild(header);
    // --- Content Section ---
    var content = document.createElement("div");
    content.className = "about-page-content";
    var tagline = document.createElement("div");
    tagline.className = "about-tagline";
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(tagline, "Quickly Crop Avatar for Discord, X (Twitter), etc.");
    content.appendChild(tagline);
    var desc = document.createElement("div");
    desc.className = "about-desc";
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(desc, "Quick and accurate avatar cropper tool. Crop perfect avatar for Discord, X, etc. No signup required.");
    content.appendChild(desc);
    aboutContainer.appendChild(content);
    contentBox.appendChild({
        element: aboutContainer
    });
    $3f388979afa814df$var$box.appendChild(contentBox);
}
function $3f388979afa814df$var$show() {
    $3f388979afa814df$var$container.appendChild($3f388979afa814df$var$box);
}
function $3f388979afa814df$var$hide() {
    if ($3f388979afa814df$var$box && $3f388979afa814df$var$box.element.parentNode) $3f388979afa814df$var$box.element.parentNode.removeChild($3f388979afa814df$var$box.element);
}
var $3f388979afa814df$var$aboutScreen = {
    init: $3f388979afa814df$var$init,
    show: $3f388979afa814df$var$show,
    hide: $3f388979afa814df$var$hide
};
var $3f388979afa814df$export$2e2bcd8739ae039 = $3f388979afa814df$var$aboutScreen;






var $5815a1afe9c329ee$var$container, $5815a1afe9c329ee$var$box;
function $5815a1afe9c329ee$var$init(_container) {
    $5815a1afe9c329ee$var$container = _container;
    $5815a1afe9c329ee$var$box = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("column");
    $5815a1afe9c329ee$var$box.element.id = "privacyScreen";
    $5815a1afe9c329ee$var$box.element.className = "main-screen";
    // Navbar
    var navbar = (0, $6a0f904a87ebf2c2$export$2e2bcd8739ae039)();
    $5815a1afe9c329ee$var$box.appendChild(navbar);
    // Content Container
    var contentBox = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("column");
    contentBox.element.id = "privacyContentBox";
    contentBox.alignItems = "center";
    // Breadcrumb
    var breadcrumbContainer = document.createElement("div");
    breadcrumbContainer.className = "breadcrumb-container";
    var breadcrumb = document.createElement("div");
    breadcrumb.className = "breadcrumb";
    breadcrumbContainer.appendChild(breadcrumb);
    var homeLink = document.createElement("a");
    homeLink.className = "breadcrumb-link";
    homeLink.innerHTML = `<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> <span class="breadcrumb-home-text"></span>`;
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(homeLink.querySelector(".breadcrumb-home-text"), "Home");
    homeLink.addEventListener("click", ()=>{
        var lang = (0, $bd5af8eefd2d0f75$export$dec8f99c0c14e178)();
        var prefix = (0, $bd5af8eefd2d0f75$export$3f9924f49378cb2)[lang];
        (0, $bd5af8eefd2d0f75$export$ff7962acd6052c28)(prefix ? "/" + prefix : "/");
    });
    breadcrumb.appendChild(homeLink);
    var separator = document.createElement("span");
    separator.className = "breadcrumb-separator";
    separator.innerHTML = `<svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>`;
    breadcrumb.appendChild(separator);
    var current = document.createElement("span");
    current.className = "breadcrumb-current";
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(current, "Privacy");
    breadcrumb.appendChild(current);
    contentBox.appendChild(breadcrumbContainer);
    // Title
    var title = document.createElement("h1");
    title.className = "page-title";
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(title, "Privacy Policy");
    contentBox.appendChild(title);
    // Content card
    var card = document.createElement("div");
    card.className = "about-page-container";
    card.style.textAlign = "left";
    var updated = document.createElement("p");
    updated.className = "legal-updated";
    updated.innerText = "Last updated: August 7, 2026";
    card.appendChild(updated);
    card.insertAdjacentHTML("beforeend", `
        <div class="legal-content">
            <h2>1. Overview</h2>
            <p>Avatar Cropper ("we", "us", or "our") is a free, browser-based tool that lets you crop and edit avatars for social media. This Privacy Policy explains what information we handle, how we use it, and the choices you have. By using avatarcropper.app (the "Site"), you agree to the practices described below.</p>

            <h2>2. How the Tool Works (Local Processing)</h2>
            <p>The core Avatar Cropper experience runs entirely inside your own browser. When you open an image, all cropping, resizing, rotation, and export happen locally on your device using the Canvas API. <strong>Your images are never uploaded to our servers.</strong> We do not transmit, store, or have access to the photos you edit.</p>

            <h2>3. Information We Collect</h2>
            <p>Because image processing is performed on your device, we do not collect the content of the images you edit. We also do not require you to create an account or provide personal information to use the tool.</p>
            <p>Like most websites, we use standard server and analytics technologies that may collect limited, non-identifying information such as approximate location (country/region), device type, browser, language preference, and pages visited. This helps us understand usage and improve the Site.</p>

            <h2>4. Advertising (Google AdSense)</h2>
            <p>We use Google AdSense to display advertisements on the Site. Google AdSense is an advertising service provided by Google LLC ("Google").</p>
            <ul>
                <li>Third-party vendors, including Google, use cookies to serve ads based on a user's prior visits to this and other websites.</li>
                <li>Google's use of advertising cookies enables it and its partners to serve ads to you based on your visit to this Site and/or other sites on the Internet.</li>
                <li>You may opt out of personalized advertising by visiting the <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener">Google Ads Settings</a>, the <a href="https://optout.aboutads.info/" target="_blank" rel="noopener">YourAdChoices</a> page, or by visiting <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener">Google's Advertising Privacy & Terms</a>.</li>
            </ul>
            <p>Under the Google EU User Consent Policy and similar regional requirements, where required (for example in the EEA and UK), we request consent before storing or accessing cookies or other information on your device for advertising and measurement purposes. You can manage your choices at any time through the consent banner shown on the Site.</p>

            <h2>5. Cookies and Similar Technologies</h2>
            <p>Cookies are small text files stored on your device. We and our partners (such as Google) may use cookies to:</p>
            <ul>
                <li>Remember your language preference and improve your experience;</li>
                <li>Measure advertising performance and prevent fraud;</li>
                <li>Serve ads that are more relevant to you (only where permitted by your consent).</li>
            </ul>
            <p>You can control or delete cookies through your browser settings. Disabling certain cookies may affect Site functionality or ad personalization.</p>

            <h2>6. Children's Privacy</h2>
            <p>The Site is not directed to children under the age of 13 (or the equivalent minimum age in your jurisdiction). We do not knowingly collect personal information from children. If you believe a child has provided us with personal data, please contact us so we can remove it.</p>

            <h2>7. Data Security</h2>
            <p>Because your images are processed locally and are not uploaded, they are not exposed to our servers. We follow reasonable technical and organizational measures to protect the limited data we do handle.</p>

            <h2>8. Links to Third-Party Sites</h2>
            <p>The Site may contain links to third-party websites (for example, the social platforms you are cropping avatars for). This Privacy Policy does not apply to those sites, and we are not responsible for their practices.</p>

            <h2>9. Changes to This Policy</h2>
            <p>We may update this Privacy Policy from time to time. When we do, we will revise the "Last updated" date above. We encourage you to review this page periodically.</p>

            <h2>10. Contact Us</h2>
            <p>If you have any questions about this Privacy Policy or our data practices, you can reach us at <a href="mailto:support@avatarcropper.app">support@avatarcropper.app</a>.</p>

            <p class="legal-note">For more information about how Google uses data when you use our Site, visit <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener">How Google uses information from sites or apps that use our services</a>.</p>
        </div>
    `);
    contentBox.appendChild({
        element: card
    });
    $5815a1afe9c329ee$var$box.appendChild(contentBox);
}
function $5815a1afe9c329ee$var$show() {
    $5815a1afe9c329ee$var$container.appendChild($5815a1afe9c329ee$var$box);
    setTimeout(()=>$5815a1afe9c329ee$var$box.element.classList.add("show"), 0);
}
function $5815a1afe9c329ee$var$hide() {
    if (!$5815a1afe9c329ee$var$box) return;
    $5815a1afe9c329ee$var$box.element.classList.remove("show");
    if ($5815a1afe9c329ee$var$container && $5815a1afe9c329ee$var$container.contains($5815a1afe9c329ee$var$box)) $5815a1afe9c329ee$var$container.removeChild($5815a1afe9c329ee$var$box);
}
var $5815a1afe9c329ee$var$privacyScreen = {
    init: $5815a1afe9c329ee$var$init,
    show: $5815a1afe9c329ee$var$show,
    hide: $5815a1afe9c329ee$var$hide
};
var $5815a1afe9c329ee$export$2e2bcd8739ae039 = $5815a1afe9c329ee$var$privacyScreen;






var $1e0d62f138ff7c21$var$container, $1e0d62f138ff7c21$var$box;
function $1e0d62f138ff7c21$var$init(_container) {
    $1e0d62f138ff7c21$var$container = _container;
    $1e0d62f138ff7c21$var$box = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("column");
    $1e0d62f138ff7c21$var$box.element.id = "contactScreen";
    $1e0d62f138ff7c21$var$box.element.className = "main-screen";
    // Navbar
    var navbar = (0, $6a0f904a87ebf2c2$export$2e2bcd8739ae039)();
    $1e0d62f138ff7c21$var$box.appendChild(navbar);
    // Content Container
    var contentBox = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("column");
    contentBox.element.id = "contactContentBox";
    contentBox.alignItems = "center";
    // Breadcrumb
    var breadcrumbContainer = document.createElement("div");
    breadcrumbContainer.className = "breadcrumb-container";
    var breadcrumb = document.createElement("div");
    breadcrumb.className = "breadcrumb";
    breadcrumbContainer.appendChild(breadcrumb);
    var homeLink = document.createElement("a");
    homeLink.className = "breadcrumb-link";
    homeLink.innerHTML = `<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> <span class="breadcrumb-home-text"></span>`;
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(homeLink.querySelector(".breadcrumb-home-text"), "Home");
    homeLink.addEventListener("click", ()=>{
        var lang = (0, $bd5af8eefd2d0f75$export$dec8f99c0c14e178)();
        var prefix = (0, $bd5af8eefd2d0f75$export$3f9924f49378cb2)[lang];
        (0, $bd5af8eefd2d0f75$export$ff7962acd6052c28)(prefix ? "/" + prefix : "/");
    });
    breadcrumb.appendChild(homeLink);
    var separator = document.createElement("span");
    separator.className = "breadcrumb-separator";
    separator.innerHTML = `<svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>`;
    breadcrumb.appendChild(separator);
    var current = document.createElement("span");
    current.className = "breadcrumb-current";
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(current, "Contact");
    breadcrumb.appendChild(current);
    contentBox.appendChild(breadcrumbContainer);
    // Title
    var title = document.createElement("h1");
    title.className = "page-title";
    (0, $313f6ce5359206e9$export$625550452a3fa3ec)(title, "Contact Us");
    contentBox.appendChild(title);
    // Content card
    var card = document.createElement("div");
    card.className = "about-page-container about-page-content";
    card.style.textAlign = "center";
    card.insertAdjacentHTML("beforeend", `
        <p class="about-tagline">We'd love to hear from you.</p>
        <p class="about-desc">Whether you have a question about the tool, feedback, a partnership idea, or a privacy request, the fastest way to reach us is by email.</p>
        <div class="contact-method">
            <div class="contact-icon">\u{2709}\u{FE0F}</div>
            <div class="contact-label">Email</div>
            <a class="contact-value" href="mailto:support@avatarcropper.app">support@avatarcropper.app</a>
        </div>
        <p class="about-desc" style="margin-top:1.5rem;">We aim to respond to all inquiries within 2\u{2013}3 business days. For privacy-related requests, please mention "Privacy" in your subject line.</p>
    `);
    contentBox.appendChild({
        element: card
    });
    $1e0d62f138ff7c21$var$box.appendChild(contentBox);
}
function $1e0d62f138ff7c21$var$show() {
    $1e0d62f138ff7c21$var$container.appendChild($1e0d62f138ff7c21$var$box);
    setTimeout(()=>$1e0d62f138ff7c21$var$box.element.classList.add("show"), 0);
}
function $1e0d62f138ff7c21$var$hide() {
    if (!$1e0d62f138ff7c21$var$box) return;
    $1e0d62f138ff7c21$var$box.element.classList.remove("show");
    if ($1e0d62f138ff7c21$var$container && $1e0d62f138ff7c21$var$container.contains($1e0d62f138ff7c21$var$box)) $1e0d62f138ff7c21$var$container.removeChild($1e0d62f138ff7c21$var$box);
}
var $1e0d62f138ff7c21$var$contactScreen = {
    init: $1e0d62f138ff7c21$var$init,
    show: $1e0d62f138ff7c21$var$show,
    hide: $1e0d62f138ff7c21$var$hide
};
var $1e0d62f138ff7c21$export$2e2bcd8739ae039 = $1e0d62f138ff7c21$var$contactScreen;






var $e87b816374bfd5c0$var$container, $e87b816374bfd5c0$var$box;
var $e87b816374bfd5c0$var$subtitleElement, $e87b816374bfd5c0$var$descriptionElement, $e87b816374bfd5c0$var$homeButton;
function $e87b816374bfd5c0$var$init(_container) {
    $e87b816374bfd5c0$var$container = _container;
    $e87b816374bfd5c0$var$box = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("column");
    $e87b816374bfd5c0$var$box.element.id = "notFoundScreen";
    $e87b816374bfd5c0$var$box.justifyContent = "center";
    $e87b816374bfd5c0$var$box.alignItems = "center";
    $e87b816374bfd5c0$var$box.element.style.height = "100vh";
    $e87b816374bfd5c0$var$box.element.style.width = "100%";
    $e87b816374bfd5c0$var$box.element.style.display = "none";
    // Navbar
    var navbar = (0, $6a0f904a87ebf2c2$export$2e2bcd8739ae039)();
    $e87b816374bfd5c0$var$box.appendChild(navbar);
    var contentBox = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox("column");
    contentBox.alignItems = "center";
    contentBox.justifyContent = "center";
    contentBox.gap = "1.5rem";
    contentBox.element.style.flex = "1";
    contentBox.element.style.textAlign = "center";
    contentBox.element.style.padding = "1rem";
    var title = document.createElement("h1");
    title.innerText = "404";
    title.style.fontSize = "6rem";
    title.style.margin = "0";
    title.style.lineHeight = "1";
    title.style.color = "var(--primary-color)";
    contentBox.appendChild({
        element: title
    });
    $e87b816374bfd5c0$var$subtitleElement = document.createElement("h2");
    $e87b816374bfd5c0$var$subtitleElement.innerText = (0, $313f6ce5359206e9$export$71511d61b312f219)("Page Not Found");
    $e87b816374bfd5c0$var$subtitleElement.style.fontSize = "2rem";
    $e87b816374bfd5c0$var$subtitleElement.style.margin = "0";
    contentBox.appendChild({
        element: $e87b816374bfd5c0$var$subtitleElement
    });
    $e87b816374bfd5c0$var$descriptionElement = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Label((0, $313f6ce5359206e9$export$71511d61b312f219)("The page you are looking for does not exist."));
    $e87b816374bfd5c0$var$descriptionElement.element.style.fontSize = "1.2rem";
    $e87b816374bfd5c0$var$descriptionElement.element.style.opacity = "0.8";
    contentBox.appendChild($e87b816374bfd5c0$var$descriptionElement);
    $e87b816374bfd5c0$var$homeButton = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Button((0, $313f6ce5359206e9$export$71511d61b312f219)("Go Home"), "primary");
    $e87b816374bfd5c0$var$homeButton.addEventListener("click", function() {
        var lang = (0, $bd5af8eefd2d0f75$export$dec8f99c0c14e178)();
        var prefix = (0, $bd5af8eefd2d0f75$export$3f9924f49378cb2)[lang];
        var rootPath = prefix ? "/" + prefix : "/";
        history.pushState(null, "", rootPath);
        window.dispatchEvent(new Event('popstate'));
    });
    contentBox.appendChild($e87b816374bfd5c0$var$homeButton);
    $e87b816374bfd5c0$var$box.appendChild(contentBox);
    $e87b816374bfd5c0$var$container.appendChild($e87b816374bfd5c0$var$box);
}
function $e87b816374bfd5c0$var$show() {
    if ($e87b816374bfd5c0$var$box) {
        // Update translations
        if ($e87b816374bfd5c0$var$subtitleElement) $e87b816374bfd5c0$var$subtitleElement.innerText = (0, $313f6ce5359206e9$export$71511d61b312f219)("Page Not Found");
        if ($e87b816374bfd5c0$var$descriptionElement) $e87b816374bfd5c0$var$descriptionElement.element.innerText = (0, $313f6ce5359206e9$export$71511d61b312f219)("The page you are looking for does not exist.");
        if ($e87b816374bfd5c0$var$homeButton) $e87b816374bfd5c0$var$homeButton.element.innerText = (0, $313f6ce5359206e9$export$71511d61b312f219)("Go Home");
        $e87b816374bfd5c0$var$box.element.style.display = "flex";
        // Add noindex tag
        var meta = document.querySelector("meta[name='robots']");
        if (!meta) {
            meta = document.createElement("meta");
            meta.name = "robots";
            document.head.appendChild(meta);
        }
        meta.content = "noindex";
        document.title = "404 - " + (0, $313f6ce5359206e9$export$71511d61b312f219)("Page Not Found");
    }
}
function $e87b816374bfd5c0$var$hide() {
    if ($e87b816374bfd5c0$var$box) {
        $e87b816374bfd5c0$var$box.element.style.display = "none";
        // Reset robots tag to allow indexing
        var meta = document.querySelector("meta[name='robots']");
        if (meta) meta.content = "index, follow";
    }
}
var $e87b816374bfd5c0$export$2e2bcd8739ae039 = {
    init: $e87b816374bfd5c0$var$init,
    show: $e87b816374bfd5c0$var$show,
    hide: $e87b816374bfd5c0$var$hide
};





function $c96730ec68fc0f7f$var$dispatchImageDrop(detail, element) {
    var idEvent = new CustomEvent("imagedrop", {
        detail: detail
    });
    element.dispatchEvent(idEvent);
}
function $c96730ec68fc0f7f$var$dispatchFile(file, element) {
    if (file.type.startsWith("image/")) {
        $c96730ec68fc0f7f$var$dispatchImageDrop(file, element);
        return true;
    }
    return false;
}
var $c96730ec68fc0f7f$var$lolMessages = [
    "Hey, you should drop your file into the window.",
    "Just drop it...",
    "I'm getting rather impatient.",
    "What are you doing!?",
    "Drop it now!",
    "Stop teasing me!",
    "I beg you!",
    "Please, just give me your file!!!"
];
function $c96730ec68fc0f7f$var$DndHandler(container, element) {
    this.element = element;
    var overlay = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Flexbox;
    overlay.element.id = "dndOverlay";
    var lol = 0;
    var counter = 0;
    element.addEventListener("dragenter", function() {
        if (counter == 0) {
            container.appendChild(overlay);
            if (++lol >= 10) {
                var msg = $c96730ec68fc0f7f$var$lolMessages[Math.min(lol - 10, $c96730ec68fc0f7f$var$lolMessages.length - 1)];
                (0, $cff5b25a521f554e$export$2e2bcd8739ae039).show(msg);
            }
        }
        ++counter;
    });
    element.addEventListener("dragleave", function() {
        if (--counter == 0) container.removeChild(overlay);
    });
    element.addEventListener("drop", function(e) {
        e.preventDefault();
        if (lol >= 10 + $c96730ec68fc0f7f$var$lolMessages.length - 1) (0, $cff5b25a521f554e$export$2e2bcd8739ae039).show("Thank you.");
        lol = 0;
        container.removeChild(overlay);
        counter = 0;
        var value = e.dataTransfer.getData("text/pain");
        if (value) {
            $c96730ec68fc0f7f$var$dispatchImageDrop(value, element);
            return;
        }
        if (e.dataTransfer.items) for (const item of e.dataTransfer.items){
            if (item.kind != "file") continue;
            const file = item.getAsFile();
            if ($c96730ec68fc0f7f$var$dispatchFile(file, element)) return;
        }
        else for (const file of e.dataTransfer.files){
            if ($c96730ec68fc0f7f$var$dispatchFile(file, element)) return;
        }
        (0, $cff5b25a521f554e$export$2e2bcd8739ae039).show((0, $313f6ce5359206e9$export$71511d61b312f219)("Invalid image file."));
    });
    element.addEventListener("dragover", function(e) {
        e.preventDefault();
    });
}
$c96730ec68fc0f7f$var$DndHandler.prototype.addListener = function(listener) {
    this.element.addEventListener("imagedrop", listener);
};
var $c96730ec68fc0f7f$export$2e2bcd8739ae039 = $c96730ec68fc0f7f$var$DndHandler;








// Lightweight cookie/consent banner for GDPR / Google EU User Consent Policy.
// Stores the visitor's choice in localStorage. For full EEA/UK compliance with
// personalized advertising, also enable AdSense's built-in "Privacy & Messaging"
// in the AdSense dashboard — this banner is the site's own first-party notice.
const $c867d053c82b6c8f$var$STORAGE_KEY = "ac-cookie-consent";
function $c867d053c82b6c8f$var$getChoice() {
    try {
        return localStorage.getItem($c867d053c82b6c8f$var$STORAGE_KEY);
    } catch (e) {
        return null;
    }
}
function $c867d053c82b6c8f$var$setChoice(value) {
    try {
        localStorage.setItem($c867d053c82b6c8f$var$STORAGE_KEY, value);
    } catch (e) {
    // ignore (private mode etc.)
    }
}
function $c867d053c82b6c8f$export$870e4a296b65a3ae() {
    if ($c867d053c82b6c8f$var$getChoice() !== null) return;
    var banner = document.createElement("div");
    banner.className = "consent-banner";
    banner.setAttribute("role", "dialog");
    banner.setAttribute("aria-label", "Cookie consent");
    var text = document.createElement("p");
    text.innerHTML = `We use cookies to operate this site, remember your preferences, and serve personalized ads via Google AdSense. See our <a href="/privacy">Privacy Policy</a> for details.`;
    banner.appendChild(text);
    var actions = document.createElement("div");
    actions.className = "consent-actions";
    var reject = document.createElement("button");
    reject.className = "consent-btn consent-btn-reject";
    reject.textContent = "Reject";
    reject.addEventListener("click", function() {
        $c867d053c82b6c8f$var$setChoice("rejected");
        $c867d053c82b6c8f$var$dismiss(banner);
    });
    var accept = document.createElement("button");
    accept.className = "consent-btn consent-btn-accept";
    accept.textContent = "Accept";
    accept.addEventListener("click", function() {
        $c867d053c82b6c8f$var$setChoice("accepted");
        $c867d053c82b6c8f$var$dismiss(banner);
    });
    actions.appendChild(reject);
    actions.appendChild(accept);
    banner.appendChild(actions);
    document.body.appendChild(banner);
    // Auto-dismiss after 30s if the user ignores it (still no explicit choice).
    setTimeout(function() {
        if ($c867d053c82b6c8f$var$getChoice() === null && document.body.contains(banner)) $c867d053c82b6c8f$var$dismiss(banner);
    }, 30000);
}
function $c867d053c82b6c8f$var$dismiss(banner) {
    if (!banner || !banner.parentNode) return;
    banner.parentNode.removeChild(banner);
}
var $c867d053c82b6c8f$export$2e2bcd8739ae039 = {
    initConsentBanner: $c867d053c82b6c8f$export$870e4a296b65a3ae
};


var $395c8e16a1683c01$exports = {};
$395c8e16a1683c01$exports = $parcel$resolve("fSHUt");


function $bd5af8eefd2d0f75$var$registerServiceWorker() {
    if ("serviceWorker" in navigator && true) navigator.serviceWorker.register($395c8e16a1683c01$exports);
}
const $bd5af8eefd2d0f75$export$3f9924f49378cb2 = {
    "en-us": "",
    "fr-fr": "fr",
    "de-de": "de",
    "ru-ru": "ru",
    "pt-br": "pt",
    "nl-nl": "nl",
    "id-id": "id",
    "ja-jp": "ja",
    "ko-kr": "ko",
    "vi-vn": "vn",
    "zh-cn": "zh",
    "zh-tw": "zh-tw"
};
function $bd5af8eefd2d0f75$export$dec8f99c0c14e178() {
    // Priority 1: URL Path
    var path = window.location.pathname;
    // Remove trailing slash for consistency
    if (path.endsWith("/")) path = path.slice(0, -1);
    var segments = path.split("/");
    var firstSegment = segments[1]; // path starts with /
    for (const [lang, prefix] of Object.entries($bd5af8eefd2d0f75$export$3f9924f49378cb2)){
        if (prefix === "") continue; // Skip default
        if (firstSegment === prefix) return lang;
    }
    // Priority 2: LocalStorage (only if at root or default path)
    if (!firstSegment) {
        var saved = localStorage.getItem("lang");
        if (saved && $bd5af8eefd2d0f75$export$3f9924f49378cb2[saved] !== undefined) return saved;
    }
    return "en-us";
}
function $bd5af8eefd2d0f75$export$d75f91200e8ff7e0() {
    var path = window.location.pathname;
    if (path.endsWith("/")) path = path.slice(0, -1);
    var segments = path.split("/");
    var firstSegment = segments[1];
    for (const prefix of Object.values($bd5af8eefd2d0f75$export$3f9924f49378cb2))if (prefix && firstSegment === prefix) {
        var newPath = path.substring(prefix.length + 1);
        if (newPath === "") return "/";
        return newPath;
    }
    if (path === "") return "/";
    return path;
}
function $bd5af8eefd2d0f75$var$updateCanonical(lang, route) {
    var link = document.querySelector("link[rel='canonical']");
    if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
    }
    // Base URL
    var url = "https://avatarcropper.app/";
    var prefix = $bd5af8eefd2d0f75$export$3f9924f49378cb2[lang];
    if (prefix) {
        url += prefix;
        // Set generic language code for html tag
        var shortLang = lang.split("-")[0];
        if (lang === "zh-cn") shortLang = "zh-Hans";
        if (lang === "zh-tw") shortLang = "zh-Hant";
        document.documentElement.lang = shortLang;
    } else document.documentElement.lang = "en";
    // Append route if not root
    if (route && route !== "/") {
        // Ensure route starts with /
        if (!route.startsWith("/")) route = "/" + route;
        // If url ends with /, remove it before appending route to avoid //
        if (url.endsWith("/")) url = url.slice(0, -1);
        url += route;
    }
    link.href = url;
}
function $bd5af8eefd2d0f75$var$updateSEOTags(lang, route) {
    var titleKey, descKey;
    if (route === "/changelog") {
        titleKey = "Changelog - Avatar Cropper";
        descKey = "See what's new in Avatar Cropper. Latest updates, features, and bug fixes.";
    } else if (route === "/blog") {
        titleKey = "Blog";
        descKey = "Learn how to use Avatar Cropper to create perfect avatars for your social media profiles.";
    } else if (route && route.startsWith("/blog/")) {
        // Dynamic blog post SEO
        var slug = route.replace("/blog/", "");
        var post = (0, $5ac34e91e8ba2501$export$f47708b5cead80df)(slug);
        if (post) {
            titleKey = post.title;
            descKey = post.summary;
        } else {
            titleKey = "Post Not Found - Avatar Cropper";
            descKey = "The requested blog post could not be found.";
        }
    } else if (route === "/about") {
        titleKey = "About - Avatar Cropper";
        descKey = "Learn more about Avatar Cropper, a free online tool to crop avatars for social media.";
    } else if (route === "/privacy") {
        titleKey = "Privacy Policy - Avatar Cropper";
        descKey = "How Avatar Cropper handles your data, local image processing, and advertising cookies (Google AdSense).";
    } else if (route === "/contact") {
        titleKey = "Contact Us - Avatar Cropper";
        descKey = "Get in touch with the Avatar Cropper team by email for questions, feedback, or privacy requests.";
    } else {
        // Home or Editor
        titleKey = "Avatar Cropper - Quickly Crop Avatar for Discord, X, etc.";
        descKey = "Quick and accurate avatar cropper tool. Crop perfect avatar for Discord, X (Twitter), etc. No signup required.";
    }
    // Use translations if available, otherwise fallback to English key or raw string (for dynamic content)
    var title = (0, $313f6ce5359206e9$export$71511d61b312f219)(titleKey) === titleKey ? titleKey : (0, $313f6ce5359206e9$export$71511d61b312f219)(titleKey);
    var desc = (0, $313f6ce5359206e9$export$71511d61b312f219)(descKey) === descKey ? descKey : (0, $313f6ce5359206e9$export$71511d61b312f219)(descKey);
    document.title = title;
    // Meta Description
    var metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) metaDesc.content = desc;
    else {
        metaDesc = document.createElement("meta");
        metaDesc.name = "description";
        metaDesc.content = desc;
        document.head.appendChild(metaDesc);
    }
    // OG Tags
    var ogTitle = document.querySelector("meta[property='og:title']");
    if (ogTitle) ogTitle.content = title;
    var ogDesc = document.querySelector("meta[property='og:description']");
    if (ogDesc) ogDesc.content = desc;
    var ogUrl = document.querySelector("meta[property='og:url']");
    if (ogUrl) {
        var currentUrl = document.querySelector("link[rel='canonical']").href;
        ogUrl.content = currentUrl;
    }
    // Twitter Tags
    var twitterTitle = document.querySelector("meta[name='twitter:title']");
    if (twitterTitle) twitterTitle.content = title;
    var twitterDesc = document.querySelector("meta[name='twitter:description']");
    if (twitterDesc) twitterDesc.content = desc;
    // Update Canonical and Lang attribute
    $bd5af8eefd2d0f75$var$updateCanonical(lang, route);
}
function $bd5af8eefd2d0f75$export$7b1c7456353579f9() {
    var path = $bd5af8eefd2d0f75$export$d75f91200e8ff7e0();
    var lang = $bd5af8eefd2d0f75$export$dec8f99c0c14e178();
    // Update SEO tags based on current route and language
    $bd5af8eefd2d0f75$var$updateSEOTags(lang, path);
    if (path === "/avatar-cropper-editor") {
        if ((0, $0544d5bc706c7688$export$2e2bcd8739ae039).hasImage()) {
            (0, $fac49d8f1486f244$export$2e2bcd8739ae039).hide();
            (0, $200cdb1bd3341216$export$2e2bcd8739ae039).hide();
            (0, $8c398b5c754c4adc$export$2e2bcd8739ae039).hide();
            (0, $eab94a9650d2810a$export$2e2bcd8739ae039).hide();
            (0, $3f388979afa814df$export$2e2bcd8739ae039).hide();
            (0, $5815a1afe9c329ee$export$2e2bcd8739ae039).hide();
            (0, $1e0d62f138ff7c21$export$2e2bcd8739ae039).hide();
            (0, $e87b816374bfd5c0$export$2e2bcd8739ae039).hide();
            (0, $0544d5bc706c7688$export$2e2bcd8739ae039).show();
        } else {
            // Redirect to home if no image
            var prefix = $bd5af8eefd2d0f75$export$3f9924f49378cb2[lang];
            var rootPath = prefix ? "/" + prefix : "/";
            history.replaceState(null, "", rootPath);
            (0, $0544d5bc706c7688$export$2e2bcd8739ae039).hide();
            (0, $200cdb1bd3341216$export$2e2bcd8739ae039).hide();
            (0, $8c398b5c754c4adc$export$2e2bcd8739ae039).hide();
            (0, $eab94a9650d2810a$export$2e2bcd8739ae039).hide();
            (0, $3f388979afa814df$export$2e2bcd8739ae039).hide();
            (0, $5815a1afe9c329ee$export$2e2bcd8739ae039).hide();
            (0, $1e0d62f138ff7c21$export$2e2bcd8739ae039).hide();
            (0, $e87b816374bfd5c0$export$2e2bcd8739ae039).hide();
            (0, $fac49d8f1486f244$export$2e2bcd8739ae039).show();
        }
    } else if (path === "/changelog") {
        (0, $fac49d8f1486f244$export$2e2bcd8739ae039).hide();
        (0, $0544d5bc706c7688$export$2e2bcd8739ae039).hide();
        (0, $3f388979afa814df$export$2e2bcd8739ae039).hide();
        (0, $8c398b5c754c4adc$export$2e2bcd8739ae039).hide();
        (0, $eab94a9650d2810a$export$2e2bcd8739ae039).hide();
        (0, $5815a1afe9c329ee$export$2e2bcd8739ae039).hide();
        (0, $1e0d62f138ff7c21$export$2e2bcd8739ae039).hide();
        (0, $e87b816374bfd5c0$export$2e2bcd8739ae039).hide();
        (0, $200cdb1bd3341216$export$2e2bcd8739ae039).show();
    } else if (path === "/blog") {
        (0, $fac49d8f1486f244$export$2e2bcd8739ae039).hide();
        (0, $0544d5bc706c7688$export$2e2bcd8739ae039).hide();
        (0, $3f388979afa814df$export$2e2bcd8739ae039).hide();
        (0, $200cdb1bd3341216$export$2e2bcd8739ae039).hide();
        (0, $eab94a9650d2810a$export$2e2bcd8739ae039).hide();
        (0, $5815a1afe9c329ee$export$2e2bcd8739ae039).hide();
        (0, $1e0d62f138ff7c21$export$2e2bcd8739ae039).hide();
        (0, $e87b816374bfd5c0$export$2e2bcd8739ae039).hide();
        (0, $8c398b5c754c4adc$export$2e2bcd8739ae039).show();
    } else if (path && path.startsWith("/blog/")) {
        (0, $fac49d8f1486f244$export$2e2bcd8739ae039).hide();
        (0, $0544d5bc706c7688$export$2e2bcd8739ae039).hide();
        (0, $3f388979afa814df$export$2e2bcd8739ae039).hide();
        (0, $200cdb1bd3341216$export$2e2bcd8739ae039).hide();
        (0, $8c398b5c754c4adc$export$2e2bcd8739ae039).hide();
        (0, $5815a1afe9c329ee$export$2e2bcd8739ae039).hide();
        (0, $1e0d62f138ff7c21$export$2e2bcd8739ae039).hide();
        (0, $e87b816374bfd5c0$export$2e2bcd8739ae039).hide();
        var slug = path.replace("/blog/", "");
        (0, $eab94a9650d2810a$export$2e2bcd8739ae039).init(null, slug); // Pass slug to init
        (0, $eab94a9650d2810a$export$2e2bcd8739ae039).show();
    } else if (path === "/about") {
        (0, $fac49d8f1486f244$export$2e2bcd8739ae039).hide();
        (0, $0544d5bc706c7688$export$2e2bcd8739ae039).hide();
        (0, $200cdb1bd3341216$export$2e2bcd8739ae039).hide();
        (0, $8c398b5c754c4adc$export$2e2bcd8739ae039).hide();
        (0, $eab94a9650d2810a$export$2e2bcd8739ae039).hide();
        (0, $5815a1afe9c329ee$export$2e2bcd8739ae039).hide();
        (0, $1e0d62f138ff7c21$export$2e2bcd8739ae039).hide();
        (0, $e87b816374bfd5c0$export$2e2bcd8739ae039).hide();
        (0, $3f388979afa814df$export$2e2bcd8739ae039).show();
    } else if (path === "/privacy") {
        (0, $fac49d8f1486f244$export$2e2bcd8739ae039).hide();
        (0, $0544d5bc706c7688$export$2e2bcd8739ae039).hide();
        (0, $200cdb1bd3341216$export$2e2bcd8739ae039).hide();
        (0, $8c398b5c754c4adc$export$2e2bcd8739ae039).hide();
        (0, $eab94a9650d2810a$export$2e2bcd8739ae039).hide();
        (0, $3f388979afa814df$export$2e2bcd8739ae039).hide();
        (0, $1e0d62f138ff7c21$export$2e2bcd8739ae039).hide();
        (0, $e87b816374bfd5c0$export$2e2bcd8739ae039).hide();
        (0, $5815a1afe9c329ee$export$2e2bcd8739ae039).show();
    } else if (path === "/contact") {
        (0, $fac49d8f1486f244$export$2e2bcd8739ae039).hide();
        (0, $0544d5bc706c7688$export$2e2bcd8739ae039).hide();
        (0, $200cdb1bd3341216$export$2e2bcd8739ae039).hide();
        (0, $8c398b5c754c4adc$export$2e2bcd8739ae039).hide();
        (0, $eab94a9650d2810a$export$2e2bcd8739ae039).hide();
        (0, $3f388979afa814df$export$2e2bcd8739ae039).hide();
        (0, $5815a1afe9c329ee$export$2e2bcd8739ae039).hide();
        (0, $e87b816374bfd5c0$export$2e2bcd8739ae039).hide();
        (0, $1e0d62f138ff7c21$export$2e2bcd8739ae039).show();
    } else if (path === "/") {
        (0, $0544d5bc706c7688$export$2e2bcd8739ae039).hide();
        (0, $200cdb1bd3341216$export$2e2bcd8739ae039).hide();
        (0, $8c398b5c754c4adc$export$2e2bcd8739ae039).hide();
        (0, $eab94a9650d2810a$export$2e2bcd8739ae039).hide();
        (0, $3f388979afa814df$export$2e2bcd8739ae039).hide();
        (0, $5815a1afe9c329ee$export$2e2bcd8739ae039).hide();
        (0, $1e0d62f138ff7c21$export$2e2bcd8739ae039).hide();
        (0, $e87b816374bfd5c0$export$2e2bcd8739ae039).hide();
        (0, $fac49d8f1486f244$export$2e2bcd8739ae039).show();
    } else {
        (0, $0544d5bc706c7688$export$2e2bcd8739ae039).hide();
        (0, $200cdb1bd3341216$export$2e2bcd8739ae039).hide();
        (0, $8c398b5c754c4adc$export$2e2bcd8739ae039).hide();
        (0, $eab94a9650d2810a$export$2e2bcd8739ae039).hide();
        (0, $3f388979afa814df$export$2e2bcd8739ae039).hide();
        (0, $5815a1afe9c329ee$export$2e2bcd8739ae039).hide();
        (0, $1e0d62f138ff7c21$export$2e2bcd8739ae039).hide();
        (0, $fac49d8f1486f244$export$2e2bcd8739ae039).hide();
        (0, $e87b816374bfd5c0$export$2e2bcd8739ae039).show();
    }
}
async function $bd5af8eefd2d0f75$var$bootstrap() {
    $bd5af8eefd2d0f75$var$registerServiceWorker();
    document.body.innerHTML = "";
    (0, $c867d053c82b6c8f$export$870e4a296b65a3ae)();
    var lang = $bd5af8eefd2d0f75$export$dec8f99c0c14e178();
    var container = new (0, $21104bc65c54f4d6$export$2e2bcd8739ae039).Container;
    container.element.style.backgroundColor = "#1e1e1e";
    container.createShadow();
    (0, $cff5b25a521f554e$export$2e2bcd8739ae039).init(container);
    try {
        await (0, $313f6ce5359206e9$export$2e2bcd8739ae039).init();
        try {
            await (0, $313f6ce5359206e9$export$2e2bcd8739ae039).loadLanguage(lang);
            localStorage.setItem("lang", lang);
        } catch (e) {
            (0, $cff5b25a521f554e$export$2e2bcd8739ae039).show("Failed to load translations for " + lang);
        }
    } catch (e) {
        (0, $cff5b25a521f554e$export$2e2bcd8739ae039).show("Failed to initialize i18n.");
    }
    (0, $0544d5bc706c7688$export$2e2bcd8739ae039).init(container);
    (0, $200cdb1bd3341216$export$2e2bcd8739ae039).init(container);
    (0, $8c398b5c754c4adc$export$2e2bcd8739ae039).init(container);
    (0, $eab94a9650d2810a$export$2e2bcd8739ae039).init(container); // Initial init (container only)
    (0, $3f388979afa814df$export$2e2bcd8739ae039).init(container);
    (0, $5815a1afe9c329ee$export$2e2bcd8739ae039).init(container);
    (0, $1e0d62f138ff7c21$export$2e2bcd8739ae039).init(container);
    (0, $e87b816374bfd5c0$export$2e2bcd8739ae039).init(container);
    (0, $4244c5b4a8c0a9c7$export$2e2bcd8739ae039).init(container);
    (0, $4244c5b4a8c0a9c7$export$2e2bcd8739ae039).setProgress(-1);
    (0, $4244c5b4a8c0a9c7$export$2e2bcd8739ae039).show();
    (0, $fac49d8f1486f244$export$2e2bcd8739ae039).init(container, function() {
        $bd5af8eefd2d0f75$export$7b1c7456353579f9();
        (0, $4244c5b4a8c0a9c7$export$2e2bcd8739ae039).hide();
    });
    window.addEventListener("popstate", function() {
        $bd5af8eefd2d0f75$export$7b1c7456353579f9();
    });
    var dnd = new (0, $c96730ec68fc0f7f$export$2e2bcd8739ae039)(container, document.body);
    dnd.addListener((e)=>{
        (0, $0544d5bc706c7688$export$2e2bcd8739ae039).open(e.detail, function() {
            var lang = $bd5af8eefd2d0f75$export$dec8f99c0c14e178();
            var prefix = $bd5af8eefd2d0f75$export$3f9924f49378cb2[lang];
            var path = "/avatar-cropper-editor";
            if (prefix) path = "/" + prefix + path;
            history.pushState(null, "", path);
            $bd5af8eefd2d0f75$export$7b1c7456353579f9();
        });
    });
    if ("ontouchmove" in document) {
        document.addEventListener("touchmove", (0, $81b042702cd50b64$export$b9d4e1086abc9c4d), {
            passive: true
        });
        document.addEventListener("touchend", (0, $81b042702cd50b64$export$b9d4e1086abc9c4d), {
            passive: true
        });
    }
    window.scrollTo(0, 1);
}
// One-time app bootstrap. Called exactly once at startup. Navigation and
// language switches must NOT call this again — use navigate()/switchLanguage()
// which update the UI in place instead of tearing down the whole DOM (which
// would also discard any image the user is editing).
$bd5af8eefd2d0f75$var$bootstrap();
function $bd5af8eefd2d0f75$export$ff7962acd6052c28(path) {
    history.pushState(null, "", path);
    $bd5af8eefd2d0f75$export$7b1c7456353579f9();
}
async function $bd5af8eefd2d0f75$export$fa43c961ec463ef0(lang) {
    localStorage.setItem("lang", lang);
    var cleanPath = $bd5af8eefd2d0f75$export$d75f91200e8ff7e0();
    var newPrefix = $bd5af8eefd2d0f75$export$3f9924f49378cb2[lang];
    var newPath = cleanPath;
    if (newPrefix) {
        if (cleanPath === "/") newPath = "/" + newPrefix;
        else newPath = "/" + newPrefix + cleanPath;
    }
    history.pushState(null, "", newPath);
    try {
        await (0, $313f6ce5359206e9$export$2e2bcd8739ae039).loadLanguage(lang);
    } catch (e) {
    // keep current strings if the fetch fails
    }
    // Re-translate every registered UI element in place (no rebuild).
    (0, $313f6ce5359206e9$export$282dadb5b59543dc)();
    // Update SEO signals + show the correct screen for the new URL/language.
    $bd5af8eefd2d0f75$export$7b1c7456353579f9();
}
var $bd5af8eefd2d0f75$export$2e2bcd8739ae039 = $bd5af8eefd2d0f75$var$bootstrap;


//# sourceMappingURL=repo.4906b5b9.js.map
